var _path, _path2, _path3, _path4, _path5, _path6, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.81,
    y: 74.02,
    width: 85.32,
    height: 354.07,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.13,
    y: 75.09,
    width: 74.6,
    height: 354.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,84.71c0,.15-13.46.27-30.07.27s-30.07-.12-30.07-.27,13.46-.26,30.07-.26S461,84.57,461,84.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,93.31c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,93.16,461,93.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,101.9c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,101.75,461,101.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,110.49c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,110.34,461,110.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,119.08c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,118.93,461,119.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,127.67c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,127.53,461,127.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,136.26c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,136.12,461,136.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,144.85c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,144.71,461,144.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,153.44c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,153.3,461,153.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,162c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,161.89,461,162Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,170.62c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,170.48,461,170.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,179.21c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,179.07,461,179.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,187.8c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,187.66,461,187.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,196.4c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S461,196.25,461,196.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,205c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,204.84,461,205Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,213.58c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,213.43,461,213.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,222.17c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,222,461,222.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,230.76c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,230.61,461,230.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,239.35c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,239.21,461,239.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,247.94c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,247.8,461,247.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,256.53c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,256.39,461,256.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,265.12c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,265,461,265.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,273.71c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,273.57,461,273.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,282.3c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,282.16,461,282.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,290.89c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,290.75,461,290.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,299.48c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,299.34,461,299.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,308.08c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S461,307.93,461,308.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,316.67c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,316.52,461,316.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,325.26c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,325.11,461,325.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,333.85c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,333.7,461,333.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,342.44c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,342.29,461,342.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,351c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,350.89,461,351Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,359.62c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,359.48,461,359.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,368.21c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S461,368.07,461,368.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,376.8c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,376.66,461,376.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,385.39c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,385.25,461,385.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,394c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,393.84,461,394Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,402.57c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,402.43,461,402.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,411.16c0,.15-13.46.26-30.07.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S461,411,461,411.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,419.76c0,.14-13.46.26-30.07.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S461,419.61,461,419.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.51 97.43 569.51 153 497.73 153 495.14 97.81 569.51 97.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.41,
    y: 89.48,
    width: 55.26,
    height: 71.78,
    transform: "translate(405.66 656.41) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.2,153.28H494.87V97.47H567.2Zm-71.78-.55h71.23V98H495.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.92,
    y: 103.43,
    width: 56.24,
    height: 42.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.15,103.43h-1.06l-3.06,0-11.54,0-40.57.07.13-.13c0,12.69,0,27.09,0,42.3h0l-.14-.14,56.23,0-.11.12c0-12.78,0-23.34.06-30.72,0-3.69,0-6.58,0-8.55,0-1,0-1.74,0-2.25s0-.78,0-.78,0,.25,0,.75,0,1.26,0,2.23c0,2,0,4.85,0,8.53,0,7.39,0,18,.06,30.79v.12h-.12l-56.23,0h-.15v-.14h0c0-15.21,0-29.61,0-42.3v-.13h.13l40.66.06,11.5,0h4.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.14,97.62a6.39,6.39,0,0,1,1.22.75c.73.49,1.72,1.18,2.8,2s2,1.55,2.71,2.11a7.54,7.54,0,0,1,1.05,1,7.89,7.89,0,0,1-1.18-.81l-2.75-2-2.75-2A7.3,7.3,0,0,1,495.14,97.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93,97.75a43.75,43.75,0,0,1-3.81,3,40.49,40.49,0,0,1-4,2.73,40.55,40.55,0,0,1,3.81-3A37.34,37.34,0,0,1,566.93,97.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.93,
    y1: 153,
    x2: 558.87,
    y2: 145.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.87,145.73a50.84,50.84,0,0,1,4.12,3.53c2.23,2,4,3.69,3.94,3.74a49.9,49.9,0,0,1-4.13-3.53A51.1,51.1,0,0,1,558.87,145.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.14,153a51,51,0,0,1,3.75-3.58,48.64,48.64,0,0,1,3.95-3.36,48.6,48.6,0,0,1-3.75,3.58A46.72,46.72,0,0,1,495.14,153Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.96,
    cy: 122.78,
    r: 6.79,
    transform: "translate(283.03 612.16) rotate(-75.34)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.76,129.23a10.62,10.62,0,0,1,.59-1.88,11.33,11.33,0,0,0,.62-4.56,6.35,6.35,0,0,0-2-4,12.25,12.25,0,0,0-1.61-1.05,3,3,0,0,1,1.85.76,6.2,6.2,0,0,1,2.27,4.23,9.92,9.92,0,0,1-.79,4.75A5.43,5.43,0,0,1,535.76,129.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.52,122a11.16,11.16,0,0,0-3.95.14,10.75,10.75,0,0,0-3.39,2s.15-.47.69-1a6,6,0,0,1,5.52-1.62C544.13,121.65,544.54,121.9,544.52,122Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.45,121.62c-.08,0,0-.48-.29-1.15a3,3,0,0,0-4.41-1.71c-.63.32-.92.69-1,.64s.13-.51.79-1a3.19,3.19,0,0,1,5,1.93C541.69,121.15,541.51,121.63,541.45,121.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.29,122.33c-.15,0,0-1-.31-2s-.77-1.87-.65-2,.87.62,1.16,1.84S539.42,122.38,539.29,122.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.23,120.21c0,.15-.59.18-1.15.48s-1,.69-1.15.58.19-.65.9-1S539.26,120.08,539.23,120.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.37,123.39a5.15,5.15,0,1,1-7.26.63A5.14,5.14,0,0,1,528.37,123.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.58,131.1a8.4,8.4,0,0,1-1-1.06,8.44,8.44,0,0,0-2.83-2,4.8,4.8,0,0,0-3.39-.1,10.44,10.44,0,0,0-1.28.7,2.29,2.29,0,0,1,1.17-1,4.66,4.66,0,0,1,3.65,0,7.54,7.54,0,0,1,2.89,2.22A4.31,4.31,0,0,1,528.58,131.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.84,122.65a8.4,8.4,0,0,0-1.31,2.69,8.3,8.3,0,0,0,.14,3s-.26-.27-.43-.82a4.53,4.53,0,0,1-.11-2.25,4.59,4.59,0,0,1,1-2C526.5,122.79,526.81,122.61,526.84,122.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.52,124.58s-.34-.14-.87-.22a2.32,2.32,0,0,0-2.72,2.34c0,.54.14.87.08.89s-.29-.27-.37-.87a2.55,2.55,0,0,1,.83-2.14,2.5,2.5,0,0,1,2.24-.49C525.29,124.25,525.55,124.54,525.52,124.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.23,126.28c-.08.09-.66-.32-1.48-.52s-1.53-.15-1.55-.27.72-.36,1.65-.12S525.3,126.21,525.23,126.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.78,125.56c.1.07-.08.47-.09,1s.1.94,0,1-.36-.36-.38-1S523.71,125.5,523.78,125.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.59,121.62a10.31,10.31,0,0,1-3.66-5.35,10,10,0,0,1-.09-6.4,8.3,8.3,0,0,1,4.38,4.67,10.17,10.17,0,0,1-.63,7.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.47,113.23a71.68,71.68,0,0,1,2,8.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.43,121.32a5.6,5.6,0,0,1-.33-1.18c-.2-.84-.43-1.8-.67-2.86s-.5-2-.71-2.86a5.78,5.78,0,0,1-.25-1.19,4.4,4.4,0,0,1,.44,1.14c.23.72.52,1.72.79,2.84s.47,2.14.6,2.89A5.57,5.57,0,0,1,528.43,121.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.2,130.85a10.37,10.37,0,0,1,6.37,1.2,10,10,0,0,1,4.58,4.47,8.35,8.35,0,0,1-6.4-.22,10.18,10.18,0,0,1-4.55-5.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.63,135.29a73.76,73.76,0,0,1-7.11-4.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.52,131a5.9,5.9,0,0,1,1.07.6l2.5,1.55,2.52,1.52a6.38,6.38,0,0,1,1,.67,4.36,4.36,0,0,1-1.12-.5c-.67-.34-1.59-.84-2.57-1.44s-1.85-1.19-2.46-1.63A5,5,0,0,1,533.52,131Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.14,131.87a6.2,6.2,0,0,1-.34,3.86,6,6,0,0,1-2.39,3,5,5,0,0,1-.25-3.83,6,6,0,0,1,3-3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.93,136.55a43,43,0,0,1,2.17-4.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.1,132.07a15.59,15.59,0,0,1-1,2.27,14.35,14.35,0,0,1-1.15,2.21,9.05,9.05,0,0,1,.89-2.34A8.56,8.56,0,0,1,531.1,132.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.5,
    y: 74.02,
    width: 85.32,
    height: 354.07,
    transform: "translate(1190.31 502.1) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.32,
    y: 84.05,
    width: 67.68,
    height: 334.01,
    transform: "translate(1190.31 502.1) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.89,
    y: 75.09,
    width: 74.6,
    height: 354.07,
    transform: "translate(1348.38 504.25) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,84.72c0-.15,13.46-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S644.66,84.86,644.66,84.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,93.31c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,93.45,644.66,93.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,101.9c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,102,644.66,101.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,110.49c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,110.63,644.66,110.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,119.08c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,119.22,644.66,119.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,127.67c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,127.81,644.66,127.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,136.26c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,136.4,644.66,136.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,144.85c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,145,644.66,144.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,153.44c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,153.58,644.66,153.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,162c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,162.18,644.66,162Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,170.62c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,170.77,644.66,170.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,179.21c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,179.36,644.66,179.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,187.8c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,188,644.66,187.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,196.4c0-.15,13.46-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S644.66,196.54,644.66,196.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,205c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,205.13,644.66,205Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,213.58c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,213.72,644.66,213.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,222.17c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,222.31,644.66,222.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,230.76c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,230.9,644.66,230.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,239.35c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,239.49,644.66,239.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,247.94c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,248.08,644.66,247.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,256.53c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,256.67,644.66,256.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,265.12c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,265.26,644.66,265.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,273.71c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,273.86,644.66,273.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,282.3c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,282.45,644.66,282.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,290.89c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,291,644.66,290.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,299.48c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,299.63,644.66,299.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,308.08c0-.15,13.46-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S644.66,308.22,644.66,308.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,316.67c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,316.81,644.66,316.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,325.26c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,325.4,644.66,325.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,333.85c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,334,644.66,333.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,342.44c0-.15,13.46-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S644.66,342.58,644.66,342.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,351c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,351.17,644.66,351Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,359.62c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,359.76,644.66,359.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,368.21c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,368.35,644.66,368.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,376.8c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,377,644.66,376.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,385.39c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,385.54,644.66,385.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,394c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,394.13,644.66,394Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,402.57c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,402.72,644.66,402.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,411.16c0-.14,13.46-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S644.66,411.31,644.66,411.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.66,419.76c0-.15,13.46-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S644.66,419.9,644.66,419.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.32 136.26 629 203.03 629 213.58 561.32 147.76 561.32 136.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.32 162.09 629 228.86 629 233.65 561.32 167.84 561.32 162.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.19,
    y: 168.44,
    width: 52.67,
    height: 54.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.62,
    y: 168.44,
    width: 52.67,
    height: 54.9,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3,223.35H480.6V168.42h52.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.7,
    y: 175.82,
    width: 38.51,
    height: 40.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.7,216.22a5.83,5.83,0,0,1-.95,1.11c-.61.65-1.48,1.53-2.45,2.48s-1.86,1.8-2.51,2.41a5.51,5.51,0,0,1-1.12.92,6.42,6.42,0,0,1,.95-1.1c.61-.64,1.48-1.52,2.45-2.48s1.87-1.81,2.52-2.41A6.41,6.41,0,0,1,487.7,216.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.21,216.13a5.88,5.88,0,0,1,1.1,1c.65.61,1.53,1.47,2.48,2.44s1.81,1.86,2.41,2.52a7.06,7.06,0,0,1,.93,1.11,6.15,6.15,0,0,1-1.1-.94c-.65-.62-1.53-1.49-2.49-2.46s-1.81-1.86-2.41-2.52A5.8,5.8,0,0,1,526.21,216.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1,175.92a7.06,7.06,0,0,1,.95-1.1c.62-.65,1.48-1.53,2.45-2.48s1.86-1.81,2.52-2.41a6.13,6.13,0,0,1,1.11-.93,6,6,0,0,1-1,1.1c-.61.65-1.48,1.53-2.45,2.49s-1.86,1.81-2.52,2.41A5.53,5.53,0,0,1,526.1,175.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.6,176a5.83,5.83,0,0,1-1.11-1c-.65-.61-1.53-1.48-2.48-2.45s-1.81-1.85-2.41-2.51a7.06,7.06,0,0,1-.93-1.11,5.33,5.33,0,0,1,1.1.94c.65.62,1.53,1.48,2.49,2.45s1.81,1.87,2.41,2.52A6.41,6.41,0,0,1,487.6,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1,216s0-.07,0-.2,0-.32,0-.56c0-.5,0-1.23,0-2.17,0-1.9,0-4.66,0-8.18,0-7,0-17-.08-29l.15.15-38.4,0h0l.17-.17c0,14.73,0,28.51,0,40.14l-.15-.15,27.81.08,7.81,0,2.06,0h.54c.12,0,.18,0,.18,0h-.69l-2,0-7.78,0-27.9.07h-.15V216c0-11.63,0-25.41,0-40.14v-.17h.17l38.4,0h.15v.15c0,12-.06,22.08-.08,29.13,0,3.5,0,6.25,0,8.15,0,.92,0,1.64,0,2.13,0,.24,0,.42,0,.55A1.23,1.23,0,0,1,526.1,216Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.24,204.35a24.27,24.27,0,0,0-3.53-7.91,3.73,3.73,0,0,0-2.51-1.91,2.47,2.47,0,0,0-2.13,1.11,4.68,4.68,0,0,0-.76,2.37,6.73,6.73,0,0,0-6-.35c-1.87.94-3,3.4-2.06,5.26s3.32,2.42,5.39,2.75a2.33,2.33,0,0,0-.58,2.86,3.46,3.46,0,0,0,2.53,1.73,5,5,0,0,0,3.13-.3,18.07,18.07,0,0,0,6.55-5.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.67,205.31a4.07,4.07,0,0,1-.83,0c-.53,0-1.29-.1-2.23-.19-1.89-.19-4.41-.52-7.34-1.05s-5.4-1.11-7.24-1.6c-.91-.24-1.65-.45-2.16-.61a3.32,3.32,0,0,1-.77-.28,4,4,0,0,1,.81.15l2.18.51c1.85.42,4.4,1,7.24,1.49s5.43.9,7.3,1.15l2.23.29A3.87,3.87,0,0,1,518.67,205.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.89,196.2a2,2,0,0,1,.32.53c.18.35.43.87.7,1.53a23.62,23.62,0,0,1,1.44,5.41l0,.13-.13,0-.45.2A27.88,27.88,0,0,0,501.7,207c-1.22.88-1.92,1.51-2,1.46a2.24,2.24,0,0,1,.45-.48,15.54,15.54,0,0,1,1.36-1.18,24,24,0,0,1,5.1-3.05l.46-.2-.1.19a27.69,27.69,0,0,0-1.33-5.38C505.21,197,504.84,196.22,504.89,196.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.3,198.44a10.45,10.45,0,0,1,.81,1.24c.48.78,1.2,1.83,2,3l.13.21L503,203l-.48.11c-1.52.35-2.9.58-3.9.76a9.56,9.56,0,0,1-1.62.24,7,7,0,0,1,1.57-.48c1-.24,2.37-.51,3.87-.86l.47-.11-.1.26c-.79-1.19-1.48-2.27-1.92-3.09A4.85,4.85,0,0,1,500.3,198.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44,194.23a24.09,24.09,0,0,0,2.36-8.34,3.67,3.67,0,0,0-.7-3.08,2.51,2.51,0,0,0-2.35-.51,4.75,4.75,0,0,0-2.09,1.33,6.76,6.76,0,0,0-4.41-4.13c-2-.47-4.48.69-4.95,2.72s1,4,2.37,5.57a2.33,2.33,0,0,0-2.28,1.82,3.43,3.43,0,0,0,.84,2.94,5,5,0,0,0,2.59,1.78,18.18,18.18,0,0,0,8.62-.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44,183.47a1.84,1.84,0,0,1,0,.62c0,.39-.14,1-.3,1.65a23.62,23.62,0,0,1-1.9,5.27l-.06.11-.14,0-.48-.1a28.25,28.25,0,0,0-5.85-.5c-1.51,0-2.44.14-2.45.08a2.9,2.9,0,0,1,.65-.14c.42-.07,1-.14,1.79-.19a24,24,0,0,1,5.92.41l.5.1-.19.09a28.25,28.25,0,0,0,2-5.17C514.24,184.32,514.39,183.47,514.44,183.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.64,182a7.26,7.26,0,0,1,.09,1.44c0,.9,0,2.14,0,3.53v.23l-.22-.06-.4-.11c-1.43-.4-2.72-.78-3.65-1.06a7.74,7.74,0,0,1-1.5-.54,6.73,6.73,0,0,1,1.56.3c.94.23,2.25.57,3.69,1l.4.11-.23.17c0-1.4.08-2.64.13-3.53A5.91,5.91,0,0,1,509.64,182Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.15,183.28s.1.07.26.22l.68.67a14.75,14.75,0,0,1,1,1.1c.4.44.84.95,1.29,1.54a43,43,0,0,1,3,4.26,57.77,57.77,0,0,1,3.06,5.6,59.53,59.53,0,0,1,2.4,5.92,45.14,45.14,0,0,1,1.38,5c.08.36.15.71.22,1s.1.64.15.93c.09.59.17,1.09.19,1.5s0,.7.07,1a1.19,1.19,0,0,1,0,.33,1.12,1.12,0,0,1-.07-.33c0-.25-.09-.56-.14-.94s-.15-.91-.25-1.48c-.06-.3-.12-.6-.18-.93s-.15-.67-.24-1a48.07,48.07,0,0,0-1.45-5,60.05,60.05,0,0,0-2.41-5.88c-1-2-2-3.91-3-5.59a49.94,49.94,0,0,0-2.93-4.27c-.44-.6-.86-1.11-1.24-1.56s-.7-.84-1-1.14l-.63-.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 70.92,
    width: 85.32,
    height: 354.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.99,
    y: 80.95,
    width: 67.68,
    height: 334.01,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.49,
    y: 71.99,
    width: 74.6,
    height: 354.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,81.61c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,81.47,105.32,81.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,90.21c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S105.32,90.06,105.32,90.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,98.8c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,98.65,105.32,98.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,107.39c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,107.24,105.32,107.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,116c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,115.83,105.32,116Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,124.57c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,124.42,105.32,124.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,133.16c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,133,105.32,133.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,141.75c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,141.61,105.32,141.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,150.34c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,150.2,105.32,150.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,158.93c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,158.79,105.32,158.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,167.52c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,167.38,105.32,167.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,176.11c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,176,105.32,176.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,184.7c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,184.56,105.32,184.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,193.29c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26S58.65,193,75.26,193,105.32,193.15,105.32,193.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,201.89c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S105.32,201.74,105.32,201.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,210.48c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,210.33,105.32,210.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,219.07c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,218.92,105.32,219.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,227.66c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,227.51,105.32,227.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,236.25c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26S58.65,236,75.26,236,105.32,236.1,105.32,236.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,244.84c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,244.7,105.32,244.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,253.43c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,253.29,105.32,253.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,262c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,261.88,105.32,262Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,270.61c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,270.47,105.32,270.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,279.2c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,279.06,105.32,279.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,287.79c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,287.65,105.32,287.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,296.38c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,296.24,105.32,296.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,305c0,.15-13.46.27-30.06.27s-30.07-.12-30.07-.27,13.46-.26,30.07-.26S105.32,304.83,105.32,305Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,313.57c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.27,30.07-.27S105.32,313.42,105.32,313.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,322.16c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,322,105.32,322.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,330.75c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,330.6,105.32,330.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,339.34c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,339.19,105.32,339.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,347.93c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,347.78,105.32,347.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,356.52c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,356.38,105.32,356.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,365.11c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,365,105.32,365.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,373.7c0,.14-13.46.26-30.06.26s-30.07-.12-30.07-.26,13.46-.26,30.07-.26S105.32,373.56,105.32,373.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,382.29c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26S58.65,382,75.26,382,105.32,382.15,105.32,382.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,390.88c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,390.74,105.32,390.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,399.47c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,399.33,105.32,399.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,408.06c0,.15-13.46.26-30.06.26s-30.07-.11-30.07-.26,13.46-.26,30.07-.26S105.32,407.92,105.32,408.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,416.65c0,.15-13.46.27-30.06.27s-30.07-.12-30.07-.27,13.46-.26,30.07-.26S105.32,416.51,105.32,416.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.18,
    y: 70.92,
    width: 85.32,
    height: 354.07,
    transform: "translate(469.67 495.9) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 80.95,
    width: 67.68,
    height: 334.01,
    transform: "translate(469.67 495.9) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.57,
    y: 71.99,
    width: 74.6,
    height: 354.07,
    transform: "translate(627.74 498.05) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,81.61c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,81.76,284.34,81.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,90.21c0-.15,13.47-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S284.34,90.35,284.34,90.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,98.8c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,98.94,284.34,98.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,107.39c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,107.53,284.34,107.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,116c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,116.12,284.34,116Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,124.57c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,124.71,284.34,124.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,133.16c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,133.3,284.34,133.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,141.75c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26S331,142,314.41,142,284.34,141.89,284.34,141.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,150.34c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,150.48,284.34,150.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,158.93c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,159.08,284.34,158.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,167.52c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,167.67,284.34,167.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,176.11c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,176.26,284.34,176.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,184.7c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26S331,185,314.41,185,284.34,184.85,284.34,184.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,193.29c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,193.44,284.34,193.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,201.89c0-.15,13.47-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S284.34,202,284.34,201.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,210.48c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,210.62,284.34,210.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,219.07c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,219.21,284.34,219.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,227.66c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,227.8,284.34,227.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,236.25c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,236.39,284.34,236.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,244.84c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,245,284.34,244.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,253.43c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,253.57,284.34,253.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,262c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,262.16,284.34,262Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,270.61c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,270.76,284.34,270.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,279.2c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,279.35,284.34,279.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,287.79c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,287.94,284.34,287.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,296.38c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,296.53,284.34,296.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,305c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.27-30.07.27S284.34,305.12,284.34,305Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,313.57c0-.15,13.47-.27,30.07-.27s30.07.12,30.07.27-13.46.26-30.07.26S284.34,313.71,284.34,313.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,322.16c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,322.3,284.34,322.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,330.75c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26S331,331,314.41,331,284.34,330.89,284.34,330.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,339.34c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,339.48,284.34,339.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,347.93c0-.15,13.47-.26,30.07-.26s30.07.11,30.07.26-13.46.26-30.07.26S284.34,348.07,284.34,347.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,356.52c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,356.66,284.34,356.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,365.11c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,365.25,284.34,365.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,373.7c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26S331,374,314.41,374,284.34,373.84,284.34,373.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,382.29c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,382.44,284.34,382.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,390.88c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,391,284.34,390.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,399.47c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,399.62,284.34,399.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,408.06c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.26-30.07.26S284.34,408.21,284.34,408.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.34,416.65c0-.14,13.47-.26,30.07-.26s30.07.12,30.07.26-13.46.27-30.07.27S284.34,416.8,284.34,416.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201 133.16 268.68 199.93 268.68 210.48 201 144.66 201 133.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201 158.99 268.68 225.76 268.68 230.55 201 164.74 201 158.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.41,231.86s-16.94-33.45-18.57-36.08c-2.87-4.65,9.64-40.26,9.64-40.26L603.57,157l-5.87,32.24,19,32.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "612.39 259.67 597.65 230.61 616.71 216.15 633.09 238.69 612.62 257.17",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.91,415.19,499,433.32s-20.42.09-21.84,3.33l34.76,12.73,10.37-27.89Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.3,435.75a1.52,1.52,0,0,1,.39,2,1.46,1.46,0,0,1-2,.4,1.6,1.6,0,0,1-.4-2.1,1.51,1.51,0,0,1,2.08-.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.92,449.38l1-2.78-33.77-11.21s-1.8.11-2,1.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5,432.94c-.06.17.76.56,1.4,1.41s.82,1.73,1,1.72.29-1.08-.5-2.1S498.52,432.77,498.5,432.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.3,433.11c-.1.15.53.71.85,1.64s.2,1.75.37,1.8.63-.86.22-2S494.37,433,494.3,433.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.64,436.72c.14.09.68-.67.59-1.76s-.76-1.75-.88-1.63.19.79.25,1.68S490.47,436.64,490.64,436.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.31,429c0,.18.88.23,1.81.64s1.57,1,1.72.88-.36-1-1.47-1.45S500.27,428.79,500.31,429Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.57,425.32a3.43,3.43,0,0,0,1.74.63,8.11,8.11,0,0,0,2,.1,7.36,7.36,0,0,0,1.19-.16,2.14,2.14,0,0,0,.68-.22.78.78,0,0,0,.4-.87,1,1,0,0,0-.6-.66,2.4,2.4,0,0,0-.68-.15,7.18,7.18,0,0,0-1.22,0,6.54,6.54,0,0,0-2,.47c-1.08.45-1.59,1-1.54,1s.64-.3,1.69-.62a7.51,7.51,0,0,1,1.87-.31,7.07,7.07,0,0,1,1.11.06c.4,0,.72.15.75.35s0,.1-.11.18a2,2,0,0,1-.49.16,9.56,9.56,0,0,1-1.11.19,10.46,10.46,0,0,1-1.92,0A13.1,13.1,0,0,0,501.57,425.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.7,425.64c.05.05.61-.43,1.07-1.51a5.83,5.83,0,0,0,.46-2,6.33,6.33,0,0,0-.05-1.22,1.55,1.55,0,0,0-.79-1.29.88.88,0,0,0-.91.22,2.78,2.78,0,0,0-.41.57,4.32,4.32,0,0,0-.43,1.18,4.27,4.27,0,0,0,.09,2.07c.35,1.15,1,1.61,1,1.56a16.59,16.59,0,0,1-.58-1.67,4.28,4.28,0,0,1,0-1.84,3.61,3.61,0,0,1,.4-1c.19-.35.43-.6.56-.51s.36.45.4.79a6,6,0,0,1,.08,1.11,6.72,6.72,0,0,1-.29,1.86C502,425,501.62,425.58,501.7,425.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.16,309.45c-6.51-2.12-32.29-10-51-14.67a27.26,27.26,0,0,0-21.3,4.1h0a23.9,23.9,0,0,0-10,24.44l7.7,47.54L543,368.7l-4.11-45.78,45.33,13.83,40.39-11.68-.12-2-33.32-13.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.06,317.81,544,330.18a25.49,25.49,0,0,0-18.45,15.9l-28,77.32,23.23,7.16,31.56-70.8,45.95-5.65a50,50,0,0,0,31.09-16.18l8-8.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.69,319.87l-.24.08-.71.17-2.74.64L576.91,323l-15,3.26-8.86,1.92c-3.06.68-6.26,1.29-9.47,2.13a29.3,29.3,0,0,0-8.86,3.71,23.25,23.25,0,0,0-6.22,6.38c-3.19,4.79-4.79,9.81-6.16,13.93s-2.47,7.52-3.44,9.76c-.48,1.13-.89,2-1.18,2.56-.14.26-.25.48-.35.65a1.12,1.12,0,0,1-.13.21.86.86,0,0,1,.09-.24l.3-.66c.26-.59.64-1.46,1.09-2.59.92-2.26,2-5.62,3.29-9.79s2.89-9.21,6.11-14.08a23.61,23.61,0,0,1,6.33-6.53,29.57,29.57,0,0,1,9-3.79c3.24-.85,6.43-1.45,9.5-2.13l8.86-1.88,15-3.17L587,320.57l2.76-.54.72-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.55,300.49a45.09,45.09,0,0,1-8.92,3.31,23.17,23.17,0,0,1,4.37-1.88A23.68,23.68,0,0,1,637.55,300.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.14,240.27l-13,52.23-14.18,16.55,49.14,20.33,17.67-38.82,14.12-43.05c-3.92-7.24-11.45-9-14-9.28l-20.27-1.43Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.28,251.15a9.1,9.1,0,0,1-.3,1.65c-.26,1.13-.6,2.63-1,4.45-.88,3.75-2.12,8.93-3.53,14.63s-2.71,10.88-3.67,14.61c-.48,1.8-.87,3.29-1.17,4.41a12.16,12.16,0,0,1-.49,1.6,9.9,9.9,0,0,1,.31-1.65c.25-1.13.6-2.63,1-4.45.88-3.75,2.13-8.93,3.53-14.63s2.71-10.87,3.67-14.6c.48-1.81.87-3.3,1.17-4.42A12.16,12.16,0,0,1,614.28,251.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.21,295.85c-.06.07-.78-.55-2.12-1.25a17.7,17.7,0,0,0-5.6-1.75,35.18,35.18,0,0,0-5.91-.31,13,13,0,0,1-2.48,0,11.29,11.29,0,0,1,2.46-.31,27.27,27.27,0,0,1,6,.17,15.81,15.81,0,0,1,5.7,1.93A6.65,6.65,0,0,1,620.21,295.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.1,292.5a43.38,43.38,0,0,1,15.61-.76A6,6,0,0,1,623,293a2.32,2.32,0,0,1,.4,3.18,2.39,2.39,0,0,1-2.38.46c-.81-.24-1.8-1.49-2.52-1.94-4-2.53-9.06-2.66-14.11-2.15"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M646.42,250.72c-4.13,11.73,4.2,24.86,12,34.53l2-6S650.55,239,646.42,250.72Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "602.6 364.15 601.65 437.33 571.52 448.84 640.62 448.51 610.13 436.9 609.85 364.15 602.6 364.15",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.66,358.35c8.65,3.37,17.6,6.44,26.88,6.75s19-2.46,25.37-9.26c5.07-5.44,7.43-12.78,9.65-19.88q2.41-7.66,4.81-15.35c1.33-4.24,3.33-9.21.91-11.49-3.4-3.2-12.51-4.43-15.93-1.25-5.12,4.75-5.35,6.72-7.66,10.78-5.33,9.37-10,17.9-20,21.83-4.84,1.89-10.21,2-15.06,3.87s-9.81,8.87-9,14",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M648.28,309.12c-3.4-3.2-12.51-4.43-15.93-1.25-5.12,4.75-5.35,6.72-7.66,10.78-5.33,9.37-10,17.9-20,21.83-4.84,1.89-10.21,2-15.06,3.87s-9.81,8.87-9,14c7.1,2.77,14.41,5.33,21.93,6.33l-.94,72.65-30.13,11.51,69.1-.33L610.13,436.9l-.28-71.79c8.56-.19,17.26-3,23.06-9.27,5.07-5.44,7.43-12.78,9.65-19.88q2.41-7.66,4.81-15.35C648.7,316.37,650.7,311.4,648.28,309.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M651.21,310s-29.56-33.57-30-33.47-22.47-3.14-22.47-3.14L595,277.05l24.52,3.19,30.12,31.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,277c-.31.16-1.71,1.09-1.71,1.09l.3,3.15s5.41,1.64,5.57,1.82,1.25-1.66,1.25-1.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.68,312.78,619.5,280.07,595,277c-.28.12,27.69,29.6,27.69,29.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,277s-4,1.76,2.3,2.61c6.8.91,20.65,2.51,20.65,2.51L639,311s-1.17,1.77-2.19,1.51c-4.64-1.17-16.09-2-20.34-4.29-5.38-2.9-23.83-26.43-24.1-28.59C592.12,277.67,595,277,595,277Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.81,312.52a2.38,2.38,0,0,1-.41-.46c-.27-.36-.63-.81-1.06-1.37l-3.85-5.11c-3.24-4.4-7.65-10.38-12.53-17l-2.91-4,.17.1-9.78-1.19-4.2-.53-3.63-.56c-1.1-.18-2.1-.3-3-.5a7.53,7.53,0,0,1-2.13-.81,2.59,2.59,0,0,1-1-1,1,1,0,0,1-.14-.47,2.55,2.55,0,0,0,1.25,1.32,7.67,7.67,0,0,0,2.09.72c.85.17,1.86.26,2.95.42l3.62.49,4.21.48,9.79,1.13.11,0,.07.09,2.92,4,12.41,17.07c1.54,2.15,2.79,3.92,3.71,5.21l1,1.43A3.39,3.39,0,0,1,636.81,312.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.84,294.21s-4.87-4.63-6.52-4.89c-1.84-.28-4.92-2.11-6.84-3.86a1.35,1.35,0,0,0-2.13,0L634,291l-15.44-2.19a4.12,4.12,0,0,0,2,3.13c2,1.19,1.5,1.2,1.5,1.2s-1,1.39.17,2.32a28.63,28.63,0,0,0,3,1.93s-.61,2.06.5,3.28a6.74,6.74,0,0,0,1.07,3.06c1,1.61,5.54,3.59,5.54,3.59l20.54-.76-.47-11.75Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628,290.16a21.78,21.78,0,0,0,4.22.88,22.45,22.45,0,0,0,4.27.46,21.35,21.35,0,0,0-4.21-.88A22.45,22.45,0,0,0,628,290.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.6,292.6a26.18,26.18,0,0,0,4.25,1.93,25,25,0,0,0,4.4,1.52,51.09,51.09,0,0,0-8.65-3.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.47,297.07a7.41,7.41,0,0,0,2.17,1.34,8,8,0,0,0,2.37,1,7.56,7.56,0,0,0-2.18-1.34A7.78,7.78,0,0,0,624.47,297.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.54,300.44c0,.11.52.5,1.22.94s1.3.79,1.37.7-.41-.6-1.14-1.06S625.6,300.34,625.54,300.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.45,291a11.71,11.71,0,0,1-2.82.21,39.8,39.8,0,0,1-13.39-2.33,12.38,12.38,0,0,1-2.59-1.15,19.83,19.83,0,0,1,2.7.8,56.19,56.19,0,0,0,6.57,1.58,55.1,55.1,0,0,0,6.72.73A21.38,21.38,0,0,1,616.45,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.1,301.54a11.48,11.48,0,0,1-2.62.24,44.87,44.87,0,0,1-6.37-.23,37.09,37.09,0,0,1-6.26-1.22,10.66,10.66,0,0,1-2.48-.91,18.26,18.26,0,0,1,2.57.56,56,56,0,0,0,6.22,1.06c2.46.26,4.69.34,6.31.38A14.74,14.74,0,0,1,625.1,301.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629,307.38a10.9,10.9,0,0,1-2.53.22,35.07,35.07,0,0,1-6.11-.42,41,41,0,0,1-6-1.42,11.69,11.69,0,0,1-2.37-.92c.06-.18,3.72,1.08,8.4,1.83S629,307.2,629,307.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.85,295.88a10,10,0,0,1-2.45.41,31.78,31.78,0,0,1-6,0,36.85,36.85,0,0,1-5.89-1.09,9.81,9.81,0,0,1-2.35-.79c0-.18,3.69.89,8.29,1.36S619.83,295.71,619.85,295.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633,307.32l51.7-.74h0a38.55,38.55,0,0,0,.12-25.23l-10.75-27.17c-3-7.38-11-13.4-18.25-10.13h0c-7.07,3.17-7.69,10.34-4.6,17.46l13.65,28.93-19.54,3.93",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.08,263.06c4,6.86,10.35,17.49,10.35,17.49l23.39-9.67s-10.1-19.09-13.35-24c-1.32-2-4.23-6-12.8-7a17.92,17.92,0,0,0-2.65.69,11.34,11.34,0,0,0-7.89,8.66l-.2,1C646.46,254.45,647.93,259.42,650.08,263.06Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.43,280.55a12.17,12.17,0,0,1-1-1.38L657,275.31l-3.61-5.76c-1.34-2.18-2.89-4.52-4.27-7.16a22.57,22.57,0,0,1-1.67-4,18.28,18.28,0,0,1-.7-4,20.47,20.47,0,0,1,.45-6.82,9.14,9.14,0,0,1,2.12-4.08l.52-.5.43-.31c.24-.17.37-.25.38-.23a1.65,1.65,0,0,1-.32.31l-.39.34-.48.52a9.49,9.49,0,0,0-1.92,4,21,21,0,0,0-.34,6.69,18.88,18.88,0,0,0,.71,3.9,23.06,23.06,0,0,0,1.65,3.92c1.36,2.6,2.9,5,4.22,7.15s2.51,4.14,3.52,5.82l2.34,3.94A9.39,9.39,0,0,1,660.43,280.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.77,297.14c-.08,0-.5-.9-1.53-2.16a12.73,12.73,0,0,0-11.16-4.75c-1.62.13-2.59.47-2.61.39s.22-.15.66-.3a9.94,9.94,0,0,1,1.91-.44,12.17,12.17,0,0,1,11.48,4.88,10.22,10.22,0,0,1,1,1.69C679.72,296.88,679.8,297.12,679.77,297.14Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.32,159.75s3.41-.31,5-2.05,8.42-13.62,8.42-13.62-1.39-1.21-3.49.62a57.1,57.1,0,0,0-4.39,4.8l2.47-10.42c.55-2.33,1.25-5.9.14-6.5s-2.26,3.9-3.13,5.69-2,4.36-2,4.36c0,.15,2-9.26,1.81-11.92-.11-1.94-2.52-1.48-2.83.72,0,0-.65-2.33-1.87-.84s-3,10.65-3.63,10.42.44-7.76-.47-8.57c-.52-.46-1.34.17-1.7,2.07s-2.93,16.25-2.81,18.29a4.75,4.75,0,0,0,.86,2.84Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.81,148.71a3.75,3.75,0,0,1,1.31,1A9.74,9.74,0,0,1,599.3,153l-.43-.09.12-.12a11.32,11.32,0,0,1,3.38-2.29,3.81,3.81,0,0,1,1.62-.47,20.73,20.73,0,0,0-4.63,3.14l-.12.11-.28.28-.15-.37A16.14,16.14,0,0,0,595.81,148.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.37,131.09a38.16,38.16,0,0,1-.75,5.93,22.33,22.33,0,0,1-1.51,5.8c-.14,0,.46-2.63,1-5.88A30.23,30.23,0,0,1,601.37,131.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.63,199.83a16.54,16.54,0,0,1,16.47-15.25H637c9.24.53,14,8.67,13.18,17.89l-1.59,37h0l-21.13,8.28.07-16.52s-8.89-1.36-9-10.25C618.41,216.67,619,207.83,619.63,199.83Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.41,231.2a21.56,21.56,0,0,0,11.64-3.43s-2.73,6.39-11.59,5.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.78,206.32a1.26,1.26,0,0,0,1.23,1.27,1.2,1.2,0,0,0,1.3-1.14,1.26,1.26,0,0,0-1.22-1.28A1.22,1.22,0,0,0,621.78,206.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.55,204.17c.16.17,1.12-.55,2.48-.54s2.37.68,2.51.51-.08-.37-.52-.69a3.47,3.47,0,0,0-2-.62,3.39,3.39,0,0,0-2,.65C621.61,203.8,621.47,204.1,621.55,204.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.59,206.32a1.26,1.26,0,0,0,1.23,1.27,1.2,1.2,0,0,0,1.3-1.14,1.26,1.26,0,0,0-1.22-1.28A1.22,1.22,0,0,0,634.59,206.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,204.4c.15.16,1.12-.55,2.48-.55s2.37.68,2.51.52-.08-.38-.52-.69a3.47,3.47,0,0,0-2-.62,3.39,3.39,0,0,0-2,.64C635,204,634.89,204.33,635,204.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,214.53a9.4,9.4,0,0,0-2.21-.39c-.35,0-.68-.11-.74-.34a1.79,1.79,0,0,1,.23-1c.32-.84.67-1.73,1-2.65,1.43-3.79,2.46-6.9,2.3-7a45.52,45.52,0,0,0-2.85,6.74c-.34.94-.67,1.83-1,2.68a2,2,0,0,0-.18,1.37.86.86,0,0,0,.57.5,2.36,2.36,0,0,0,.6.09A8.47,8.47,0,0,0,630,214.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.05,215.47c-.22,0-.22,1.47-1.48,2.52s-2.85.9-2.86,1.11.35.28,1,.3a3.66,3.66,0,0,0,2.38-.84,3.21,3.21,0,0,0,1.16-2.11C634.32,215.83,634.15,215.46,634.05,215.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.6,199.05c.14.37,1.5.19,3.1.38s2.9.63,3.11.29c.1-.16-.13-.5-.65-.86a5.25,5.25,0,0,0-2.31-.81,5.32,5.32,0,0,0-2.42.29C634.84,198.58,634.55,198.87,634.6,199.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622,200.22c.24.31,1.18,0,2.31,0s2.09.2,2.31-.12c.1-.16,0-.47-.47-.76a3.28,3.28,0,0,0-1.88-.51,3.19,3.19,0,0,0-1.84.63C622.07,199.75,621.94,200.07,622,200.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.81,209c.16-.07,6.1-1.82,5.92,4.26s-6.24,4.63-6.24,4.46S648.81,209,648.81,209Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.87,215.51s.11.08.29.17a1.08,1.08,0,0,0,.79,0,2.66,2.66,0,0,0,1.28-2.31,3.57,3.57,0,0,0-.25-1.53,1.2,1.2,0,0,0-.78-.83.53.53,0,0,0-.63.27c-.09.17-.05.29-.08.3s-.13-.11-.07-.36a.65.65,0,0,1,.25-.37.77.77,0,0,1,.59-.14,1.49,1.49,0,0,1,1.07,1,3.47,3.47,0,0,1,.32,1.7A2.77,2.77,0,0,1,651,216a1.11,1.11,0,0,1-1-.19C649.88,215.66,649.85,215.52,649.87,215.51Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.83,191l-25.32.55a11.56,11.56,0,0,1,3.72-4.3,19.8,19.8,0,0,1,11.47-4.13c4.13-.07,12.53,5,15.53,7.81,2.39,2.28,2.37,4.25,2.37,4.25.39,3.29-1.45,7-2.18,10.24-.38,1.66-1.11,6.69-1.11,6.69h0c-1.39,0-1.91-1.11-1.7-2.49l.26-5.41a8.18,8.18,0,0,1-2.5-9.55C645.73,194.16,646.5,191.91,644.83,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.51,210.19a.15.15,0,0,0,.18-.13.15.15,0,0,0-.11-.19.16.16,0,0,0-.18.13A.15.15,0,0,0,639.51,210.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.91,209.61a.18.18,0,0,0,.18-.16.17.17,0,0,0-.11-.21.17.17,0,0,0-.19.15A.18.18,0,0,0,636.91,209.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.15,209.57c.08,0,.16-.09.18-.23s0-.25-.12-.26-.16.09-.18.23S635.07,209.56,635.15,209.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.24,211.83c.08,0,.15,0,.15-.09s-.07-.1-.15-.1-.15,0-.15.1S638.15,211.83,638.24,211.83Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.84,211.28a.16.16,0,0,0,.17-.15.17.17,0,0,0-.14-.19.16.16,0,0,0-.16.16A.15.15,0,0,0,635.84,211.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.39,209.82a.16.16,0,0,0,.18-.13.16.16,0,0,0-.11-.2.16.16,0,0,0-.18.14A.15.15,0,0,0,623.39,209.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.61,209.66a.17.17,0,0,0,.17-.17c0-.1,0-.2-.13-.2s-.16.07-.17.17S621.53,209.66,621.61,209.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,209.86a.13.13,0,0,0,.17-.1.15.15,0,0,0-.29,0A.13.13,0,0,0,625,209.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.65,211.64a.15.15,0,0,0,.2-.09.16.16,0,0,0-.06-.22.16.16,0,0,0-.21.09A.16.16,0,0,0,623.65,211.64Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.13,211.34a.13.13,0,0,0,.11-.16.14.14,0,0,0-.18-.08.13.13,0,1,0,.07.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.39,191.27a7.49,7.49,0,0,0-7.48-9.31,23.37,23.37,0,0,1-3.53.25c-2.19-.24-3.88-2-5.92-2.85a7.71,7.71,0,0,0-9.1,2.74c-.77,1.15-1.28,2.57-2.46,3.29-1,.63-2.31.58-3.45.92a5.64,5.64,0,0,0-3.79,5.58,6.65,6.65,0,0,0,4,5.58,8.13,8.13,0,0,0,7-.49c1.91-1.07,3.63-2.88,5.81-2.82s4.24,2.21,6.46,1.76a6.27,6.27,0,0,0,2.92-1.95,5,5,0,0,1,3-1.74c1.18-.07,1.8,1.56,1.38,2.67l5.1-3.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,188.33l0,.09a1.63,1.63,0,0,0,.15.24,3.88,3.88,0,0,0,.72.83,4.55,4.55,0,0,0,1.51.87,4.36,4.36,0,0,0,2.3.14,4.58,4.58,0,0,0,2.42-1.38c.69-.76,1.1-1.78,1.75-2.67a3.51,3.51,0,0,1,1.22-1.11,3.56,3.56,0,0,1,1.68-.37,3.71,3.71,0,0,1,1.73.47,3.18,3.18,0,0,1,1.27,1.3,17.38,17.38,0,0,0,.89,1.71,2.11,2.11,0,0,0,1.62,1,3.24,3.24,0,0,0,1.77-.51,6.7,6.7,0,0,0,1.34-1.12,5.59,5.59,0,0,1,2.52-1.78,3.19,3.19,0,0,1,2.54.59,4.49,4.49,0,0,1,1.4,1.73,7.72,7.72,0,0,1,.52,1.63c.09.46.14.83.17,1.08a2.55,2.55,0,0,0,.05.37.31.31,0,0,0,0-.09,2.27,2.27,0,0,1,0-.29c0-.25-.05-.62-.13-1.09a6.66,6.66,0,0,0-.49-1.66,4.49,4.49,0,0,0-1.42-1.82,3.34,3.34,0,0,0-2.69-.65,5.76,5.76,0,0,0-2.62,1.82,6.5,6.5,0,0,1-1.31,1.08,3.06,3.06,0,0,1-1.63.47,1.87,1.87,0,0,1-1.44-.89c-.34-.5-.56-1.11-.88-1.69a3.55,3.55,0,0,0-1.37-1.4,4,4,0,0,0-1.83-.49,3.88,3.88,0,0,0-1.79.4,3.76,3.76,0,0,0-1.31,1.19A30.79,30.79,0,0,1,627,189a4.39,4.39,0,0,1-2.31,1.35,4.31,4.31,0,0,1-2.22-.1,4.61,4.61,0,0,1-1.49-.81A5.7,5.7,0,0,1,620,188.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.41,188.42a1.47,1.47,0,0,0-.1.49,3.67,3.67,0,0,0,.12,1.36,4.85,4.85,0,0,0,1,1.78,5.65,5.65,0,0,0,2,1.46,8.21,8.21,0,0,0,4.41.5,12,12,0,0,0,1.33-.26,2.27,2.27,0,0,0,.47-.16s-.69.13-1.82.25a8.59,8.59,0,0,1-4.3-.55,5.82,5.82,0,0,1-1.93-1.38,4.93,4.93,0,0,1-.95-1.69A5.28,5.28,0,0,1,615.41,188.42Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.26,415.24l2.25,18.94s20,4.08,20.77,7.54l-36.57,5.68L177,418Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,434.35a1.52,1.52,0,0,0-.76,1.87A1.45,1.45,0,0,0,187,437a1.6,1.6,0,0,0,.8-2,1.5,1.5,0,0,0-2-.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.71,447.4l-.47-2.92,35.31-4.39s1.73.45,1.73,1.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.07,433.9c0,.18-.85.4-1.64,1.11s-1.14,1.54-1.32,1.49-.07-1.12.9-2S198.09,433.73,198.07,433.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.16,434.89c.06.17-.66.59-1.15,1.44s-.54,1.68-.72,1.7-.45-1,.18-2S202.13,434.72,202.16,434.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.05,439.15c-.16.06-.54-.79-.24-1.84s1.08-1.57,1.18-1.43-.33.74-.57,1.6S205.22,439.1,205.05,439.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.08,429.64c-.05.18-.9.06-1.9.28s-1.74.67-1.86.53.54-.89,1.72-1.14S197.15,429.49,197.08,429.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,425.83a3.64,3.64,0,0,1-1.84.28,8.37,8.37,0,0,1-2-.3,9,9,0,0,1-1.14-.39,2.27,2.27,0,0,1-.62-.34.8.8,0,0,1-.23-.94,1,1,0,0,1,.72-.53,2.37,2.37,0,0,1,.7,0,6.53,6.53,0,0,1,1.2.21,6.31,6.31,0,0,1,1.86.85c1,.65,1.36,1.27,1.31,1.32s-.57-.43-1.54-.94a7.12,7.12,0,0,0-1.77-.67,6.45,6.45,0,0,0-1.11-.16c-.4,0-.73,0-.8.2s0,.09.07.19a1.75,1.75,0,0,0,.46.26,9.75,9.75,0,0,0,1,.4,9.65,9.65,0,0,0,1.88.4A12.18,12.18,0,0,1,196.56,425.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.36,426.12a3,3,0,0,1-.75-1.69,6,6,0,0,1-.06-2.05,5.34,5.34,0,0,1,.29-1.18,1.53,1.53,0,0,1,1-1.11.88.88,0,0,1,.85.39,2.61,2.61,0,0,1,.29.65,4.09,4.09,0,0,1,.19,1.23,4.14,4.14,0,0,1-.49,2c-.56,1.06-1.27,1.39-1.3,1.33a13.43,13.43,0,0,0,.9-1.51,4.19,4.19,0,0,0,.31-1.81,3.59,3.59,0,0,0-.19-1.06c-.12-.38-.32-.67-.46-.61s-.44.37-.54.7a5.55,5.55,0,0,0-.3,1.07,6.41,6.41,0,0,0-.07,1.88C196.16,425.44,196.46,426.08,196.36,426.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.38,413.87l-11.31,15.37s11.82,16.65,10,19.69L131.5,428.08l16.63-24.67Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,421.46a1.52,1.52,0,0,0-1.84.84,1.45,1.45,0,0,0,.81,1.82,1.58,1.58,0,0,0,1.94-.89,1.5,1.5,0,0,0-1.05-1.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,428.08l1.65-2.45,28.77,20.93s1,1.52.15,2.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.67,429.42c-.11.14-.9-.3-2-.32s-1.88.34-2,.19.71-.87,2-.82S152.8,429.3,152.67,429.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,432.93c-.06.17-.88,0-1.82.27s-1.54.85-1.68.74.33-1,1.51-1.35S155.07,432.79,155,432.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18,438c-.16-.06.14-.95,1.08-1.5s1.86-.41,1.84-.24-.75.31-1.52.78S154.33,438.1,154.18,438Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,425.63c-.16.09-.7-.58-1.58-1.1s-1.73-.7-1.72-.88,1-.28,2,.34S155,425.56,154.86,425.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.08,422.49c0,.06-.69-.25-1.52-1.05a7.75,7.75,0,0,1-1.27-1.59,8.79,8.79,0,0,1-.56-1.06,2.59,2.59,0,0,1-.22-.68.78.78,0,0,1,.48-.84,1,1,0,0,1,.88.1,2.44,2.44,0,0,1,.52.47,6.58,6.58,0,0,1,1.51,2.87,3,3,0,0,1,0,1.86c-.1,0-.12-.7-.48-1.74a7.2,7.2,0,0,0-.84-1.7,7.73,7.73,0,0,0-.69-.87c-.27-.3-.54-.49-.72-.41s-.09.06-.08.2a1.73,1.73,0,0,0,.16.49,9.63,9.63,0,0,0,.49,1,10.14,10.14,0,0,0,1.09,1.57C156.59,422,157.14,422.41,157.08,422.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,422.57a2.92,2.92,0,0,1,.61-1.75,6,6,0,0,1,1.35-1.54,6.16,6.16,0,0,1,1-.66,1.54,1.54,0,0,1,1.51-.11.87.87,0,0,1,.35.86,2.29,2.29,0,0,1-.23.67,4.19,4.19,0,0,1-2.43,2.17,2.38,2.38,0,0,1-1.87.08,14.59,14.59,0,0,0,1.7-.49,4.29,4.29,0,0,0,1.47-1.11,3.93,3.93,0,0,0,.57-.9c.17-.36.23-.71.09-.76a1.11,1.11,0,0,0-.88.14,6.83,6.83,0,0,0-.95.57,6.42,6.42,0,0,0-1.33,1.33C157.06,421.94,156.84,422.6,156.74,422.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,277.16s10.58,71,7.4,76.56S156.71,427,156.71,427l-20.48-11,42.63-73.84-8.08-64.85Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.93,277.16s10.58,71,7.4,76.56S156.71,427,156.71,427l-20.48-11,42.63-73.84-8.08-64.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.12,270.31s-3.93,15.1-2,24.21c1.76,8.21,33.48,140.57,33.48,140.57l24.19-3-25.56-153.1Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.12,270.31s-3.93,15.1-2,24.21c1.76,8.21,33.48,140.57,33.48,140.57l24.19-3-25.56-153.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,432c-.14,0-5.15-30.19-11.19-67.49S177.8,297,177.94,297s5.16,30.19,11.2,67.49S200,432,199.82,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,435.09c-.14,0-5.07-20.08-11-44.93s-10.65-45-10.51-45.05,5.07,20.08,11,44.93S175.77,435.06,175.63,435.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.53,355.49a8.42,8.42,0,0,1-2-1.36,24.78,24.78,0,0,1-7-9.24,7.89,7.89,0,0,1-.77-2.29,50.38,50.38,0,0,0,4.14,7A49.3,49.3,0,0,0,194.53,355.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,141.28l8.34,9.27c1.38,1.53,2.84,3.24,3,5.3.13,2.32-1.47,4.72-.55,6.85s3.56,2.72,4.4,4.74c1.2,2.87-2.17,6.14-1.06,9,.87,2.28,4.24,3.57,3.76,6-.26,1.24-1.59,2.24-1.35,3.48.33,1.64,2.77,1.59,4,2.72,2,1.82-.16,5.36,1.14,7.7,1,1.78,3.56,2.11,4.73,3.78a4.36,4.36,0,0,1-.08,4.56,12.73,12.73,0,0,1-3.32,3.43,40.09,40.09,0,0,1-9.28,6.09c-3.42,1.44-7.43,1.88-10.82.36-2.57-1.16-4.54-3.31-6.68-5.16s-4.78-3.47-7.6-3.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,140c-2-.71-8.25,4.8-8.94,6.84s-.82,4.39-2.25,6c-1.26,1.41-3.41,2.1-4,3.88-.76,2.14,1.17,4.57.38,6.7-1,2.62-5.33,2.91-5.88,5.66-.39,2,1.66,4,1.09,5.93s-3.75,2.71-4.06,4.85,2.16,3.43,2.39,5.44c.17,1.49-.91,2.81-1.32,4.25a5.91,5.91,0,0,0,2.09,5.89,9.67,9.67,0,0,0,6.15,2,14.7,14.7,0,0,0,11-4.84c4.81-5.39,4.94-13.34,5.21-20.56a194.57,194.57,0,0,1,3.5-30.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,146.2c-2.65-7.21-12.72-12.15-21.57-10.93-7.44,1-16,7.36-17.46,14.76-2.07,10.74,2.53,22.52-2.25,32.38-5.56,11.47-11.26,7-12.47,24.25-.37,5.2.44,18.12,2.53,22.91,1.07,2.48,2.9,4.88,5.53,5.63,3.28,1,7.82,2.05,10.72.28,7.83-4.77,14.7-4.86,17.38-13.58,4-12.84-3.26-29.71-1.87-40.31s.74-21.35.09-32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.76,193.07c-2.57-3.16-13.69-5.15-14.48-5.15l-25.06-2.17a157.88,157.88,0,0,0-19,6.24l1,26.41,4.92,27.07c-6.66,8-12.93,20-14.33,27.2,18.3,9.54,40.21,10.21,59.5,4.62l-1-27.91Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.49,191.4s8.11,4,11,9.34C221,203.47,226,221.1,226,221.1s-2.54,8.63-18.19,5.85l-2.61-3.07Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.39,192.12a18.3,18.3,0,0,0-7.88,10.34,102.18,102.18,0,0,0-2.43,16l15.34,2.87Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.37,248.56a8.65,8.65,0,0,1,.13-1.49c.15-1,.34-2.4.56-4,.5-3.39,1.21-8.08,2-13.26s1.6-9.85,2.18-13.24c.29-1.62.54-3,.72-4a8,8,0,0,1,.34-1.45,7.4,7.4,0,0,1-.13,1.48c-.15,1.05-.34,2.4-.56,4-.5,3.4-1.21,8.09-2,13.27s-1.6,9.86-2.18,13.24c-.29,1.62-.54,3-.72,4A8,8,0,0,1,202.37,248.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.08,222a3,3,0,0,1,.09,1,11.2,11.2,0,0,1-.34,2.7,12.5,12.5,0,0,1-13.57,9.53,11.16,11.16,0,0,1-2.66-.6,3,3,0,0,1-.9-.42,23.49,23.49,0,0,0,3.59.65,12.63,12.63,0,0,0,13.19-9.26A22.53,22.53,0,0,0,206.08,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42,249.32a51.88,51.88,0,0,1-5.21-1.46,50.71,50.71,0,0,1-5.2-1.5,19.74,19.74,0,0,1,5.34,1A19.54,19.54,0,0,1,168.42,249.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,246a26.53,26.53,0,0,1-6.7,0,26.36,26.36,0,0,1-6.59-1.22c0-.15,3,.36,6.64.7S171.8,245.82,171.8,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.11,245.47a7.12,7.12,0,0,1-.32-1.34c-.17-1-.4-2.22-.67-3.7-.55-3.12-1.26-7.45-2-12.23s-1.42-9.11-1.87-12.25c-.21-1.49-.38-2.74-.51-3.72a6.7,6.7,0,0,1-.12-1.38,7.12,7.12,0,0,1,.32,1.34c.17,1,.4,2.22.67,3.7.55,3.12,1.26,7.45,2,12.23s1.42,9.11,1.87,12.25c.21,1.5.38,2.75.51,3.73A6.66,6.66,0,0,1,158.11,245.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169,237c3.06-.45,4.48-1.85,7-3.19s5.3-2.58,8-1.87c1.91.5,3.49,1.9,5.39,2.41a24,24,0,0,0,4,.4,5,5,0,0,1,3.55,1.61,3.77,3.77,0,0,1,.15,4,6.25,6.25,0,0,1-3.25,2.66,9.61,9.61,0,0,1-6.56.16c-1.68-.57-3.21-1.63-5-1.92a9.63,9.63,0,0,0-4.41.53c-1.42.46-2.8,1.06-4.25,1.41a7.21,7.21,0,0,1-4.41-.13,3.9,3.9,0,0,1-2.53-3.39,2.71,2.71,0,0,1,2.85-2.72"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178,232.34s-.18.23-.57.58a5.93,5.93,0,0,1-.75.6,10.84,10.84,0,0,1-1.06.7,15.69,15.69,0,0,1-3,1.37,18.7,18.7,0,0,1-4,.79,18.19,18.19,0,0,1-4-.21,15.54,15.54,0,0,1-3.18-.92,10.42,10.42,0,0,1-1.15-.54,6.38,6.38,0,0,1-.82-.48c-.44-.29-.67-.46-.65-.49s1,.54,2.75,1.17a17.68,17.68,0,0,0,3.12.79,19.37,19.37,0,0,0,3.94.16,19.89,19.89,0,0,0,3.86-.73,17.3,17.3,0,0,0,3-1.23C177.08,233,178,232.26,178,232.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.84,189.33a5.06,5.06,0,0,1-.11-.8c0-.58-.11-1.35-.2-2.32-.15-2.06-.37-5-.64-8.52-.12-1.8-.26-3.77-.41-5.88s-.52-4.41.13-6.82a4.89,4.89,0,0,1,2.27-3c1.09-.66,2.36-1,3.06-2a5.85,5.85,0,0,0,.75-3.65,12.62,12.62,0,0,1,.3-4.12,8.81,8.81,0,0,1,5.61-5.67,8.19,8.19,0,0,1,3.88-.28,5.53,5.53,0,0,0,1.77,0,2.33,2.33,0,0,0,1.36-.86,6.57,6.57,0,0,0,.91-3.19,11.55,11.55,0,0,1,.62-3.27,8.9,8.9,0,0,1,3.8-4.54,8.13,8.13,0,0,1,4.76-1.12,8.78,8.78,0,0,1,3.55,1,7.44,7.44,0,0,1,1.88,1.38,4.39,4.39,0,0,1,.41.45c.09.11.13.16.12.17a10.64,10.64,0,0,0-2.5-1.82,8.84,8.84,0,0,0-3.48-.91,7.85,7.85,0,0,0-4.55,1.15,8.57,8.57,0,0,0-3.59,4.37,12.21,12.21,0,0,0-.57,3.17,6.88,6.88,0,0,1-1,3.43,2.77,2.77,0,0,1-1.64,1,5.63,5.63,0,0,1-1.92,0,7.76,7.76,0,0,0-3.67.28,8.34,8.34,0,0,0-5.28,5.33,12.45,12.45,0,0,0-.27,4,6.28,6.28,0,0,1-.85,4c-.86,1.16-2.22,1.54-3.23,2.16a4.46,4.46,0,0,0-2.06,2.7c-.62,2.24-.24,4.54-.16,6.65s.24,4.08.35,5.89c.2,3.56.36,6.46.48,8.53l.1,2.32A4.16,4.16,0,0,1,150.84,189.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93,155.49A15.57,15.57,0,0,1,186.11,140a16,16,0,0,1,15.38,15.54c.23,7.28.29,14.6-.06,17.22-1.06,7.88-6.14,10.38-8.16,11.07a10.56,10.56,0,0,1-2.18.26h0s-.06,0-.05.05l.68,9.28c.08,6-3.94,10.92-10.08,11s-10.34-5-10.54-11.06Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,159.66a1.26,1.26,0,0,1-1.21,1.3,1.23,1.23,0,0,1-1.36-1.11,1.26,1.26,0,0,1,1.21-1.3A1.23,1.23,0,0,1,199,159.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,157.44c-.16.17-1.15-.52-2.54-.49s-2.38.74-2.53.57.08-.37.51-.7a3.64,3.64,0,0,1,2-.66,3.49,3.49,0,0,1,2,.6C199.3,157.07,199.45,157.36,199.38,157.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,160.24a1.27,1.27,0,0,1-1.21,1.3,1.23,1.23,0,0,1-1.35-1.11,1.27,1.27,0,0,1,1.2-1.31A1.24,1.24,0,0,1,186,160.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.77,158c-.15.17-1.15-.52-2.53-.49s-2.38.73-2.54.57.08-.37.52-.7a3.53,3.53,0,0,1,2-.66,3.46,3.46,0,0,1,2,.59C185.7,157.61,185.85,157.9,185.77,158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,168a9.06,9.06,0,0,1,2.24-.44c.35-.05.68-.12.74-.36a1.83,1.83,0,0,0-.26-1c-.36-.83-.73-1.7-1.12-2.62a45.84,45.84,0,0,1-2.53-6.87c.16-.06,1.54,2.92,3.09,6.66l1.07,2.64a2,2,0,0,1,.22,1.36.91.91,0,0,1-.57.52,2.43,2.43,0,0,1-.6.09A9.2,9.2,0,0,1,191.06,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,184.07s-5.33.54-12.12-3.27c0,0,2.29,6.9,12.31,5.77Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.56,171.25a2.54,2.54,0,0,0-2.26-.86,2.27,2.27,0,0,0-1.55.86,1.42,1.42,0,0,0-.07,1.63,1.72,1.72,0,0,0,1.83.41,5.28,5.28,0,0,0,1.74-1.08,1.38,1.38,0,0,0,.39-.41.45.45,0,0,0,0-.5",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,169c.23,0,.27,1.46,1.58,2.48s2.91.82,2.93,1-.35.29-1,.33a3.87,3.87,0,0,1-2.44-.78,3.24,3.24,0,0,1-1.23-2.08C186.75,169.35,186.91,169,187,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,155.58c-.12.37-1.51.23-3.13.45s-2.92.69-3.15.37c-.1-.16.12-.51.64-.88a5.53,5.53,0,0,1,4.79-.62C186.08,155.12,186.39,155.41,186.33,155.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,154.67c-.23.31-1.19,0-2.34,0s-2.11.25-2.35-.06c-.1-.16.05-.47.46-.77a3.44,3.44,0,0,1,3.78,0C198.76,154.2,198.9,154.52,198.79,154.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.14,141.34A16.52,16.52,0,0,1,183.06,153l.74-2.18a23.41,23.41,0,0,1-14,9.52,16.2,16.2,0,0,1,5.61-19.45c6.12-4.14,15.41-4.38,20.74.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.15,149.86a17.3,17.3,0,0,0-4.68,3.75,5.87,5.87,0,0,0-1.13,5.65,16,16,0,0,1,1.32,2.78c.6,3.05-3.72,5-4.14,8.08-.38,2.78,2.54,5,2.78,7.83.32,3.59-3.81,6.48-3.43,10.07.2,1.93,1.66,3.44,2.87,5s2.27,3.52,1.54,5.32c-.53,1.32-1.85,2.1-2.87,3.1a8,8,0,0,0-2.15,7.4c.61,2.64,2.54,5.48,1.09,7.78-1.08,1.71-3.49,2-5.49,1.62a9.89,9.89,0,0,1-5.43-2.55,5.86,5.86,0,0,1-1.67-5.58c.54-1.89,2.25-3.67,1.6-5.53-.58-1.63-2.72-2.29-3.29-3.91-.63-1.84,1.05-3.6,1.61-5.46.92-3.06-1.24-6.52,0-9.47.79-1.9,2.82-3.13,3.38-5.11.7-2.51-1.24-5-1.66-7.53a13.07,13.07,0,0,1,.89-6l4.05-13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,191.76s.77-.63,1.93-1.92a5.12,5.12,0,0,0,1.29-2.79,3.28,3.28,0,0,0-.32-1.85,3.19,3.19,0,0,0-1.58-1.36,20.4,20.4,0,0,1-2.25-1.06,3.72,3.72,0,0,1-1.59-2.26,6.23,6.23,0,0,1,0-2.94,11.31,11.31,0,0,1,1.23-2.84c1-1.8,2.35-3.63,2.32-5.85A3.81,3.81,0,0,0,216,166a5,5,0,0,0-3.17-.92,10.06,10.06,0,0,1-3.59-.49,4.15,4.15,0,0,1-2.3-2.7,8.57,8.57,0,0,1-.29-3.39c.1-1.1.27-2.15.32-3.17a10.68,10.68,0,0,0-1.31-5.55,15.48,15.48,0,0,0-3.08-4,31.8,31.8,0,0,0-6-4.26l-1.75-1a5.07,5.07,0,0,1-.6-.38,3.19,3.19,0,0,1,.65.28c.41.21,1,.51,1.8.92a30.14,30.14,0,0,1,6.19,4.17,15.92,15.92,0,0,1,3.21,4.06,11,11,0,0,1,1.41,5.77c-.08,2.1-.72,4.28,0,6.38a3.68,3.68,0,0,0,2,2.38,9.65,9.65,0,0,0,3.41.45,5.41,5.41,0,0,1,3.49,1.05,4.32,4.32,0,0,1,1.32,3.3,7.21,7.21,0,0,1-.84,3.3c-.48,1-1.06,1.9-1.57,2.79a10.13,10.13,0,0,0-1.2,2.71,5.72,5.72,0,0,0-.08,2.72,3.33,3.33,0,0,0,1.39,2,18.46,18.46,0,0,0,2.19,1.07,3.26,3.26,0,0,1,2,3.57,5.23,5.23,0,0,1-1.43,2.89,12.07,12.07,0,0,1-1.5,1.37A3.5,3.5,0,0,1,216.07,191.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,212.34a3.57,3.57,0,0,1,.6-.38c.4-.24,1-.57,1.71-1.06a9.35,9.35,0,0,0,2.3-2.14,4.93,4.93,0,0,0,1-3.86c-.29-1.5-1.47-2.85-2-4.71a5,5,0,0,1,.18-2.94,10.62,10.62,0,0,1,1.55-2.68c1.22-1.68,2.83-3.25,3.51-5.34a4.57,4.57,0,0,0-.16-3.19,12.75,12.75,0,0,0-1.9-2.89,16.41,16.41,0,0,1-2.06-3,5,5,0,0,1-.45-3.51,9.46,9.46,0,0,1,1.48-3.06c.59-.91,1.21-1.77,1.68-2.68a9.19,9.19,0,0,0,.75-5.61c-.23-1.81-.68-3.48-.91-5a11.75,11.75,0,0,1,0-4.27,7,7,0,0,1,1.39-2.92,4.62,4.62,0,0,1,1.59-1.27,2.43,2.43,0,0,1,.67-.23,5.41,5.41,0,0,0-2.1,1.63,6.67,6.67,0,0,0-1.26,2.85,11.67,11.67,0,0,0,.07,4.15c.25,1.54.72,3.2,1,5a9.62,9.62,0,0,1-.76,5.88c-.93,1.89-2.55,3.51-3.09,5.63a4.63,4.63,0,0,0,.42,3.17,16.71,16.71,0,0,0,2,2.85,12.91,12.91,0,0,1,2,3,5.09,5.09,0,0,1,.17,3.54c-.76,2.27-2.42,3.83-3.62,5.48a10.53,10.53,0,0,0-1.5,2.54,4.51,4.51,0,0,0-.19,2.68c.44,1.73,1.63,3.12,1.93,4.75a5.17,5.17,0,0,1-1.1,4.1,9,9,0,0,1-2.42,2.14,19.72,19.72,0,0,1-1.77,1A3.44,3.44,0,0,1,168.9,212.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3,190.8a2.2,2.2,0,0,1-.42-.63,4.25,4.25,0,0,1-.43-2.13,4.55,4.55,0,0,1,1.4-3.13c1-1,2.6-1.34,3.84-2.37a2.65,2.65,0,0,0,1.08-2.11,5.63,5.63,0,0,0-1-2.52,5.33,5.33,0,0,1-1-3,5.4,5.4,0,0,1,1.41-3c.75-.87,1.64-1.58,2.4-2.42a5.43,5.43,0,0,0,1.47-3c.35-2.31-.62-4.84,0-7.47a4.2,4.2,0,0,1,2.44-3,30.22,30.22,0,0,1,3.61-.86,3.06,3.06,0,0,0,2.37-2c.24-1-.21-2.16-.22-3.32a4.32,4.32,0,0,1,1.3-3.07,7.88,7.88,0,0,1,2.61-1.73,31.87,31.87,0,0,1,5.36-1.27,8.91,8.91,0,0,0,4-1.78,7.61,7.61,0,0,0,2-2.67,9.21,9.21,0,0,0,.68-2.79s0,.06,0,.19a3.65,3.65,0,0,1,0,.56,7,7,0,0,1-.51,2.12,7.62,7.62,0,0,1-2,2.81,9.21,9.21,0,0,1-4.13,1.92,33.06,33.06,0,0,0-5.28,1.31A7.26,7.26,0,0,0,172.9,147a3.88,3.88,0,0,0-1.15,2.74c0,1,.49,2.17.23,3.44a2.76,2.76,0,0,1-1,1.59,5.43,5.43,0,0,1-1.69.83,31.75,31.75,0,0,0-3.55.85,3.69,3.69,0,0,0-2.14,2.66c-.64,2.42.31,4.92,0,7.41a5.86,5.86,0,0,1-1.6,3.27c-.8.88-1.7,1.59-2.4,2.41a3.91,3.91,0,0,0-.4,5.46,5.91,5.91,0,0,1,1,2.73,3,3,0,0,1-1.24,2.4,9.91,9.91,0,0,1-2.1,1.22,7.62,7.62,0,0,0-1.79,1.09,4.33,4.33,0,0,0-1.39,2.92,4.73,4.73,0,0,0,.32,2.08C154.16,190.58,154.32,190.79,154.3,190.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.39,214.84s0,0-.15,0a3.82,3.82,0,0,1-.48.09,4.82,4.82,0,0,1-1.83-.19,5.78,5.78,0,0,1-2.51-1.52,5.11,5.11,0,0,1-1.45-3.58,34,34,0,0,1,.78-4.6,5.77,5.77,0,0,0-.16-2.47,19.36,19.36,0,0,0-1.05-2.5,8.31,8.31,0,0,1-.88-2.82,5.13,5.13,0,0,1,.79-3c.51-.92,1.14-1.75,1.55-2.68a3.92,3.92,0,0,0,.18-3c-.3-1-.83-1.94-1.23-2.94a5.07,5.07,0,0,1-.33-3.21c.58-2.09,2.09-3.54,2.6-5.29a4.07,4.07,0,0,0-.06-2.56c-.26-.82-.67-1.59-1-2.38a7.57,7.57,0,0,1-.36-4.68A11.36,11.36,0,0,1,167.3,164a20.06,20.06,0,0,1,1.72-2.35c.51-.62.93-1.07,1.21-1.38a2.65,2.65,0,0,1,.46-.45,3.63,3.63,0,0,1-.38.52l-1.13,1.43a14.55,14.55,0,0,0-3,5.88,7.26,7.26,0,0,0,.4,4.44c.32.76.73,1.52,1,2.4a4.55,4.55,0,0,1,.08,2.83c-.56,1.9-2.07,3.38-2.56,5.28a4.58,4.58,0,0,0,.31,2.9c.38,1,.92,1.9,1.25,3a4.77,4.77,0,0,1,.22,1.68,4.67,4.67,0,0,1-.42,1.63c-.46,1-1.09,1.84-1.58,2.72a4.67,4.67,0,0,0-.75,2.71,8.06,8.06,0,0,0,.82,2.66,19.6,19.6,0,0,1,1.06,2.57,6.19,6.19,0,0,1,.15,2.66,36.87,36.87,0,0,0-.84,4.55,4.78,4.78,0,0,0,1.3,3.37A5.6,5.6,0,0,0,169,214.6,5.87,5.87,0,0,0,171.39,214.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,190.57s-.11,0-.31,0a4.29,4.29,0,0,1-.86-.25,6.23,6.23,0,0,1-3.71-6.73,11.55,11.55,0,0,0,.26-2.75,2.43,2.43,0,0,0-.48-1.25,3.71,3.71,0,0,0-1.12-.89,13.39,13.39,0,0,1-1.35-.81,3.25,3.25,0,0,1-1.06-1.21,5.56,5.56,0,0,1-.29-2.93c.09-.91.26-1.75.28-2.53a10,10,0,0,0-.16-2.18,13.52,13.52,0,0,0-1.58-4.06,3.54,3.54,0,0,1,.73.94,9.76,9.76,0,0,1,1.21,3,10,10,0,0,1,.23,2.27c0,.83-.16,1.68-.24,2.57a5.09,5.09,0,0,0,.28,2.65,4.64,4.64,0,0,0,2.21,1.8,4.12,4.12,0,0,1,1.27,1,2.91,2.91,0,0,1,.58,1.52,12.3,12.3,0,0,1-.29,2.87,5.78,5.78,0,0,0,1,4.41,6.23,6.23,0,0,0,2.35,2.06C214.05,190.44,214.47,190.52,214.46,190.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,237.74c.15-1.54-.68-17-.68-17l-10.18-2-1.44-26.54-11.7.75s-4.76,50.4,1.31,58.54c5.66,7.57,14,3.21,14,3.21S153.94,250.11,155.11,237.74Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59,193.57s2.24-2.86,2.08-5.37-4.39-16.41-4.39-16.41-1.94.18-2.06,3.14a59.36,59.36,0,0,0,.51,6.88l-6.25-9.48c-1.4-2.13-3.65-5.27-4.92-4.85s1.36,4.59,2.12,6.56,1.87,4.75,1.87,4.75-5.71-8.27-7.88-10.08c-1.58-1.32-3,.87-1.5,2.72,0,0-2.27-1.2-2,.83s6,10.08,5.4,10.39-5.67-6-7-5.88c-.73.06-.84,1.16.36,2.82s10.41,14.09,12.07,15.48a5.15,5.15,0,0,0,2.83,1.41Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,188.25a3.86,3.86,0,0,1,1.71-.3,10.47,10.47,0,0,1,4.15.75L137,189v-.18a12.22,12.22,0,0,1,.68-4.27,4.14,4.14,0,0,1,.82-1.6,21.06,21.06,0,0,0-1,5.86v.57l-.37-.15A16.47,16.47,0,0,0,131.51,188.25Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,171.12a44.17,44.17,0,0,1,4,4.91,25,25,0,0,1,3.39,5.38c-.13.07-1.69-2.28-3.81-5.07A35.78,35.78,0,0,1,122,171.12Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.43,195.41c0-.15,1.39-.11,3-.44s2.9-.88,3-.74a7.27,7.27,0,0,1-6,1.18Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.93,248c-.06,0,.24-.73.57-2.07a25,25,0,0,0,.7-5.78c.14-4.94-1.36-11.68-1.93-19.23s-1-14.39-1.28-19.33c-.14-2.42-.25-4.41-.33-5.86,0-.65-.06-1.18-.08-1.6a2.22,2.22,0,0,1,0-.56,2.3,2.3,0,0,1,.1.55c0,.42.1.95.17,1.59.13,1.38.31,3.38.49,5.85.39,4.94.79,11.78,1.44,19.31s2,14.27,1.78,19.29a23.38,23.38,0,0,1-.87,5.83,13.43,13.43,0,0,1-.53,1.51A1.8,1.8,0,0,1,144.93,248Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,222.63s4.77,24.89,3.34,36.56c-.5,4.17-22.19,12.57-22.19,12.57l-5.4-8.93,12.36-11.89-4.74-24C214.9,228.11,220.44,226.6,225.55,222.63Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,282a53.45,53.45,0,0,1-20.33,0v-25.4H196.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,260.41c.5.32,2.21,1.53,3.31,2.27,1.45,1,3.63,5.29,4.73,8A9.9,9.9,0,0,1,207,273c.32,2.3-.47,3-1.58,3.64s-7.86,2.85-8.57,2,0-2,0-2-2,.48-2.85-.63a1.57,1.57,0,0,1,0-2.06s-5.48,2.38-6.82,1.82-.91-1.88-.2-2.43,2.1-1.89,1.86-1.67-3.73.14-3.17-1.29,10-7.38,10-7.38-1-2.08-1.66-4c-.95-2.73-.72-3.14.14-4.08.44-.49,1.57-.31,2.57,3.06A6.1,6.1,0,0,0,198.63,260.41Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.89,262.5s.14-.18.51-.18a1.72,1.72,0,0,1,1.24.76c.39.52.54,1.24.94,1.82a3.46,3.46,0,0,0,.83.77,3,3,0,0,1,.92,1.06,2.73,2.73,0,0,1,0,2.27l-.15-.33a2.5,2.5,0,0,1,1.34,1.32,4.59,4.59,0,0,1,.46,1.35,1.78,1.78,0,0,1-.08,1.24c-.07,0,0-.46-.22-1.18a5.43,5.43,0,0,0-.52-1.21,2.29,2.29,0,0,0-1.12-1.05l-.26-.08.1-.25a2.3,2.3,0,0,0-.07-1.85c-.3-.75-1.18-1-1.68-1.79s-.55-1.43-.84-1.88a1.66,1.66,0,0,0-1-.77C201.08,262.46,200.9,262.54,200.89,262.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5,273.36c.05.14-1.36.65-2.91,1.62s-2.63,2-2.74,1.88a8.56,8.56,0,0,1,5.65-3.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.22,270.07a11,11,0,0,1-2.54,2.12,10.4,10.4,0,0,1-2.85,1.7,10.67,10.67,0,0,1,2.55-2.12A10.44,10.44,0,0,1,199.22,270.07Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.61,266.74a32.75,32.75,0,0,1-3.91,2.59,30.63,30.63,0,0,1-4,2.47,16.63,16.63,0,0,1,3.72-2.91A15.67,15.67,0,0,1,196.61,266.74Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,274a3.29,3.29,0,0,1-.81.49c-.54.27-1.34.64-2.35,1.05a8.26,8.26,0,0,1-1.74.57,2.56,2.56,0,0,1-2.14-.4,4.18,4.18,0,0,1-.44-.4.79.79,0,0,1-.19-.38.87.87,0,0,1,.06-.38,3.88,3.88,0,0,1,.67-1.07,16.8,16.8,0,0,1,1.77-1.82l.25.44a2.65,2.65,0,0,1-2-.05,2,2,0,0,1-1-1.13l0,.07a.7.7,0,0,1,0-.54,1.51,1.51,0,0,1,.18-.36,5,5,0,0,1,.44-.55c.31-.32.64-.61,1-.89.65-.54,1.29-1,1.91-1.48,1.25-.9,2.39-1.65,3.36-2.26s1.76-1.09,2.31-1.41a3.73,3.73,0,0,1,.88-.44,3.89,3.89,0,0,1-.78.61l-2.22,1.53c-.93.65-2.05,1.43-3.27,2.35-.61.45-1.24.94-1.87,1.48a12.19,12.19,0,0,0-.9.86,3.33,3.33,0,0,0-.38.48.57.57,0,0,0-.14.33h0l0,.08a1.61,1.61,0,0,0,.73.82,2.23,2.23,0,0,0,1.63,0l1.13-.36-.88.79a17.79,17.79,0,0,0-1.73,1.75,3.79,3.79,0,0,0-.59.91.37.37,0,0,0,0,.18s0,0,.06.11a2.5,2.5,0,0,0,.37.36,2.17,2.17,0,0,0,1.79.36,9,9,0,0,0,1.69-.49c1-.36,1.83-.68,2.4-.9A4.51,4.51,0,0,1,193.5,274Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,275.2c0,.17-.24.44-.88.66a5.79,5.79,0,0,1-2.82.18,7.62,7.62,0,0,1-3.86-1.9,8,8,0,0,1-1.22-10.05,7.6,7.6,0,0,1,3.31-2.77,5.85,5.85,0,0,1,2.78-.5c.66.06,1,.26,1,.43,0,.39-1.34.57-2.9,1.68a7.31,7.31,0,0,0-2.14,2.4,6.43,6.43,0,0,0,.86,7.11,7.25,7.25,0,0,0,2.65,1.82C176.62,275,178,274.82,178.06,275.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,251.92s.32-.51,1.19-.84a5,5,0,0,1,3.53.06,7.32,7.32,0,0,1,2.85,2c.6.68.87,1.16.82,1.2s-.44-.35-1.08-.94a9.1,9.1,0,0,0-2.78-1.82,5.32,5.32,0,0,0-3.23-.19C213.38,251.65,212.94,252,212.89,251.92Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,257.93a9.65,9.65,0,0,1-2.59.93,22.21,22.21,0,0,1-6.62.65,21.89,21.89,0,0,1-6.52-1.38,9.49,9.49,0,0,1-2.47-1.21c.06-.18,3.86,1.81,9,2.07S193.65,257.74,193.68,257.93Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,457.37H409.79a30.48,30.48,0,0,0,0-27.17H704A31.83,31.83,0,0,0,704,457.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.69,
    y: 427.4,
    width: 305.54,
    height: 8.89,
    rx: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.59,269.53a5.79,5.79,0,1,1-5.79-6A5.91,5.91,0,0,1,423.59,269.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.22,
    y: 273.48,
    width: 5.16,
    height: 153.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.9,269.53a5.79,5.79,0,1,1-5.79-6A5.9,5.9,0,0,1,702.9,269.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.53,
    y: 273.48,
    width: 5.16,
    height: 153.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.8,
    y: 277.62,
    width: 280.81,
    height: 3.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.8,
    y: 414.74,
    width: 279.77,
    height: 3.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81,344.33a.92.92,0,0,1-.06-.34,8.47,8.47,0,0,1,0-1,7.17,7.17,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.71-1.59a4.87,4.87,0,0,1,1.73.81,4.79,4.79,0,0,1,1.31,1.57,7.9,7.9,0,0,1,.77,4.3v0a5.79,5.79,0,0,1-2.33,4.31,9.07,9.07,0,0,1-5.13,1.6A10.3,10.3,0,0,1,482,350a5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.75,20.75,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36c1.62-4.25,3.31-8.65,5-13.16l6.18-16.43c1-2.59,1.87-5.24,1.47-7.83a10.81,10.81,0,0,0-1.07-3.65,6,6,0,0,0-2.51-2.56,7.49,7.49,0,0,0-3.4-.8,10.4,10.4,0,0,0-3.37.43,5.9,5.9,0,0,0-2.67,1.71,6.13,6.13,0,0,0-1.26,2.74,9.8,9.8,0,0,0-.11,2.9,5.73,5.73,0,0,0,.94,2.51,5.92,5.92,0,0,0,4.08,2.33h0a5.1,5.1,0,0,0,4.07-1.74,6,6,0,0,0,1.12-3.18,11.31,11.31,0,0,0,0-2.14c0-.22-.05-.4-.07-.54a1.42,1.42,0,0,1,0-.19,8.15,8.15,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.18,6.18,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,9.93,9.93,0,0,1,.1-3,6.39,6.39,0,0,1,1.33-2.93,6.26,6.26,0,0,1,2.84-1.85,10.53,10.53,0,0,1,3.51-.47,8,8,0,0,1,3.6.84,6.45,6.45,0,0,1,2.72,2.73,11.73,11.73,0,0,1,1.13,3.81c.42,2.72-.46,5.49-1.47,8.07-2,5.25-4,10.76-6.18,16.44l-5.05,13.16a44.13,44.13,0,0,0-2.15,6.29,20.44,20.44,0,0,0-.54,6.28,8.74,8.74,0,0,0,2,5.45,4.91,4.91,0,0,0,2.39,1.36,10,10,0,0,0,2.73.2,8.74,8.74,0,0,0,4.91-1.49,5.45,5.45,0,0,0,2.21-4v0a7.66,7.66,0,0,0-.7-4.11,4.63,4.63,0,0,0-1.2-1.48,4.85,4.85,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.33,5.33,0,0,0-.91,2,8.69,8.69,0,0,0-.23,1.62c0,.44,0,.77,0,1A2.17,2.17,0,0,1,481.81,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81,409.25a1.09,1.09,0,0,1-.06-.34,8.77,8.77,0,0,1,0-1,7.17,7.17,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.71-1.59a5.05,5.05,0,0,1,1.73.81,4.79,4.79,0,0,1,1.31,1.57,7.9,7.9,0,0,1,.77,4.3v0a5.77,5.77,0,0,1-2.33,4.31,9.07,9.07,0,0,1-5.13,1.6A9.93,9.93,0,0,1,482,415a5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.77,20.77,0,0,1,.54-6.44A43.34,43.34,0,0,1,479.9,395c1.62-4.25,3.31-8.65,5-13.16,2.14-5.68,4.21-11.18,6.18-16.43,1-2.58,1.87-5.24,1.47-7.83a10.81,10.81,0,0,0-1.07-3.65,5.89,5.89,0,0,0-2.51-2.55,7.5,7.5,0,0,0-3.4-.81,10.4,10.4,0,0,0-3.37.43,5.9,5.9,0,0,0-2.67,1.71,6.17,6.17,0,0,0-1.26,2.75,9.8,9.8,0,0,0-.11,2.9,5.74,5.74,0,0,0,.94,2.5,5.88,5.88,0,0,0,4.08,2.33h0a5.07,5.07,0,0,0,4.07-1.74,6,6,0,0,0,1.12-3.17,11.28,11.28,0,0,0,0-2.14c0-.23-.05-.41-.07-.55a1.29,1.29,0,0,1,0-.19,8.15,8.15,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.14,6.14,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,9.94,9.94,0,0,1,.1-3,6.44,6.44,0,0,1,1.33-2.93,6.26,6.26,0,0,1,2.84-1.85,10.53,10.53,0,0,1,3.51-.46,7.81,7.81,0,0,1,3.6.83,6.42,6.42,0,0,1,2.72,2.74,11.59,11.59,0,0,1,1.13,3.81c.42,2.72-.46,5.49-1.47,8.07L485.42,382l-5.05,13.16a44.13,44.13,0,0,0-2.15,6.29,20.51,20.51,0,0,0-.54,6.29,8.73,8.73,0,0,0,2,5.44,5,5,0,0,0,2.39,1.37,10,10,0,0,0,2.73.19,8.81,8.81,0,0,0,4.91-1.48,5.47,5.47,0,0,0,2.21-4v0a7.68,7.68,0,0,0-.7-4.11,4.74,4.74,0,0,0-1.2-1.48,4.64,4.64,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.3,5.3,0,0,0-.91,2,8.49,8.49,0,0,0-.23,1.61c0,.44,0,.78,0,1A2.32,2.32,0,0,1,481.81,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.34,344.38a2.31,2.31,0,0,1,0-.35,10.62,10.62,0,0,0-.2-2.61,5.09,5.09,0,0,0-.88-2c-.92-1.39-3.16-2.12-5.45-1.53a4.73,4.73,0,0,0-1.63.75,4.5,4.5,0,0,0-1.23,1.46,7.62,7.62,0,0,0-.76,4.1v0a5.43,5.43,0,0,0,2.15,4,8.64,8.64,0,0,0,4.88,1.56,9.7,9.7,0,0,0,2.74-.15,5.08,5.08,0,0,0,2.41-1.32,8.79,8.79,0,0,0,2.11-5.42,20.43,20.43,0,0,0-.45-6.29A42.67,42.67,0,0,0,474,330.3q-2.34-6.42-4.85-13.24c-2-5.71-4-11.25-5.92-16.53-1-2.6-1.82-5.38-1.35-8.09a11.32,11.32,0,0,1,1.18-3.79,6.53,6.53,0,0,1,2.76-2.7,8,8,0,0,1,3.62-.78,10.5,10.5,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.33,6.33,0,0,1,1.29,3,9.9,9.9,0,0,1,.05,3,5.75,5.75,0,0,1-5.43,5h0a5.33,5.33,0,0,1-4.22-2,6.18,6.18,0,0,1-1.05-3.31,8.32,8.32,0,0,1,.3-2.88s0,.06,0,.18-.05.33-.08.55a11.41,11.41,0,0,0-.05,2.14,6.1,6.1,0,0,0,1.08,3.19,5.12,5.12,0,0,0,4.05,1.81h0a5.92,5.92,0,0,0,4.12-2.27,5.82,5.82,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,6,6,0,0,0-1.23-2.76,5.87,5.87,0,0,0-2.64-1.76,10.31,10.31,0,0,0-3.36-.48,7.51,7.51,0,0,0-3.41.75,6.07,6.07,0,0,0-2.56,2.51,11,11,0,0,0-1.11,3.64c-.44,2.58.37,5.25,1.35,7.85,1.89,5.28,3.88,10.81,5.93,16.52l4.84,13.24a43.74,43.74,0,0,1,2.07,6.4A21,21,0,0,1,477,343a9.28,9.28,0,0,1-2.27,5.69,5.33,5.33,0,0,1-2.63,1.43,10.34,10.34,0,0,1-2.87.15,9.06,9.06,0,0,1-5.09-1.68,5.81,5.81,0,0,1-2.28-4.35v0a7.87,7.87,0,0,1,.84-4.29,4.7,4.7,0,0,1,1.32-1.54,4.91,4.91,0,0,1,1.75-.79c2.38-.59,4.73.2,5.69,1.69a5.43,5.43,0,0,1,.86,2.09,8.27,8.27,0,0,1,.16,1.65,7.87,7.87,0,0,1-.06,1A1.48,1.48,0,0,1,472.34,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,409.48a3.09,3.09,0,0,1,0-.35,8.11,8.11,0,0,0,0-1,8.38,8.38,0,0,0-.22-1.61,5.23,5.23,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.47-1.48a4.86,4.86,0,0,0-1.63.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.7,8.7,0,0,0,4.9,1.52,10.09,10.09,0,0,0,2.74-.17,5.07,5.07,0,0,0,2.39-1.35,8.8,8.8,0,0,0,2.07-5.44,20.72,20.72,0,0,0-.51-6.28,43.68,43.68,0,0,0-2.11-6.31c-1.61-4.26-3.27-8.67-5-13.19-2.1-5.69-4.14-11.22-6.07-16.47-1-2.59-1.87-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.37,6.37,0,0,1,2.73-2.71,7.87,7.87,0,0,1,3.61-.82,10.84,10.84,0,0,1,3.51.49,6.32,6.32,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,10.24,10.24,0,0,1,.08,3,5.79,5.79,0,0,1-5.39,5h0a5.36,5.36,0,0,1-4.24-1.92,6.08,6.08,0,0,1-1.07-3.3,8.26,8.26,0,0,1,.26-2.89.69.69,0,0,1,0,.19l-.07.55a10.85,10.85,0,0,0,0,2.13,6,6,0,0,0,1.1,3.19,5.06,5.06,0,0,0,4.06,1.76h0a5.93,5.93,0,0,0,4.1-2.31,5.82,5.82,0,0,0,.95-2.5,9.79,9.79,0,0,0-.1-2.9,6.07,6.07,0,0,0-1.24-2.75,6,6,0,0,0-2.66-1.73,10.12,10.12,0,0,0-3.36-.45,7.67,7.67,0,0,0-3.41.78,6,6,0,0,0-2.53,2.54,11,11,0,0,0-1.09,3.65c-.41,2.58.42,5.24,1.42,7.84,1.94,5.25,4,10.77,6.09,16.46l5,13.2a42.81,42.81,0,0,1,2.11,6.37,20.73,20.73,0,0,1,.5,6.44,9.23,9.23,0,0,1-2.21,5.71,5.46,5.46,0,0,1-2.62,1.45,10.32,10.32,0,0,1-2.86.18,9.11,9.11,0,0,1-5.12-1.63,5.77,5.77,0,0,1-2.31-4.33v0a8,8,0,0,1,.81-4.29,4.53,4.53,0,0,1,3-2.36c2.38-.62,4.74.15,5.71,1.63a5.24,5.24,0,0,1,.88,2.08,8.3,8.3,0,0,1,.17,1.65,8.69,8.69,0,0,1,0,1A1.66,1.66,0,0,1,472,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,416.93c-.15,0-.26-30.4-.26-67.9s.11-67.91.26-67.91.26,30.4.26,67.91S493.1,416.93,493,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.26,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S461.41,416.93,461.26,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.06,344.33A1.89,1.89,0,0,1,450,344a5.61,5.61,0,0,1,0-1,7.68,7.68,0,0,1,.18-1.64,5.43,5.43,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a4.87,4.87,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.77,5.77,0,0,1-2.34,4.31,9.06,9.06,0,0,1-5.12,1.6,10.4,10.4,0,0,1-2.87-.2,5.4,5.4,0,0,1-2.6-1.47,9.25,9.25,0,0,1-2.18-5.72,20.75,20.75,0,0,1,.54-6.44,43.29,43.29,0,0,1,2.15-6.36c1.63-4.25,3.32-8.65,5-13.16,2.14-5.68,4.22-11.19,6.19-16.43,1-2.59,1.87-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,6,6,0,0,0-2.51-2.56,7.56,7.56,0,0,0-3.41-.8,10.47,10.47,0,0,0-3.37.43,5.51,5.51,0,0,0-3.92,4.45,9.81,9.81,0,0,0-.12,2.9,5.85,5.85,0,0,0,.94,2.51,5.94,5.94,0,0,0,4.08,2.33h0a5.1,5.1,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.18,11.14,11.14,0,0,0,0-2.14c0-.22-.05-.4-.06-.54s0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.19,6.19,0,0,1-4.33-2.42,6.1,6.1,0,0,1-1-2.65,10.25,10.25,0,0,1,.09-3,6.5,6.5,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.47,8,8,0,0,1,3.61.84,6.43,6.43,0,0,1,2.71,2.73,11.26,11.26,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07l-6.17,16.44-5.05,13.16a42.91,42.91,0,0,0-2.15,6.29,20.45,20.45,0,0,0-.55,6.28,8.86,8.86,0,0,0,2,5.45,5,5,0,0,0,2.39,1.36,10.11,10.11,0,0,0,2.74.2,8.68,8.68,0,0,0,4.9-1.49,5.43,5.43,0,0,0,2.22-4v0a7.57,7.57,0,0,0-.71-4.11,4.38,4.38,0,0,0-1.2-1.48,4.8,4.8,0,0,0-1.61-.78c-2.29-.62-4.54.06-5.49,1.44a5.29,5.29,0,0,0-.9,2,8.69,8.69,0,0,0-.23,1.62,8.58,8.58,0,0,0,0,1A1.44,1.44,0,0,1,450.06,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.06,409.25a2.48,2.48,0,0,1-.05-.34,5.79,5.79,0,0,1,0-1,7.68,7.68,0,0,1,.18-1.64,5.43,5.43,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a5.05,5.05,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.75,5.75,0,0,1-2.34,4.31,9.06,9.06,0,0,1-5.12,1.6,10,10,0,0,1-2.87-.2,5.4,5.4,0,0,1-2.6-1.47,9.25,9.25,0,0,1-2.18-5.72,20.77,20.77,0,0,1,.54-6.44,43.29,43.29,0,0,1,2.15-6.36c1.63-4.25,3.32-8.65,5-13.16,2.14-5.68,4.22-11.18,6.19-16.43,1-2.58,1.87-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,5.94,5.94,0,0,0-2.51-2.55,7.57,7.57,0,0,0-3.41-.81,10.47,10.47,0,0,0-3.37.43,5.5,5.5,0,0,0-3.92,4.46,9.81,9.81,0,0,0-.12,2.9,5.46,5.46,0,0,0,5,4.83h0a5.07,5.07,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.17,11.1,11.1,0,0,0,0-2.14c0-.23-.05-.41-.06-.55s0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a5.76,5.76,0,0,1-5.35-5.07,10.26,10.26,0,0,1,.09-3,6.54,6.54,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.46,7.85,7.85,0,0,1,3.61.83,6.4,6.4,0,0,1,2.71,2.74,11.13,11.13,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07L453.68,382l-5.05,13.16a42.91,42.91,0,0,0-2.15,6.29,20.52,20.52,0,0,0-.55,6.29,8.85,8.85,0,0,0,2,5.44,5.11,5.11,0,0,0,2.39,1.37,10.1,10.1,0,0,0,2.74.19,8.75,8.75,0,0,0,4.9-1.48,5.45,5.45,0,0,0,2.22-4v0a7.59,7.59,0,0,0-.71-4.11,4.47,4.47,0,0,0-1.2-1.48,4.59,4.59,0,0,0-1.61-.77c-2.29-.63-4.54.06-5.49,1.43a5.27,5.27,0,0,0-.9,2,8.49,8.49,0,0,0-.23,1.61,8.59,8.59,0,0,0,0,1A1.59,1.59,0,0,1,450.06,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.59,344.38s0-.12,0-.35,0-.56,0-1a7.56,7.56,0,0,0-.21-1.61,5.06,5.06,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.81,4.81,0,0,0-1.63.75,4.47,4.47,0,0,0-1.22,1.46,7.72,7.72,0,0,0-.77,4.1v0a5.44,5.44,0,0,0,2.16,4,8.62,8.62,0,0,0,4.88,1.56,9.7,9.7,0,0,0,2.74-.15,5.12,5.12,0,0,0,2.41-1.32,8.85,8.85,0,0,0,2.11-5.42,20.74,20.74,0,0,0-.45-6.29,43.88,43.88,0,0,0-2.06-6.32c-1.56-4.28-3.19-8.7-4.85-13.24-2.05-5.71-4-11.25-5.92-16.53-1-2.6-1.82-5.38-1.35-8.09a11.32,11.32,0,0,1,1.18-3.79,6.47,6.47,0,0,1,2.76-2.7,8,8,0,0,1,3.62-.78,10.54,10.54,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.54,6.54,0,0,1,1.29,3,10.23,10.23,0,0,1,.05,3,6.05,6.05,0,0,1-1.07,2.64,6.2,6.2,0,0,1-4.36,2.35h0a5.29,5.29,0,0,1-4.21-2,6.09,6.09,0,0,1-1.05-3.31,8.2,8.2,0,0,1,.29-2.88s0,.06,0,.18,0,.33-.07.55a11.41,11.41,0,0,0-.05,2.14,6,6,0,0,0,1.07,3.19,5.13,5.13,0,0,0,4.05,1.81h0A5.94,5.94,0,0,0,444,296a5.68,5.68,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,5.54,5.54,0,0,0-3.86-4.52,10.35,10.35,0,0,0-3.36-.48,7.55,7.55,0,0,0-3.42.75,6,6,0,0,0-2.55,2.51,11,11,0,0,0-1.12,3.64c-.43,2.58.37,5.25,1.35,7.85l5.94,16.52,4.84,13.24a43.68,43.68,0,0,1,2.06,6.4,20.68,20.68,0,0,1,.44,6.44,9.21,9.21,0,0,1-2.26,5.69,5.38,5.38,0,0,1-2.63,1.43,10.34,10.34,0,0,1-2.87.15,9.06,9.06,0,0,1-5.1-1.68,5.8,5.8,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.85,4.85,0,0,1,1.33-1.54,5,5,0,0,1,1.74-.79c2.39-.59,4.74.2,5.69,1.69a5.28,5.28,0,0,1,.86,2.09,7.58,7.58,0,0,1,.16,1.65,8.25,8.25,0,0,1,0,1A1.14,1.14,0,0,1,440.59,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.28,409.48a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a8.38,8.38,0,0,0-.22-1.61,5.27,5.27,0,0,0-.9-2c-.94-1.39-3.18-2.09-5.47-1.48a4.73,4.73,0,0,0-1.62.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.68,8.68,0,0,0,4.9,1.52,10,10,0,0,0,2.73-.17,5.05,5.05,0,0,0,2.4-1.35,8.85,8.85,0,0,0,2.06-5.44,20.4,20.4,0,0,0-.5-6.28,43.74,43.74,0,0,0-2.12-6.31l-5-13.19-6.08-16.47c-1-2.59-1.86-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.45,6.45,0,0,1,2.74-2.71,7.84,7.84,0,0,1,3.61-.82,10.74,10.74,0,0,1,3.5.49,6.26,6.26,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,9.92,9.92,0,0,1,.08,3,6,6,0,0,1-1,2.64,6.17,6.17,0,0,1-4.34,2.4h0a5.34,5.34,0,0,1-4.23-1.92,6.19,6.19,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89s0,.07,0,.19l-.07.55a10.85,10.85,0,0,0,0,2.13,6.09,6.09,0,0,0,1.1,3.19,5.1,5.1,0,0,0,4.07,1.76h0a5.89,5.89,0,0,0,4.09-2.31,5.71,5.71,0,0,0,1-2.5,9.79,9.79,0,0,0-.1-2.9,6,6,0,0,0-1.25-2.75,5.9,5.9,0,0,0-2.65-1.73,10.14,10.14,0,0,0-3.37-.45,7.63,7.63,0,0,0-3.4.78,6,6,0,0,0-2.53,2.54,10.76,10.76,0,0,0-1.09,3.65c-.41,2.58.42,5.24,1.42,7.84L437.32,382l5,13.2a42.86,42.86,0,0,1,2.12,6.37,21,21,0,0,1,.5,6.44,9.29,9.29,0,0,1-2.22,5.71,5.39,5.39,0,0,1-2.61,1.45,10.37,10.37,0,0,1-2.87.18,9.1,9.1,0,0,1-5.11-1.63,5.77,5.77,0,0,1-2.31-4.33v0a7.86,7.86,0,0,1,.8-4.29,4.65,4.65,0,0,1,1.31-1.56,4.8,4.8,0,0,1,1.74-.8c2.38-.62,4.74.15,5.71,1.63a5.36,5.36,0,0,1,.87,2.08,7.7,7.7,0,0,1,.18,1.65,6.62,6.62,0,0,1-.05,1A1.09,1.09,0,0,1,440.28,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.21,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S461.36,416.93,461.21,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.52,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S429.66,416.93,429.52,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.18,344.33a.92.92,0,0,1-.06-.34,6.75,6.75,0,0,1,0-1,7.68,7.68,0,0,1,.18-1.64,5.43,5.43,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a4.87,4.87,0,0,1,1.73.81,4.64,4.64,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.77,5.77,0,0,1-2.34,4.31,9,9,0,0,1-5.12,1.6,10.3,10.3,0,0,1-2.86-.2,5.38,5.38,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.75,20.75,0,0,1,.54-6.44,43.29,43.29,0,0,1,2.15-6.36c1.63-4.25,3.32-8.65,5-13.16,2.14-5.68,4.22-11.19,6.19-16.43,1-2.59,1.87-5.24,1.47-7.83a11,11,0,0,0-1.07-3.65,6,6,0,0,0-2.51-2.56,7.52,7.52,0,0,0-3.4-.8,10.4,10.4,0,0,0-3.37.43,5.5,5.5,0,0,0-3.93,4.45,9.81,9.81,0,0,0-.12,2.9,5.48,5.48,0,0,0,5,4.84h0a5.1,5.1,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.18,11.14,11.14,0,0,0,0-2.14l-.06-.54c0-.13,0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.19,6.19,0,0,1-4.33-2.42,6.1,6.1,0,0,1-1-2.65,9.93,9.93,0,0,1,.1-3,5.86,5.86,0,0,1,4.17-4.78,10.51,10.51,0,0,1,3.5-.47,8,8,0,0,1,3.61.84,6.45,6.45,0,0,1,2.72,2.73,11.47,11.47,0,0,1,1.12,3.81c.43,2.72-.46,5.49-1.46,8.07-2,5.25-4,10.76-6.18,16.44l-5,13.16a44.13,44.13,0,0,0-2.15,6.29,20.44,20.44,0,0,0-.54,6.28,8.74,8.74,0,0,0,2,5.45,4.93,4.93,0,0,0,2.38,1.36,10.11,10.11,0,0,0,2.74.2,8.68,8.68,0,0,0,4.9-1.49,5.43,5.43,0,0,0,2.22-4v0a7.57,7.57,0,0,0-.71-4.11,4.38,4.38,0,0,0-1.2-1.48,4.71,4.71,0,0,0-1.61-.78c-2.28-.62-4.54.06-5.48,1.44a5.17,5.17,0,0,0-.91,2,8.69,8.69,0,0,0-.23,1.62c0,.44,0,.77,0,1S545.18,344.33,545.18,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.18,409.25a1.09,1.09,0,0,1-.06-.34,7,7,0,0,1,0-1,7.68,7.68,0,0,1,.18-1.64,5.43,5.43,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a5.05,5.05,0,0,1,1.73.81,4.64,4.64,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.75,5.75,0,0,1-2.34,4.31,9,9,0,0,1-5.12,1.6,9.93,9.93,0,0,1-2.86-.2,5.38,5.38,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.77,20.77,0,0,1,.54-6.44,43.29,43.29,0,0,1,2.15-6.36c1.63-4.25,3.32-8.65,5-13.16,2.14-5.68,4.22-11.18,6.19-16.43,1-2.58,1.87-5.24,1.47-7.83a11,11,0,0,0-1.07-3.65,5.94,5.94,0,0,0-2.51-2.55,7.53,7.53,0,0,0-3.4-.81,10.4,10.4,0,0,0-3.37.43,5.49,5.49,0,0,0-3.93,4.46,9.81,9.81,0,0,0-.12,2.9,5.49,5.49,0,0,0,5,4.83h0a5.07,5.07,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.17,11.1,11.1,0,0,0,0-2.14l-.06-.55c0-.12,0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a5.76,5.76,0,0,1-5.35-5.07,9.94,9.94,0,0,1,.1-3,6.42,6.42,0,0,1,1.32-2.93,6.34,6.34,0,0,1,2.85-1.85,10.5,10.5,0,0,1,3.5-.46,7.85,7.85,0,0,1,3.61.83,6.42,6.42,0,0,1,2.72,2.74,11.34,11.34,0,0,1,1.12,3.81c.43,2.72-.46,5.49-1.46,8.07-2,5.24-4,10.75-6.18,16.43l-5,13.16a44.13,44.13,0,0,0-2.15,6.29,20.51,20.51,0,0,0-.54,6.29,8.73,8.73,0,0,0,2,5.44,5,5,0,0,0,2.38,1.37,10.1,10.1,0,0,0,2.74.19,8.75,8.75,0,0,0,4.9-1.48,5.45,5.45,0,0,0,2.22-4v0a7.59,7.59,0,0,0-.71-4.11,4.2,4.2,0,0,0-2.81-2.25c-2.28-.63-4.54.06-5.48,1.43a5.15,5.15,0,0,0-.91,2,8.49,8.49,0,0,0-.23,1.61c0,.44,0,.78,0,1S545.18,409.24,545.18,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.71,344.38a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a7.56,7.56,0,0,0-.21-1.61,5.06,5.06,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.68,4.68,0,0,0-1.62.75,4.38,4.38,0,0,0-1.23,1.46,7.72,7.72,0,0,0-.77,4.1v0a5.43,5.43,0,0,0,2.15,4,8.62,8.62,0,0,0,4.88,1.56,9.7,9.7,0,0,0,2.74-.15,5.12,5.12,0,0,0,2.41-1.32,8.85,8.85,0,0,0,2.11-5.42,20.74,20.74,0,0,0-.45-6.29,43.88,43.88,0,0,0-2.06-6.32c-1.56-4.28-3.19-8.7-4.85-13.24-2-5.71-4-11.25-5.92-16.53-1-2.6-1.82-5.38-1.35-8.09a11.32,11.32,0,0,1,1.18-3.79,6.47,6.47,0,0,1,2.76-2.7,8,8,0,0,1,3.62-.78,10.54,10.54,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.54,6.54,0,0,1,1.29,3,10.23,10.23,0,0,1,.05,3,6.16,6.16,0,0,1-1.06,2.64,6.24,6.24,0,0,1-4.37,2.35h0a5.29,5.29,0,0,1-4.21-2,6.09,6.09,0,0,1-1-3.31,8.2,8.2,0,0,1,.29-2.88s0,.06,0,.18,0,.33-.07.55a11.41,11.41,0,0,0,0,2.14,6.08,6.08,0,0,0,1.07,3.19,5.13,5.13,0,0,0,4,1.81h0a5.92,5.92,0,0,0,4.12-2.27,5.82,5.82,0,0,0,1-2.49,9.78,9.78,0,0,0-.08-2.9,5.54,5.54,0,0,0-3.86-4.52,10.31,10.31,0,0,0-3.36-.48,7.58,7.58,0,0,0-3.42.75,6,6,0,0,0-2.55,2.51,11,11,0,0,0-1.12,3.64c-.43,2.58.38,5.25,1.35,7.85L533,316.88l4.84,13.24a43.68,43.68,0,0,1,2.06,6.4,20.68,20.68,0,0,1,.44,6.44,9.21,9.21,0,0,1-2.26,5.69,5.38,5.38,0,0,1-2.63,1.43,10.34,10.34,0,0,1-2.87.15,9.12,9.12,0,0,1-5.1-1.68,5.83,5.83,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.85,4.85,0,0,1,1.33-1.54,5,5,0,0,1,1.74-.79c2.39-.59,4.74.2,5.69,1.69a5.28,5.28,0,0,1,.86,2.09,7.67,7.67,0,0,1,.17,1.65c0,.44,0,.78-.06,1A2.85,2.85,0,0,1,535.71,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.39,409.48s0-.12,0-.35,0-.56,0-1a8.38,8.38,0,0,0-.22-1.61,5.39,5.39,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.48-1.48a4.82,4.82,0,0,0-1.62.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.7,8.7,0,0,0,4.9,1.52,10,10,0,0,0,2.73-.17,5.05,5.05,0,0,0,2.4-1.35,8.85,8.85,0,0,0,2.06-5.44,20.4,20.4,0,0,0-.5-6.28,43.68,43.68,0,0,0-2.11-6.31c-1.61-4.26-3.27-8.67-5-13.19l-6.08-16.47c-1-2.59-1.86-5.37-1.42-8.08a11.17,11.17,0,0,1,1.16-3.81,6.37,6.37,0,0,1,2.73-2.71,7.87,7.87,0,0,1,3.61-.82,10.74,10.74,0,0,1,3.5.49,6.26,6.26,0,0,1,2.83,1.87,6.45,6.45,0,0,1,1.32,2.94,9.91,9.91,0,0,1,.07,3,6,6,0,0,1-1,2.64,6.15,6.15,0,0,1-4.34,2.4h0a5.34,5.34,0,0,1-4.23-1.92,6.19,6.19,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89s0,.07,0,.19,0,.32-.07.55a12.7,12.7,0,0,0,0,2.13,6.11,6.11,0,0,0,1.11,3.19,5.06,5.06,0,0,0,4.06,1.76h0a5.89,5.89,0,0,0,4.09-2.31,5.71,5.71,0,0,0,1-2.5,9.79,9.79,0,0,0-.1-2.9,6.07,6.07,0,0,0-1.24-2.75,6,6,0,0,0-2.66-1.73,10.14,10.14,0,0,0-3.37-.45,7.63,7.63,0,0,0-3.4.78,6,6,0,0,0-2.53,2.54,11,11,0,0,0-1.09,3.65c-.41,2.58.42,5.24,1.42,7.84L532.43,382l5,13.2a42.86,42.86,0,0,1,2.12,6.37A20.73,20.73,0,0,1,540,408a9.24,9.24,0,0,1-2.22,5.71,5.39,5.39,0,0,1-2.61,1.45,10.37,10.37,0,0,1-2.87.18,9.1,9.1,0,0,1-5.11-1.63,5.77,5.77,0,0,1-2.31-4.33v0a8,8,0,0,1,.8-4.29,4.79,4.79,0,0,1,1.32-1.56,4.68,4.68,0,0,1,1.73-.8c2.38-.62,4.74.15,5.71,1.63a5.39,5.39,0,0,1,.88,2.08,8.3,8.3,0,0,1,.17,1.65,6.62,6.62,0,0,1,0,1A1.09,1.09,0,0,1,535.39,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.32,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S556.47,416.93,556.32,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.63,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S524.78,416.93,524.63,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.43,344.33a1.32,1.32,0,0,1-.06-.34,8.6,8.6,0,0,1,.15-2.65,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a5,5,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.83,5.83,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6,10.35,10.35,0,0,1-2.86-.2,5.35,5.35,0,0,1-2.6-1.47,9.19,9.19,0,0,1-2.18-5.72,21,21,0,0,1,.53-6.44,43.34,43.34,0,0,1,2.16-6.36l5-13.16c2.14-5.68,4.21-11.19,6.19-16.43,1-2.59,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,6,6,0,0,0-2.51-2.56,7.56,7.56,0,0,0-3.41-.8,10.4,10.4,0,0,0-3.37.43,5.87,5.87,0,0,0-2.66,1.71,6,6,0,0,0-1.27,2.74,9.8,9.8,0,0,0-.11,2.9,5.73,5.73,0,0,0,.94,2.51,5.94,5.94,0,0,0,4.08,2.33h0a5.1,5.1,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.18,12,12,0,0,0,0-2.14c0-.22,0-.4-.07-.54s0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.35,5.35,0,0,1-4.25,1.88h0a6.19,6.19,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,10.25,10.25,0,0,1,.09-3,6.5,6.5,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.47,8,8,0,0,1,3.61.84,6.49,6.49,0,0,1,2.71,2.73,11.26,11.26,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07l-6.17,16.44-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.45,20.45,0,0,0-.55,6.28,8.86,8.86,0,0,0,2,5.45,5,5,0,0,0,2.39,1.36,10,10,0,0,0,2.73.2,8.71,8.71,0,0,0,4.91-1.49,5.39,5.39,0,0,0,2.21-4v0a7.76,7.76,0,0,0-.71-4.11,4.38,4.38,0,0,0-1.2-1.48,4.76,4.76,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.14,5.14,0,0,0-.9,2,7.92,7.92,0,0,0-.23,1.62,8.58,8.58,0,0,0,0,1A2.86,2.86,0,0,1,513.43,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.43,409.25a1.66,1.66,0,0,1-.06-.34,8.77,8.77,0,0,1,0-1,8.5,8.5,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a5.14,5.14,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.82,5.82,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6,10,10,0,0,1-2.86-.2,5.35,5.35,0,0,1-2.6-1.47,9.19,9.19,0,0,1-2.18-5.72,21.07,21.07,0,0,1,.53-6.44,43.34,43.34,0,0,1,2.16-6.36l5-13.16,6.19-16.43c1-2.58,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,5.94,5.94,0,0,0-2.51-2.55,7.57,7.57,0,0,0-3.41-.81,10.4,10.4,0,0,0-3.37.43,5.87,5.87,0,0,0-2.66,1.71,6.08,6.08,0,0,0-1.27,2.75,9.8,9.8,0,0,0-.11,2.9,5.74,5.74,0,0,0,.94,2.5,5.9,5.9,0,0,0,4.08,2.33h0a5.07,5.07,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.17,12,12,0,0,0,0-2.14c0-.23,0-.41-.07-.55a.69.69,0,0,1,0-.19,8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.35,5.35,0,0,1-4.25,1.88h0a6.16,6.16,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,10.26,10.26,0,0,1,.09-3,6.54,6.54,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.46,7.88,7.88,0,0,1,3.61.83,6.46,6.46,0,0,1,2.71,2.74,11.13,11.13,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07L517.05,382l-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.52,20.52,0,0,0-.55,6.29,8.85,8.85,0,0,0,2,5.44,5.11,5.11,0,0,0,2.39,1.37,10,10,0,0,0,2.73.19,8.78,8.78,0,0,0,4.91-1.48,5.41,5.41,0,0,0,2.21-4v0a7.78,7.78,0,0,0-.71-4.11,4.47,4.47,0,0,0-1.2-1.48,4.55,4.55,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.12,5.12,0,0,0-.9,2,7.75,7.75,0,0,0-.23,1.61,8.59,8.59,0,0,0,0,1A3.18,3.18,0,0,1,513.43,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,344.38a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a8.27,8.27,0,0,0-.21-1.61,5.21,5.21,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.81,4.81,0,0,0-1.63.75,4.47,4.47,0,0,0-1.22,1.46,7.63,7.63,0,0,0-.77,4.1v0a5.46,5.46,0,0,0,2.15,4,8.67,8.67,0,0,0,4.89,1.56,9.61,9.61,0,0,0,2.73-.15,5,5,0,0,0,2.41-1.32,8.8,8.8,0,0,0,2.12-5.42,20.44,20.44,0,0,0-.46-6.29,42.61,42.61,0,0,0-2.05-6.32l-4.85-13.24c-2.05-5.71-4-11.25-5.93-16.53-1-2.6-1.81-5.38-1.35-8.09a11.57,11.57,0,0,1,1.19-3.79,6.45,6.45,0,0,1,2.75-2.7,8,8,0,0,1,3.62-.78,10.46,10.46,0,0,1,3.5.53,6.27,6.27,0,0,1,2.82,1.89,6.41,6.41,0,0,1,1.28,3,10.23,10.23,0,0,1,.06,3,5.78,5.78,0,0,1-5.44,5h0a5.29,5.29,0,0,1-4.21-2,6.09,6.09,0,0,1-1.05-3.31,8.2,8.2,0,0,1,.29-2.88s0,.06,0,.18,0,.33-.07.55a10.6,10.6,0,0,0-.05,2.14,6,6,0,0,0,1.07,3.19,5.12,5.12,0,0,0,4.05,1.81h0a5.9,5.9,0,0,0,4.11-2.27,5.82,5.82,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,5.54,5.54,0,0,0-3.86-4.52,10.39,10.39,0,0,0-3.36-.48,7.55,7.55,0,0,0-3.42.75,6,6,0,0,0-2.55,2.51,11,11,0,0,0-1.12,3.64c-.44,2.58.37,5.25,1.35,7.85,1.89,5.28,3.89,10.81,5.94,16.52l4.84,13.24a43.68,43.68,0,0,1,2.06,6.4,20.68,20.68,0,0,1,.44,6.44,9.16,9.16,0,0,1-2.27,5.69,5.3,5.3,0,0,1-2.62,1.43,10.34,10.34,0,0,1-2.87.15,9.06,9.06,0,0,1-5.1-1.68,5.8,5.8,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.73,4.73,0,0,1,1.33-1.54,5,5,0,0,1,1.74-.79c2.39-.59,4.74.2,5.69,1.69a5.28,5.28,0,0,1,.86,2.09A9.14,9.14,0,0,1,504,344,1.14,1.14,0,0,1,504,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.65,409.48a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a7.66,7.66,0,0,0-.22-1.61,5.09,5.09,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.47-1.48a4.73,4.73,0,0,0-1.62.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.67,8.67,0,0,0,4.89,1.52,10.09,10.09,0,0,0,2.74-.17,5.1,5.1,0,0,0,2.4-1.35,8.85,8.85,0,0,0,2.06-5.44,20.1,20.1,0,0,0-.51-6.28,42.49,42.49,0,0,0-2.11-6.31c-1.6-4.26-3.26-8.67-5-13.19-2.1-5.69-4.13-11.22-6.07-16.47-1-2.59-1.86-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.48,6.48,0,0,1,2.73-2.71,7.88,7.88,0,0,1,3.62-.82,10.78,10.78,0,0,1,3.5.49,6.26,6.26,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,9.92,9.92,0,0,1,.08,3,6,6,0,0,1-1,2.64,6.17,6.17,0,0,1-4.35,2.4h0a5.32,5.32,0,0,1-4.23-1.92,6.1,6.1,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89,1.29,1.29,0,0,1,0,.19c0,.14,0,.32-.07.55a10.85,10.85,0,0,0,0,2.13,6,6,0,0,0,1.1,3.19,5.1,5.1,0,0,0,4.07,1.76h0a5.48,5.48,0,0,0,5.06-4.81,9.79,9.79,0,0,0-.1-2.9,6,6,0,0,0-1.25-2.75,5.9,5.9,0,0,0-2.65-1.73,10.14,10.14,0,0,0-3.37-.45,7.67,7.67,0,0,0-3.41.78,6.08,6.08,0,0,0-2.53,2.54,11,11,0,0,0-1.08,3.65c-.42,2.58.41,5.24,1.41,7.84,1.95,5.25,4,10.77,6.09,16.46l5,13.2a42.86,42.86,0,0,1,2.12,6.37,21,21,0,0,1,.5,6.44,9.29,9.29,0,0,1-2.22,5.71,5.39,5.39,0,0,1-2.61,1.45,10.37,10.37,0,0,1-2.87.18,9.08,9.08,0,0,1-5.11-1.63,5.77,5.77,0,0,1-2.31-4.33v0a7.86,7.86,0,0,1,.8-4.29,4.65,4.65,0,0,1,1.31-1.56,4.8,4.8,0,0,1,1.74-.8c2.38-.62,4.73.15,5.7,1.63a5.24,5.24,0,0,1,.88,2.08,7.7,7.7,0,0,1,.18,1.65,8.25,8.25,0,0,1-.05,1A1.66,1.66,0,0,1,503.65,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.58,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S524.72,416.93,524.58,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.89,416.93c-.15,0-.26-30.4-.26-67.9s.11-67.91.26-67.91.26,30.4.26,67.91S493,416.93,492.89,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.54,344.33a1.15,1.15,0,0,1,0-.34,6.46,6.46,0,0,1,0-1,8.5,8.5,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a4.87,4.87,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.77,5.77,0,0,1-2.34,4.31,9.06,9.06,0,0,1-5.12,1.6,10.4,10.4,0,0,1-2.87-.2,5.35,5.35,0,0,1-2.6-1.47,9.25,9.25,0,0,1-2.18-5.72,21,21,0,0,1,.53-6.44,44.55,44.55,0,0,1,2.16-6.36l5-13.16c2.14-5.68,4.22-11.19,6.19-16.43,1-2.59,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,6,6,0,0,0-2.51-2.56,7.56,7.56,0,0,0-3.41-.8,10.47,10.47,0,0,0-3.37.43,5.51,5.51,0,0,0-3.92,4.45,9.49,9.49,0,0,0-.12,2.9,5.73,5.73,0,0,0,.94,2.51,5.94,5.94,0,0,0,4.08,2.33h0A5.1,5.1,0,0,0,614,296.5a6.07,6.07,0,0,0,1.12-3.18,11.14,11.14,0,0,0,0-2.14l-.06-.54c0-.13,0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.19,6.19,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,10.25,10.25,0,0,1,.09-3A6.5,6.5,0,0,1,606,287.5a6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.47A8,8,0,0,1,616,286a6.43,6.43,0,0,1,2.71,2.73,11.26,11.26,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07l-6.17,16.44-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.45,20.45,0,0,0-.55,6.28,8.86,8.86,0,0,0,2,5.45,5,5,0,0,0,2.39,1.36,10.11,10.11,0,0,0,2.74.2,8.7,8.7,0,0,0,4.9-1.49,5.43,5.43,0,0,0,2.22-4v0a7.57,7.57,0,0,0-.71-4.11,4.38,4.38,0,0,0-1.2-1.48,4.76,4.76,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.29,5.29,0,0,0-.9,2,8.69,8.69,0,0,0-.23,1.62,8.58,8.58,0,0,0,0,1A1.44,1.44,0,0,1,608.54,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.54,409.25a1.38,1.38,0,0,1,0-.34,6.69,6.69,0,0,1,0-1,8.5,8.5,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.35-2.22,5.72-1.59a5.05,5.05,0,0,1,1.73.81,4.76,4.76,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.75,5.75,0,0,1-2.34,4.31,9.06,9.06,0,0,1-5.12,1.6,10,10,0,0,1-2.87-.2,5.35,5.35,0,0,1-2.6-1.47,9.25,9.25,0,0,1-2.18-5.72,21.07,21.07,0,0,1,.53-6.44,44.55,44.55,0,0,1,2.16-6.36l5-13.16c2.14-5.68,4.22-11.18,6.19-16.43,1-2.58,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,5.94,5.94,0,0,0-2.51-2.55,7.57,7.57,0,0,0-3.41-.81A10.47,10.47,0,0,0,609,351a5.87,5.87,0,0,0-2.66,1.71,6,6,0,0,0-1.26,2.75,9.49,9.49,0,0,0-.12,2.9,5.74,5.74,0,0,0,.94,2.5,5.9,5.9,0,0,0,4.08,2.33h0a5.07,5.07,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.17,11.1,11.1,0,0,0,0-2.14l-.06-.55c0-.12,0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0A6.16,6.16,0,0,1,605.6,361a6,6,0,0,1-1-2.65,10.26,10.26,0,0,1,.09-3,6.54,6.54,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.46,7.85,7.85,0,0,1,3.61.83,6.4,6.4,0,0,1,2.71,2.74,11.13,11.13,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07L612.16,382l-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.52,20.52,0,0,0-.55,6.29,8.85,8.85,0,0,0,2,5.44,5.11,5.11,0,0,0,2.39,1.37,10.1,10.1,0,0,0,2.74.19,8.78,8.78,0,0,0,4.9-1.48,5.45,5.45,0,0,0,2.22-4v0a7.59,7.59,0,0,0-.71-4.11,4.47,4.47,0,0,0-1.2-1.48,4.55,4.55,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.27,5.27,0,0,0-.9,2,8.49,8.49,0,0,0-.23,1.61,8.59,8.59,0,0,0,0,1A1.59,1.59,0,0,1,608.54,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.07,344.38s0-.12,0-.35,0-.56,0-1a7.56,7.56,0,0,0-.21-1.61,5.06,5.06,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.81,4.81,0,0,0-1.63.75,4.47,4.47,0,0,0-1.22,1.46,7.63,7.63,0,0,0-.77,4.1v0a5.46,5.46,0,0,0,2.15,4A8.67,8.67,0,0,0,596,349.8a9.61,9.61,0,0,0,2.73-.15,5,5,0,0,0,2.41-1.32,8.8,8.8,0,0,0,2.12-5.42,20.74,20.74,0,0,0-.45-6.29,43.88,43.88,0,0,0-2.06-6.32l-4.85-13.24c-2-5.71-4-11.25-5.92-16.53-1-2.6-1.82-5.38-1.35-8.09a11.32,11.32,0,0,1,1.18-3.79,6.42,6.42,0,0,1,2.76-2.7,8,8,0,0,1,3.62-.78,10.54,10.54,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.41,6.41,0,0,1,1.28,3,9.91,9.91,0,0,1,.06,3,6.05,6.05,0,0,1-1.07,2.64,6.2,6.2,0,0,1-4.37,2.35h0a5.29,5.29,0,0,1-4.21-2,6.09,6.09,0,0,1-1-3.31,8.2,8.2,0,0,1,.29-2.88s0,.06,0,.18,0,.33-.07.55a11.41,11.41,0,0,0,0,2.14,6,6,0,0,0,1.07,3.19,5.13,5.13,0,0,0,4,1.81h0a5.9,5.9,0,0,0,4.11-2.27,5.58,5.58,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,5.54,5.54,0,0,0-3.86-4.52,10.39,10.39,0,0,0-3.36-.48,7.55,7.55,0,0,0-3.42.75,6,6,0,0,0-2.55,2.51,11,11,0,0,0-1.12,3.64c-.43,2.58.37,5.25,1.35,7.85l5.94,16.52,4.84,13.24a43.68,43.68,0,0,1,2.06,6.4,20.68,20.68,0,0,1,.44,6.44,9.16,9.16,0,0,1-2.27,5.69,5.3,5.3,0,0,1-2.62,1.43,10.34,10.34,0,0,1-2.87.15,9.06,9.06,0,0,1-5.1-1.68,5.8,5.8,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.73,4.73,0,0,1,1.33-1.54,5,5,0,0,1,1.74-.79c2.39-.59,4.74.2,5.69,1.69a5.28,5.28,0,0,1,.86,2.09,9.14,9.14,0,0,1,.11,2.66A1.14,1.14,0,0,1,599.07,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.76,409.48a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a8.49,8.49,0,0,0-.23-1.61,5.09,5.09,0,0,0-.89-2c-.94-1.39-3.18-2.09-5.47-1.48a4.73,4.73,0,0,0-1.62.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.68,8.68,0,0,0,4.9,1.52,10,10,0,0,0,2.73-.17,5.05,5.05,0,0,0,2.4-1.35A8.85,8.85,0,0,0,602.9,408a20.1,20.1,0,0,0-.51-6.28,42.49,42.49,0,0,0-2.11-6.31c-1.6-4.26-3.26-8.67-5-13.19-2.09-5.69-4.13-11.22-6.07-16.47-1-2.59-1.86-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.45,6.45,0,0,1,2.74-2.71,7.84,7.84,0,0,1,3.61-.82,10.74,10.74,0,0,1,3.5.49,6.26,6.26,0,0,1,2.83,1.87A6.43,6.43,0,0,1,603,355.6a9.92,9.92,0,0,1,.08,3,6,6,0,0,1-1,2.64,6.17,6.17,0,0,1-4.34,2.4h0a5.32,5.32,0,0,1-4.23-1.92,6.1,6.1,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89s0,.07,0,.19l-.07.55a10.85,10.85,0,0,0,0,2.13,6.09,6.09,0,0,0,1.1,3.19,5.1,5.1,0,0,0,4.07,1.76h0a5.89,5.89,0,0,0,4.09-2.31,5.71,5.71,0,0,0,1-2.5,9.79,9.79,0,0,0-.1-2.9,6,6,0,0,0-1.25-2.75,5.9,5.9,0,0,0-2.65-1.73,10.14,10.14,0,0,0-3.37-.45,7.67,7.67,0,0,0-3.41.78,6,6,0,0,0-2.52,2.54,10.76,10.76,0,0,0-1.09,3.65c-.42,2.58.42,5.24,1.42,7.84L595.8,382l5,13.2a42.86,42.86,0,0,1,2.12,6.37,21,21,0,0,1,.5,6.44,9.29,9.29,0,0,1-2.22,5.71,5.39,5.39,0,0,1-2.61,1.45,10.37,10.37,0,0,1-2.87.18,9.08,9.08,0,0,1-5.11-1.63,5.77,5.77,0,0,1-2.31-4.33v0a7.86,7.86,0,0,1,.8-4.29,4.65,4.65,0,0,1,1.31-1.56,4.8,4.8,0,0,1,1.74-.8c2.38-.62,4.74.15,5.7,1.63a5.24,5.24,0,0,1,.88,2.08,7.7,7.7,0,0,1,.18,1.65,6.62,6.62,0,0,1,0,1A1.09,1.09,0,0,1,598.76,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.69,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S619.83,416.93,619.69,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S588.14,416.93,588,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.8,344.33a1.32,1.32,0,0,1-.06-.34,8.6,8.6,0,0,1,.15-2.65,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a4.57,4.57,0,0,1,3,2.38,7.9,7.9,0,0,1,.77,4.3v0a5.83,5.83,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6A10.3,10.3,0,0,1,577,350a5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,21.05,21.05,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36c1.62-4.25,3.31-8.65,5-13.16,2.14-5.68,4.21-11.19,6.19-16.43,1-2.59,1.86-5.24,1.46-7.83a11,11,0,0,0-1.06-3.65,6,6,0,0,0-2.52-2.56,7.49,7.49,0,0,0-3.4-.8,10.4,10.4,0,0,0-3.37.43,5.82,5.82,0,0,0-2.66,1.71,6,6,0,0,0-1.27,2.74,9.8,9.8,0,0,0-.11,2.9,5.73,5.73,0,0,0,.94,2.51,5.92,5.92,0,0,0,4.08,2.33h0a5.08,5.08,0,0,0,4.07-1.74,6,6,0,0,0,1.13-3.18,12,12,0,0,0,0-2.14l-.07-.54c0-.13,0-.19,0-.19a8.15,8.15,0,0,1,.25,2.89,6.12,6.12,0,0,1-1.09,3.3,5.37,5.37,0,0,1-4.25,1.88h0a6.19,6.19,0,0,1-4.33-2.42,6.11,6.11,0,0,1-1-2.65,9.93,9.93,0,0,1,.1-3,6.39,6.39,0,0,1,1.33-2.93,6.31,6.31,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.47,8,8,0,0,1,3.61.84,6.49,6.49,0,0,1,2.71,2.73,11.49,11.49,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07l-6.17,16.44c-1.74,4.51-3.42,8.91-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.45,20.45,0,0,0-.55,6.28,8.8,8.8,0,0,0,2,5.45,4.91,4.91,0,0,0,2.39,1.36,10,10,0,0,0,2.73.2,8.71,8.71,0,0,0,4.91-1.49,5.42,5.42,0,0,0,2.21-4v0a7.66,7.66,0,0,0-.7-4.11,4.5,4.5,0,0,0-1.2-1.48,4.76,4.76,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.14,5.14,0,0,0-.9,2,8.81,8.81,0,0,0-.24,1.62c0,.44,0,.77,0,1A2.17,2.17,0,0,1,576.8,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.8,409.25a1.66,1.66,0,0,1-.06-.34,8.77,8.77,0,0,1,0-1,8.5,8.5,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a5,5,0,0,1,1.72.81,4.79,4.79,0,0,1,1.31,1.57,7.9,7.9,0,0,1,.77,4.3v0a5.82,5.82,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6A9.93,9.93,0,0,1,577,415a5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,21.08,21.08,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36c1.62-4.25,3.31-8.65,5-13.16l6.19-16.43c1-2.58,1.86-5.24,1.46-7.83a11,11,0,0,0-1.06-3.65,6,6,0,0,0-2.52-2.55,7.5,7.5,0,0,0-3.4-.81,10.4,10.4,0,0,0-3.37.43,5.82,5.82,0,0,0-2.66,1.71,6.08,6.08,0,0,0-1.27,2.75,9.8,9.8,0,0,0-.11,2.9,5.74,5.74,0,0,0,.94,2.5,5.88,5.88,0,0,0,4.08,2.33h0a5.05,5.05,0,0,0,4.07-1.74,6,6,0,0,0,1.13-3.17,12,12,0,0,0,0-2.14l-.07-.55c0-.12,0-.19,0-.19a8.15,8.15,0,0,1,.25,2.89,6.12,6.12,0,0,1-1.09,3.3,5.37,5.37,0,0,1-4.25,1.88h0a5.79,5.79,0,0,1-5.36-5.07,9.94,9.94,0,0,1,.1-3,6.44,6.44,0,0,1,1.33-2.93,6.31,6.31,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.46,7.88,7.88,0,0,1,3.61.83,6.46,6.46,0,0,1,2.71,2.74,11.35,11.35,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07L580.42,382c-1.74,4.51-3.42,8.91-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.52,20.52,0,0,0-.55,6.29,8.79,8.79,0,0,0,2,5.44,5,5,0,0,0,2.39,1.37,10,10,0,0,0,2.73.19,8.78,8.78,0,0,0,4.91-1.48,5.44,5.44,0,0,0,2.21-4v0a7.68,7.68,0,0,0-.7-4.11,4.6,4.6,0,0,0-1.2-1.48,4.55,4.55,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.12,5.12,0,0,0-.9,2,8.6,8.6,0,0,0-.24,1.61c0,.44,0,.78,0,1A2.32,2.32,0,0,1,576.8,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.33,344.38a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a9.13,9.13,0,0,0-.21-1.61,5.21,5.21,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.81,4.81,0,0,0-1.63.75,4.47,4.47,0,0,0-1.22,1.46,7.54,7.54,0,0,0-.77,4.1v0a5.46,5.46,0,0,0,2.15,4,8.67,8.67,0,0,0,4.88,1.56,9.7,9.7,0,0,0,2.74-.15,5,5,0,0,0,2.41-1.32,8.74,8.74,0,0,0,2.11-5.42,20.13,20.13,0,0,0-.45-6.29,43.81,43.81,0,0,0-2-6.32l-4.85-13.24c-2-5.71-4-11.25-5.93-16.53-1-2.6-1.82-5.38-1.35-8.09a11.11,11.11,0,0,1,1.19-3.79,6.45,6.45,0,0,1,2.75-2.7,8,8,0,0,1,3.62-.78,10.5,10.5,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.33,6.33,0,0,1,1.29,3,9.9,9.9,0,0,1,0,3,5.75,5.75,0,0,1-5.43,5h0a5.33,5.33,0,0,1-4.22-2,6.18,6.18,0,0,1-1-3.31,8.32,8.32,0,0,1,.3-2.88s0,.06,0,.18,0,.33-.08.55a12.35,12.35,0,0,0,0,2.14,6.1,6.1,0,0,0,1.08,3.19,5.12,5.12,0,0,0,4,1.81h0a5.9,5.9,0,0,0,4.12-2.27,5.82,5.82,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,6,6,0,0,0-1.23-2.76,5.89,5.89,0,0,0-2.63-1.76,10.41,10.41,0,0,0-3.37-.48,7.53,7.53,0,0,0-3.41.75,6,6,0,0,0-2.55,2.51,10.81,10.81,0,0,0-1.12,3.64c-.44,2.58.37,5.25,1.35,7.85,1.89,5.28,3.88,10.81,5.94,16.52,1.65,4.54,3.27,9,4.84,13.24a44.92,44.92,0,0,1,2.06,6.4A21,21,0,0,1,572,343a9.16,9.16,0,0,1-2.27,5.69,5.33,5.33,0,0,1-2.63,1.43,10.29,10.29,0,0,1-2.86.15,9.06,9.06,0,0,1-5.1-1.68,5.77,5.77,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.73,4.73,0,0,1,1.33-1.54,4.87,4.87,0,0,1,1.74-.79c2.38-.59,4.73.2,5.69,1.69a5.43,5.43,0,0,1,.86,2.09,8.27,8.27,0,0,1,.16,1.65,6.37,6.37,0,0,1-.06,1A1,1,0,0,1,567.33,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,409.48a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a8.38,8.38,0,0,0-.22-1.61,5.09,5.09,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.47-1.48a4.73,4.73,0,0,0-1.62.77,4.46,4.46,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.42,5.42,0,0,0,2.18,4,8.7,8.7,0,0,0,4.9,1.52,10.09,10.09,0,0,0,2.74-.17,5,5,0,0,0,2.39-1.35,8.8,8.8,0,0,0,2.07-5.44,20.72,20.72,0,0,0-.51-6.28,42.49,42.49,0,0,0-2.11-6.31c-1.6-4.26-3.27-8.67-5-13.19-2.1-5.69-4.13-11.22-6.07-16.47-1-2.59-1.87-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.37,6.37,0,0,1,2.73-2.71,7.87,7.87,0,0,1,3.61-.82,10.8,10.8,0,0,1,3.51.49,6.32,6.32,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,10.24,10.24,0,0,1,.08,3,6.08,6.08,0,0,1-1,2.64,6.19,6.19,0,0,1-4.35,2.4h0a5.32,5.32,0,0,1-4.23-1.92,6.1,6.1,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89s0,.07,0,.19,0,.32-.07.55a10.85,10.85,0,0,0,0,2.13,6,6,0,0,0,1.1,3.19,5.08,5.08,0,0,0,4.07,1.76h0a5.91,5.91,0,0,0,4.1-2.31,5.7,5.7,0,0,0,1-2.5,9.46,9.46,0,0,0-.09-2.9,6.09,6.09,0,0,0-1.25-2.75,6,6,0,0,0-2.65-1.73,10.14,10.14,0,0,0-3.37-.45,7.67,7.67,0,0,0-3.41.78,6.08,6.08,0,0,0-2.53,2.54,10.75,10.75,0,0,0-1.08,3.65c-.42,2.58.41,5.24,1.41,7.84,1.95,5.25,4,10.77,6.09,16.46l5,13.2a44,44,0,0,1,2.12,6.37,21,21,0,0,1,.49,6.44,9.23,9.23,0,0,1-2.21,5.71,5.38,5.38,0,0,1-2.62,1.45,10.28,10.28,0,0,1-2.86.18,9.14,9.14,0,0,1-5.12-1.63,5.84,5.84,0,0,1-2.31-4.33v0a8,8,0,0,1,.81-4.29,4.65,4.65,0,0,1,1.31-1.56,4.73,4.73,0,0,1,1.74-.8c2.37-.62,4.73.15,5.7,1.63a5.24,5.24,0,0,1,.88,2.08,8.4,8.4,0,0,1,.18,1.65,8.25,8.25,0,0,1,0,1A1.66,1.66,0,0,1,567,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,416.93c-.15,0-.26-30.4-.26-67.9s.11-67.91.26-67.91.26,30.4.26,67.91S588.09,416.93,588,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.26,416.93c-.15,0-.26-30.4-.26-67.9s.11-67.91.26-67.91.26,30.4.26,67.91S556.4,416.93,556.26,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.91,344.33a1.32,1.32,0,0,1-.06-.34,8.6,8.6,0,0,1,.15-2.65,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a5,5,0,0,1,1.73.81,4.88,4.88,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.83,5.83,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6,10.35,10.35,0,0,1-2.86-.2,5.35,5.35,0,0,1-2.6-1.47,9.26,9.26,0,0,1-2.19-5.72,21.05,21.05,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36l5-13.16c2.14-5.68,4.21-11.19,6.19-16.43,1-2.59,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,6,6,0,0,0-2.52-2.56,7.49,7.49,0,0,0-3.4-.8,10.4,10.4,0,0,0-3.37.43,5.87,5.87,0,0,0-2.66,1.71,6,6,0,0,0-1.27,2.74,9.8,9.8,0,0,0-.11,2.9,5.73,5.73,0,0,0,.94,2.51,5.94,5.94,0,0,0,4.08,2.33h0a5.12,5.12,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.18,12,12,0,0,0,0-2.14c0-.22,0-.4-.07-.54s0-.19,0-.19a8.46,8.46,0,0,1,.25,2.89,6.23,6.23,0,0,1-1.1,3.3,5.35,5.35,0,0,1-4.25,1.88h0A6.19,6.19,0,0,1,669,296.1a6.11,6.11,0,0,1-1-2.65,10.61,10.61,0,0,1,.1-3,5.9,5.9,0,0,1,4.17-4.78,10.56,10.56,0,0,1,3.51-.47,8,8,0,0,1,3.61.84,6.49,6.49,0,0,1,2.71,2.73,11.26,11.26,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07l-6.17,16.44-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.45,20.45,0,0,0-.55,6.28,8.86,8.86,0,0,0,2,5.45,5,5,0,0,0,2.39,1.36,10,10,0,0,0,2.73.2,8.71,8.71,0,0,0,4.91-1.49,5.42,5.42,0,0,0,2.21-4v0a7.66,7.66,0,0,0-.7-4.11,4.38,4.38,0,0,0-1.2-1.48,4.76,4.76,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.14,5.14,0,0,0-.9,2,7.92,7.92,0,0,0-.23,1.62,8.58,8.58,0,0,0,0,1A2.86,2.86,0,0,1,671.91,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.91,409.25a1.66,1.66,0,0,1-.06-.34,8.77,8.77,0,0,1,0-1,8.5,8.5,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.72-1.59a5.14,5.14,0,0,1,1.73.81,4.88,4.88,0,0,1,1.3,1.57,8,8,0,0,1,.78,4.3v0a5.82,5.82,0,0,1-2.34,4.31,9.07,9.07,0,0,1-5.13,1.6,10,10,0,0,1-2.86-.2,5.35,5.35,0,0,1-2.6-1.47,9.26,9.26,0,0,1-2.19-5.72,21.08,21.08,0,0,1,.54-6.44A43.34,43.34,0,0,1,670,395l5-13.16,6.19-16.43c1-2.58,1.86-5.24,1.46-7.83a10.79,10.79,0,0,0-1.06-3.65,5.91,5.91,0,0,0-2.52-2.55,7.5,7.5,0,0,0-3.4-.81,10.4,10.4,0,0,0-3.37.43,5.87,5.87,0,0,0-2.66,1.71,6.08,6.08,0,0,0-1.27,2.75,9.8,9.8,0,0,0-.11,2.9,5.74,5.74,0,0,0,.94,2.5,5.9,5.9,0,0,0,4.08,2.33h0a5.09,5.09,0,0,0,4.08-1.74,6.07,6.07,0,0,0,1.12-3.17,12,12,0,0,0,0-2.14c0-.23,0-.41-.07-.55a.69.69,0,0,1,0-.19,8.46,8.46,0,0,1,.25,2.89,6.23,6.23,0,0,1-1.1,3.3,5.35,5.35,0,0,1-4.25,1.88h0a5.79,5.79,0,0,1-5.36-5.07,10.62,10.62,0,0,1,.1-3,6.44,6.44,0,0,1,1.33-2.93,6.37,6.37,0,0,1,2.84-1.85,10.56,10.56,0,0,1,3.51-.46,7.88,7.88,0,0,1,3.61.83,6.46,6.46,0,0,1,2.71,2.74,11.13,11.13,0,0,1,1.13,3.81c.43,2.72-.46,5.49-1.47,8.07L675.53,382l-5,13.16a42.91,42.91,0,0,0-2.15,6.29,20.52,20.52,0,0,0-.55,6.29,8.85,8.85,0,0,0,2,5.44,5.11,5.11,0,0,0,2.39,1.37,10,10,0,0,0,2.73.19,8.78,8.78,0,0,0,4.91-1.48,5.44,5.44,0,0,0,2.21-4v0a7.68,7.68,0,0,0-.7-4.11,4.47,4.47,0,0,0-1.2-1.48,4.55,4.55,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.12,5.12,0,0,0-.9,2,7.75,7.75,0,0,0-.23,1.61,8.59,8.59,0,0,0,0,1A3.18,3.18,0,0,1,671.91,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.44,344.38a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a8.27,8.27,0,0,0-.21-1.61,5.21,5.21,0,0,0-.87-2c-.93-1.39-3.17-2.12-5.46-1.53a4.81,4.81,0,0,0-1.63.75,4.47,4.47,0,0,0-1.22,1.46,7.63,7.63,0,0,0-.77,4.1v0a5.46,5.46,0,0,0,2.15,4,8.67,8.67,0,0,0,4.89,1.56,9.63,9.63,0,0,0,2.73-.15,5,5,0,0,0,2.41-1.32,8.74,8.74,0,0,0,2.11-5.42,20.13,20.13,0,0,0-.45-6.29,43.81,43.81,0,0,0-2-6.32l-4.85-13.24c-2-5.71-4-11.25-5.93-16.53-1-2.6-1.81-5.38-1.35-8.09a11.33,11.33,0,0,1,1.19-3.79,6.45,6.45,0,0,1,2.75-2.7,8,8,0,0,1,3.62-.78,10.46,10.46,0,0,1,3.5.53,6.33,6.33,0,0,1,2.82,1.89,6.41,6.41,0,0,1,1.28,3,9.9,9.9,0,0,1,0,3,5.75,5.75,0,0,1-5.43,5h0a5.33,5.33,0,0,1-4.22-2,6.16,6.16,0,0,1-1-3.31,8.2,8.2,0,0,1,.29-2.88s0,.06,0,.18,0,.33-.07.55a10.6,10.6,0,0,0,0,2.14,6,6,0,0,0,1.07,3.19,5.12,5.12,0,0,0,4,1.81h0a5.9,5.9,0,0,0,4.11-2.27,5.82,5.82,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,5.54,5.54,0,0,0-3.86-4.52,10.41,10.41,0,0,0-3.37-.48,7.53,7.53,0,0,0-3.41.75,6,6,0,0,0-2.55,2.51,11,11,0,0,0-1.12,3.64c-.44,2.58.37,5.25,1.35,7.85,1.89,5.28,3.88,10.81,5.94,16.52l4.84,13.24a44.92,44.92,0,0,1,2.06,6.4,21,21,0,0,1,.44,6.44,9.16,9.16,0,0,1-2.27,5.69,5.33,5.33,0,0,1-2.63,1.43,10.27,10.27,0,0,1-2.86.15,9.06,9.06,0,0,1-5.1-1.68,5.8,5.8,0,0,1-2.27-4.35v0a8,8,0,0,1,.84-4.29,4.73,4.73,0,0,1,1.33-1.54,5,5,0,0,1,1.74-.79c2.38-.59,4.74.2,5.69,1.69a5.28,5.28,0,0,1,.86,2.09,9.14,9.14,0,0,1,.11,2.66A1.14,1.14,0,0,1,662.44,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.13,409.48a2.31,2.31,0,0,1,0-.35c0-.22,0-.56,0-1a7.66,7.66,0,0,0-.22-1.61,5.09,5.09,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.47-1.48a4.73,4.73,0,0,0-1.62.77,4.46,4.46,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.64,8.64,0,0,0,4.89,1.52,10.09,10.09,0,0,0,2.74-.17,5.1,5.1,0,0,0,2.4-1.35,8.85,8.85,0,0,0,2.06-5.44,20.41,20.41,0,0,0-.51-6.28,42.49,42.49,0,0,0-2.11-6.31c-1.6-4.26-3.26-8.67-5-13.19-2.1-5.69-4.13-11.22-6.07-16.47-1-2.59-1.86-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.43,6.43,0,0,1,2.73-2.71,7.88,7.88,0,0,1,3.62-.82,10.78,10.78,0,0,1,3.5.49,6.32,6.32,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,9.92,9.92,0,0,1,.08,3,6,6,0,0,1-1,2.64,6.17,6.17,0,0,1-4.35,2.4h0a5.32,5.32,0,0,1-4.23-1.92,6.1,6.1,0,0,1-1.08-3.3,8.38,8.38,0,0,1,.27-2.89s0,.07,0,.19,0,.32-.07.55a10.85,10.85,0,0,0,0,2.13,6,6,0,0,0,1.1,3.19,5.08,5.08,0,0,0,4.07,1.76h0a5.48,5.48,0,0,0,5.06-4.81,9.79,9.79,0,0,0-.1-2.9,5.54,5.54,0,0,0-3.9-4.48,10.14,10.14,0,0,0-3.37-.45,7.67,7.67,0,0,0-3.41.78,6.08,6.08,0,0,0-2.53,2.54,10.75,10.75,0,0,0-1.08,3.65c-.42,2.58.41,5.24,1.41,7.84,1.95,5.25,4,10.77,6.09,16.46l5,13.2a42.86,42.86,0,0,1,2.12,6.37,21,21,0,0,1,.5,6.44,9.29,9.29,0,0,1-2.22,5.71,5.38,5.38,0,0,1-2.62,1.45,10.28,10.28,0,0,1-2.86.18,9.08,9.08,0,0,1-5.11-1.63,5.82,5.82,0,0,1-2.32-4.33v0a7.86,7.86,0,0,1,.8-4.29,4.65,4.65,0,0,1,1.31-1.56,4.8,4.8,0,0,1,1.74-.8c2.37-.62,4.73.15,5.7,1.63a5.24,5.24,0,0,1,.88,2.08,8.4,8.4,0,0,1,.18,1.65,8.25,8.25,0,0,1,0,1A1.66,1.66,0,0,1,662.13,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.06,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S683.2,416.93,683.06,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.37,416.93c-.15,0-.26-30.4-.26-67.9s.11-67.91.26-67.91.26,30.4.26,67.91S651.51,416.93,651.37,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.17,344.33a.92.92,0,0,1-.06-.34,8.47,8.47,0,0,1,0-1,7.17,7.17,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.71-1.59a4.87,4.87,0,0,1,1.73.81,4.79,4.79,0,0,1,1.31,1.57,7.9,7.9,0,0,1,.77,4.3v0a5.79,5.79,0,0,1-2.33,4.31,9.07,9.07,0,0,1-5.13,1.6,10.3,10.3,0,0,1-2.86-.2,5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.75,20.75,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36c1.62-4.25,3.31-8.65,5-13.16l6.18-16.43c1-2.59,1.87-5.24,1.47-7.83a10.81,10.81,0,0,0-1.07-3.65,6,6,0,0,0-2.51-2.56,7.49,7.49,0,0,0-3.4-.8,10.4,10.4,0,0,0-3.37.43,5.9,5.9,0,0,0-2.67,1.71,6.13,6.13,0,0,0-1.26,2.74,9.8,9.8,0,0,0-.11,2.9,5.73,5.73,0,0,0,.94,2.51,5.92,5.92,0,0,0,4.08,2.33h0a5.1,5.1,0,0,0,4.07-1.74,6,6,0,0,0,1.12-3.18,11.31,11.31,0,0,0,0-2.14c0-.22,0-.4-.07-.54a1.42,1.42,0,0,1,0-.19,8.15,8.15,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.18,6.18,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,9.93,9.93,0,0,1,.1-3,6.39,6.39,0,0,1,1.33-2.93,6.26,6.26,0,0,1,2.84-1.85,10.53,10.53,0,0,1,3.51-.47,8,8,0,0,1,3.6.84,6.45,6.45,0,0,1,2.72,2.73,11.73,11.73,0,0,1,1.13,3.81c.42,2.72-.46,5.49-1.47,8.07-2,5.25-4,10.76-6.18,16.44l-5,13.16a44.13,44.13,0,0,0-2.15,6.29,20.44,20.44,0,0,0-.54,6.28,8.74,8.74,0,0,0,2,5.45,4.91,4.91,0,0,0,2.39,1.36,10,10,0,0,0,2.73.2,8.74,8.74,0,0,0,4.91-1.49,5.45,5.45,0,0,0,2.21-4v0a7.66,7.66,0,0,0-.7-4.11,4.63,4.63,0,0,0-1.2-1.48,4.85,4.85,0,0,0-1.62-.78c-2.28-.62-4.53.06-5.48,1.44a5.33,5.33,0,0,0-.91,2,8.69,8.69,0,0,0-.23,1.62c0,.44,0,.77,0,1A2.17,2.17,0,0,1,640.17,344.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.17,409.25a1.09,1.09,0,0,1-.06-.34,8.77,8.77,0,0,1,0-1,7.17,7.17,0,0,1,.19-1.64,5.28,5.28,0,0,1,.89-2.08c1-1.47,3.34-2.22,5.71-1.59a5.05,5.05,0,0,1,1.73.81A4.79,4.79,0,0,1,649.9,405a7.9,7.9,0,0,1,.77,4.3v0a5.77,5.77,0,0,1-2.33,4.31,9.07,9.07,0,0,1-5.13,1.6,9.93,9.93,0,0,1-2.86-.2,5.43,5.43,0,0,1-2.61-1.47,9.25,9.25,0,0,1-2.18-5.72,20.77,20.77,0,0,1,.54-6.44,43.34,43.34,0,0,1,2.16-6.36c1.62-4.25,3.31-8.65,5-13.16,2.14-5.68,4.21-11.18,6.18-16.43,1-2.58,1.87-5.24,1.47-7.83a10.81,10.81,0,0,0-1.07-3.65,5.89,5.89,0,0,0-2.51-2.55,7.5,7.5,0,0,0-3.4-.81,10.4,10.4,0,0,0-3.37.43,5.9,5.9,0,0,0-2.67,1.71,6.17,6.17,0,0,0-1.26,2.75,9.8,9.8,0,0,0-.11,2.9,5.74,5.74,0,0,0,.94,2.5,5.88,5.88,0,0,0,4.08,2.33h0a5.07,5.07,0,0,0,4.07-1.74,6,6,0,0,0,1.12-3.17,11.28,11.28,0,0,0,0-2.14c0-.23,0-.41-.07-.55a1.29,1.29,0,0,1,0-.19,8.15,8.15,0,0,1,.25,2.89,6.14,6.14,0,0,1-1.1,3.3,5.33,5.33,0,0,1-4.24,1.88h0a6.14,6.14,0,0,1-4.33-2.42,6,6,0,0,1-1-2.65,9.94,9.94,0,0,1,.1-3,6.44,6.44,0,0,1,1.33-2.93,6.26,6.26,0,0,1,2.84-1.85,10.53,10.53,0,0,1,3.51-.46,7.81,7.81,0,0,1,3.6.83,6.42,6.42,0,0,1,2.72,2.74,11.59,11.59,0,0,1,1.13,3.81c.42,2.72-.46,5.49-1.47,8.07L643.78,382l-5,13.16a44.13,44.13,0,0,0-2.15,6.29,20.51,20.51,0,0,0-.54,6.29,8.73,8.73,0,0,0,2,5.44,5,5,0,0,0,2.39,1.37,10,10,0,0,0,2.73.19,8.81,8.81,0,0,0,4.91-1.48,5.47,5.47,0,0,0,2.21-4v0a7.68,7.68,0,0,0-.7-4.11,4.74,4.74,0,0,0-1.2-1.48,4.64,4.64,0,0,0-1.62-.77c-2.28-.63-4.53.06-5.48,1.43a5.3,5.3,0,0,0-.91,2,8.49,8.49,0,0,0-.23,1.61c0,.44,0,.78,0,1A2.32,2.32,0,0,1,640.17,409.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.7,344.38a2.31,2.31,0,0,1,0-.35,10.62,10.62,0,0,0-.2-2.61,5.24,5.24,0,0,0-.88-2c-.92-1.39-3.16-2.12-5.45-1.53a4.73,4.73,0,0,0-1.63.75,4.5,4.5,0,0,0-1.23,1.46,7.62,7.62,0,0,0-.76,4.1v0a5.43,5.43,0,0,0,2.15,4,8.64,8.64,0,0,0,4.88,1.56,9.7,9.7,0,0,0,2.74-.15,5.08,5.08,0,0,0,2.41-1.32,8.79,8.79,0,0,0,2.11-5.42,20.43,20.43,0,0,0-.45-6.29,42.67,42.67,0,0,0-2.06-6.32q-2.34-6.42-4.85-13.24c-2-5.71-4-11.25-5.92-16.53-1-2.6-1.82-5.38-1.35-8.09a11.32,11.32,0,0,1,1.18-3.79,6.53,6.53,0,0,1,2.76-2.7,8,8,0,0,1,3.62-.78,10.5,10.5,0,0,1,3.5.53,6.24,6.24,0,0,1,2.81,1.89,6.33,6.33,0,0,1,1.29,3,9.9,9.9,0,0,1,0,3,5.75,5.75,0,0,1-5.43,5h0a5.33,5.33,0,0,1-4.22-2,6.18,6.18,0,0,1-1-3.31,8.32,8.32,0,0,1,.3-2.88s0,.06,0,.18,0,.33-.08.55a11.41,11.41,0,0,0,0,2.14,6.1,6.1,0,0,0,1.08,3.19,5.12,5.12,0,0,0,4,1.81h0A5.92,5.92,0,0,0,634.1,296a5.82,5.82,0,0,0,1-2.49,9.77,9.77,0,0,0-.07-2.9,6,6,0,0,0-1.23-2.76,5.87,5.87,0,0,0-2.64-1.76,10.31,10.31,0,0,0-3.36-.48,7.51,7.51,0,0,0-3.41.75,6.07,6.07,0,0,0-2.56,2.51,11,11,0,0,0-1.11,3.64c-.44,2.58.37,5.25,1.34,7.85L628,316.88l4.84,13.24a43.74,43.74,0,0,1,2.07,6.4,21.3,21.3,0,0,1,.44,6.44,9.28,9.28,0,0,1-2.27,5.69,5.33,5.33,0,0,1-2.63,1.43,10.34,10.34,0,0,1-2.87.15,9.06,9.06,0,0,1-5.09-1.68,5.81,5.81,0,0,1-2.28-4.35v0a7.87,7.87,0,0,1,.84-4.29,4.7,4.7,0,0,1,1.32-1.54,4.91,4.91,0,0,1,1.75-.79c2.38-.59,4.73.2,5.69,1.69a5.43,5.43,0,0,1,.86,2.09,8.27,8.27,0,0,1,.16,1.65,7.87,7.87,0,0,1-.06,1A1.48,1.48,0,0,1,630.7,344.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.39,409.48a3.09,3.09,0,0,1,0-.35,8.11,8.11,0,0,0,0-1,8.38,8.38,0,0,0-.22-1.61,5.23,5.23,0,0,0-.89-2c-.94-1.39-3.19-2.09-5.47-1.48a4.86,4.86,0,0,0-1.63.77,4.59,4.59,0,0,0-1.21,1.47,7.65,7.65,0,0,0-.73,4.1v0a5.44,5.44,0,0,0,2.19,4,8.7,8.7,0,0,0,4.9,1.52,10.09,10.09,0,0,0,2.74-.17,5.07,5.07,0,0,0,2.39-1.35,8.8,8.8,0,0,0,2.07-5.44,20.72,20.72,0,0,0-.51-6.28,43.68,43.68,0,0,0-2.11-6.31c-1.61-4.26-3.27-8.67-5-13.19-2.1-5.69-4.14-11.22-6.07-16.47-1-2.59-1.87-5.37-1.42-8.08a11.38,11.38,0,0,1,1.15-3.81,6.37,6.37,0,0,1,2.73-2.71,7.87,7.87,0,0,1,3.61-.82,10.84,10.84,0,0,1,3.51.49,6.32,6.32,0,0,1,2.83,1.87,6.43,6.43,0,0,1,1.31,2.94,10.24,10.24,0,0,1,.08,3,5.79,5.79,0,0,1-5.39,5h0a5.36,5.36,0,0,1-4.24-1.92,6.08,6.08,0,0,1-1.07-3.3,8.26,8.26,0,0,1,.26-2.89.69.69,0,0,1,0,.19l-.07.55a10.85,10.85,0,0,0,0,2.13,6,6,0,0,0,1.1,3.19,5.06,5.06,0,0,0,4.06,1.76h0a5.93,5.93,0,0,0,4.1-2.31,5.82,5.82,0,0,0,.95-2.5,9.79,9.79,0,0,0-.1-2.9,6.07,6.07,0,0,0-1.24-2.75,6,6,0,0,0-2.66-1.73,10.08,10.08,0,0,0-3.36-.45,7.67,7.67,0,0,0-3.41.78,6,6,0,0,0-2.53,2.54,11,11,0,0,0-1.09,3.65c-.41,2.58.42,5.24,1.42,7.84,1.94,5.25,4,10.77,6.09,16.46l5,13.2a42.81,42.81,0,0,1,2.11,6.37A20.73,20.73,0,0,1,635,408a9.23,9.23,0,0,1-2.21,5.71,5.46,5.46,0,0,1-2.62,1.45,10.32,10.32,0,0,1-2.86.18,9.11,9.11,0,0,1-5.12-1.63,5.77,5.77,0,0,1-2.31-4.33v0a8,8,0,0,1,.81-4.29,4.53,4.53,0,0,1,3-2.36c2.38-.62,4.74.15,5.71,1.63a5.24,5.24,0,0,1,.88,2.08,8.3,8.3,0,0,1,.17,1.65,8.69,8.69,0,0,1,0,1A1.66,1.66,0,0,1,630.39,409.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.32,416.93c-.15,0-.27-30.4-.27-67.9s.12-67.91.27-67.91.26,30.4.26,67.91S651.46,416.93,651.32,416.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.62,416.93c-.14,0-.26-30.4-.26-67.9s.12-67.91.26-67.91.26,30.4.26,67.91S619.77,416.93,619.62,416.93Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.16,269.06c0,3.53-2.59,6.39-5.79,6.39s-5.79-2.86-5.79-6.39,2.59-6.39,5.79-6.39S62.16,265.53,62.16,269.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.79,
    y: 273.27,
    width: 5.16,
    height: 163.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,269.06c0,3.53-2.6,6.39-5.8,6.39s-5.79-2.86-5.79-6.39,2.6-6.39,5.79-6.39S341.48,265.53,341.48,269.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.11,
    y: 273.27,
    width: 5.16,
    height: 163.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.37,
    y: 277.68,
    width: 280.81,
    height: 4.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.37,
    y: 423.76,
    width: 279.77,
    height: 4.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,348.75a1.68,1.68,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,8.93,8.93,0,0,1,.17-1.71,6.06,6.06,0,0,1,.84-2.19,4.27,4.27,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.81,4.81,0,0,1,1.76.92,5.37,5.37,0,0,1,1.27,1.69,9,9,0,0,1,.72,4.48v0a6.29,6.29,0,0,1-2.31,4.57,8.8,8.8,0,0,1-5.33,1.72,8.54,8.54,0,0,1-3-.32,5.42,5.42,0,0,1-2.57-1.77,11.15,11.15,0,0,1-1.93-6.11,24.13,24.13,0,0,1,.61-6.73,52.5,52.5,0,0,1,2.15-6.69c1.61-4.48,3.28-9.13,5-13.89l6.11-17.29c1-2.73,1.88-5.5,1.58-8.22a13.44,13.44,0,0,0-.93-3.88,6.57,6.57,0,0,0-2.38-2.91,6.92,6.92,0,0,0-3.49-1,10.45,10.45,0,0,0-3.51.42,6,6,0,0,0-2.74,1.85,6.74,6.74,0,0,0-1.26,2.91,8.15,8.15,0,0,0,.75,5.7,5.84,5.84,0,0,0,4.15,2.58h0a5,5,0,0,0,4.15-1.95,7,7,0,0,0,1-3.36,14.15,14.15,0,0,0,0-2.23l-.07-.57c0-.13,0-.19,0-.2a9.28,9.28,0,0,1,.26,3,7.15,7.15,0,0,1-1,3.47,5.21,5.21,0,0,1-4.33,2.11h0a6.12,6.12,0,0,1-4.41-2.68,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.33-3.08,6.25,6.25,0,0,1,2.91-2,10.7,10.7,0,0,1,3.67-.46,7.4,7.4,0,0,1,3.72,1.09,7.08,7.08,0,0,1,2.56,3.1,14,14,0,0,1,1,4c.32,2.85-.59,5.71-1.58,8.43-1.95,5.52-4,11.32-6.1,17.31l-5,13.88a52.67,52.67,0,0,0-2.15,6.63,24,24,0,0,0-.62,6.58,10.76,10.76,0,0,0,1.82,5.87,4.93,4.93,0,0,0,2.35,1.63,8,8,0,0,0,2.83.31,8.48,8.48,0,0,0,5.1-1.6,5.91,5.91,0,0,0,2.2-4.26v0a8.61,8.61,0,0,0-.66-4.3,5,5,0,0,0-1.17-1.6,4.68,4.68,0,0,0-1.64-.88,6.1,6.1,0,0,0-3.36,0,4,4,0,0,0-2.23,1.65,6,6,0,0,0-.86,2.11,10.08,10.08,0,0,0-.22,1.68c0,.46,0,.81,0,1A2.43,2.43,0,0,1,120.38,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,417.9a1.35,1.35,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,8.83,8.83,0,0,1,.17-1.7,6,6,0,0,1,.84-2.19,4.24,4.24,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.41,5.41,0,0,1,1.27,1.7,9,9,0,0,1,.72,4.48v0a6.3,6.3,0,0,1-2.31,4.57,8.86,8.86,0,0,1-5.33,1.71,8.3,8.3,0,0,1-3-.31,5.56,5.56,0,0,1-2.57-1.77,11.18,11.18,0,0,1-1.93-6.12,24.06,24.06,0,0,1,.61-6.72,52,52,0,0,1,2.15-6.69q2.42-6.74,5-13.89l6.11-17.3c1-2.73,1.88-5.49,1.58-8.21a13.5,13.5,0,0,0-.93-3.89,6.69,6.69,0,0,0-2.38-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.51.42,5.85,5.85,0,0,0-2.74,1.85,6.66,6.66,0,0,0-1.26,2.9,8.15,8.15,0,0,0,.75,5.7,5.85,5.85,0,0,0,4.15,2.59h0a5,5,0,0,0,4.15-2,7,7,0,0,0,1-3.36,14.2,14.2,0,0,0,0-2.23l-.07-.57c0-.12,0-.19,0-.19a9.24,9.24,0,0,1,.26,3,7.18,7.18,0,0,1-1,3.48,5.24,5.24,0,0,1-4.33,2.11h0a6.13,6.13,0,0,1-4.41-2.69,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.33-3.08,6.24,6.24,0,0,1,2.91-2,10.47,10.47,0,0,1,3.67-.46,7.38,7.38,0,0,1,3.72,1.08,7.08,7.08,0,0,1,2.56,3.1,14.07,14.07,0,0,1,1,4c.32,2.84-.59,5.7-1.58,8.43-1.95,5.52-4,11.32-6.1,17.3l-5,13.88a53.74,53.74,0,0,0-2.15,6.63,24,24,0,0,0-.62,6.59,10.72,10.72,0,0,0,1.82,5.86,5,5,0,0,0,2.35,1.64,8,8,0,0,0,2.83.3,8.48,8.48,0,0,0,5.1-1.59,6,6,0,0,0,2.2-4.26v0a8.61,8.61,0,0,0-.66-4.3,5.18,5.18,0,0,0-1.17-1.61,4.65,4.65,0,0,0-1.64-.87,6,6,0,0,0-3.36,0,4,4,0,0,0-2.23,1.64,6,6,0,0,0-.86,2.12,10.11,10.11,0,0,0-.22,1.67c0,.46,0,.81,0,1.05A2.31,2.31,0,0,1,120.38,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6.21,6.21,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.16,6.16,0,0,0-3.36,0,4.72,4.72,0,0,0-1.65.85,5.13,5.13,0,0,0-1.2,1.58,8.81,8.81,0,0,0-.72,4.29v0a6,6,0,0,0,2.14,4.3,8.47,8.47,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,5,5,0,0,0,2.38-1.6,10.71,10.71,0,0,0,1.89-5.83,24,24,0,0,0-.52-6.6,52.92,52.92,0,0,0-2.06-6.66c-1.55-4.51-3.16-9.18-4.8-14l-5.86-17.4c-.95-2.74-1.82-5.61-1.47-8.45a13.94,13.94,0,0,1,1-4,7,7,0,0,1,2.6-3.07,7.4,7.4,0,0,1,3.73-1,10.64,10.64,0,0,1,3.66.52,6.29,6.29,0,0,1,2.89,2.05,6.9,6.9,0,0,1,1.28,3.09,8.46,8.46,0,0,1-.92,5.94,6.07,6.07,0,0,1-4.45,2.62h0a5.27,5.27,0,0,1-4.3-2.18,7.26,7.26,0,0,1-1-3.49,9.35,9.35,0,0,1,.3-3s0,.06,0,.19,0,.34-.07.57a13.18,13.18,0,0,0-.06,2.23,7.11,7.11,0,0,0,1,3.38,5,5,0,0,0,4.13,2h0a5.79,5.79,0,0,0,4.19-2.52,8.18,8.18,0,0,0,.83-5.69,6.59,6.59,0,0,0-1.22-2.92,6,6,0,0,0-2.71-1.89,10,10,0,0,0-3.52-.48,6.94,6.94,0,0,0-3.5,1,6.5,6.5,0,0,0-2.41,2.88,13.35,13.35,0,0,0-1,3.87c-.33,2.71.51,5.49,1.47,8.24l5.87,17.38c1.64,4.79,3.24,9.46,4.79,14a52.38,52.38,0,0,1,2.06,6.72,24.1,24.1,0,0,1,.52,6.74,11.08,11.08,0,0,1-2,6.08,5.35,5.35,0,0,1-2.6,1.73,8.11,8.11,0,0,1-3,.26,8.89,8.89,0,0,1-5.3-1.8,6.36,6.36,0,0,1-2.24-4.61v0a8.94,8.94,0,0,1,.79-4.47,5.38,5.38,0,0,1,1.29-1.68,4.94,4.94,0,0,1,1.78-.88,6.22,6.22,0,0,1,3.51.07,4.26,4.26,0,0,1,2.29,1.82,5.83,5.83,0,0,1,.81,2.2,8.68,8.68,0,0,1,.15,1.7,8.21,8.21,0,0,1-.06,1.05A1.71,1.71,0,0,1,110.91,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,418.15a2.43,2.43,0,0,1,0-.36c0-.23,0-.58,0-1a9.92,9.92,0,0,0-.2-1.68,6,6,0,0,0-.85-2.12,4,4,0,0,0-2.22-1.66,6,6,0,0,0-3.36,0,4.51,4.51,0,0,0-1.65.86,5.12,5.12,0,0,0-1.18,1.59,8.72,8.72,0,0,0-.68,4.3v0a6,6,0,0,0,2.17,4.28,8.45,8.45,0,0,0,5.09,1.63,7.94,7.94,0,0,0,2.83-.28,5,5,0,0,0,2.37-1.63,10.77,10.77,0,0,0,1.85-5.85,23.63,23.63,0,0,0-.59-6.59,51.42,51.42,0,0,0-2.11-6.64c-1.59-4.49-3.23-9.15-4.92-13.92l-6-17.34c-1-2.73-1.87-5.59-1.54-8.44a13.81,13.81,0,0,1,1-4,6.94,6.94,0,0,1,2.58-3.08,7.26,7.26,0,0,1,3.72-1.06,10.62,10.62,0,0,1,3.66.48,6.29,6.29,0,0,1,2.91,2,7,7,0,0,1,1.3,3.09,8.44,8.44,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.27,5.27,0,0,1-4.32-2.14,7.28,7.28,0,0,1-1-3.49,9.52,9.52,0,0,1,.28-3s0,.07,0,.19,0,.34-.07.57a12.65,12.65,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.15,2h0a5.8,5.8,0,0,0,4.16-2.55,8.1,8.1,0,0,0,.79-5.7,6.61,6.61,0,0,0-1.25-2.91,5.9,5.9,0,0,0-2.72-1.87,10.26,10.26,0,0,0-3.52-.44,6.88,6.88,0,0,0-3.49,1,6.57,6.57,0,0,0-2.39,2.9,13.39,13.39,0,0,0-1,3.88c-.31,2.71.55,5.48,1.54,8.22l6,17.33c1.69,4.77,3.33,9.43,4.91,13.92a52.6,52.6,0,0,1,2.12,6.71,24.09,24.09,0,0,1,.57,6.73,11.12,11.12,0,0,1-2,6.1,5.45,5.45,0,0,1-2.58,1.76,8.51,8.51,0,0,1-3,.29,8.93,8.93,0,0,1-5.32-1.75,6.36,6.36,0,0,1-2.29-4.59v0a9.1,9.1,0,0,1,.76-4.48,5.21,5.21,0,0,1,1.28-1.68,4.78,4.78,0,0,1,1.76-.91,6.23,6.23,0,0,1,3.51,0,4.24,4.24,0,0,1,2.32,1.79,6.22,6.22,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71c0,.46,0,.81,0,1.05A1.68,1.68,0,0,1,110.6,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53,426.09c-.15,0-.26-32.39-.26-72.34s.11-72.35.26-72.35.26,32.39.26,72.35S131.67,426.09,131.53,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.84,426.09c-.15,0-.26-32.39-.26-72.34s.11-72.35.26-72.35.26,32.39.26,72.35S100,426.09,99.84,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,348.75a1.12,1.12,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,8.93,8.93,0,0,1,.17-1.71,5.89,5.89,0,0,1,.84-2.19,4.2,4.2,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.89,4.89,0,0,1,1.76.92,5.34,5.34,0,0,1,1.26,1.69,9,9,0,0,1,.73,4.48v0a6.29,6.29,0,0,1-2.31,4.57A8.82,8.82,0,0,1,91.5,355a8.54,8.54,0,0,1-3-.32,5.37,5.37,0,0,1-2.57-1.77A11.24,11.24,0,0,1,84,346.83a24.52,24.52,0,0,1,.61-6.73,51,51,0,0,1,2.16-6.69l5-13.89c2.12-6,4.17-11.77,6.12-17.29,1-2.73,1.87-5.5,1.58-8.22a13.45,13.45,0,0,0-.94-3.88,6.49,6.49,0,0,0-2.37-2.91,6.92,6.92,0,0,0-3.49-1,10.54,10.54,0,0,0-3.52.42,6,6,0,0,0-2.73,1.85,6.64,6.64,0,0,0-1.27,2.91,8.21,8.21,0,0,0,.76,5.7,5.82,5.82,0,0,0,4.15,2.58h0a5,5,0,0,0,4.16-1.95,7.25,7.25,0,0,0,1-3.36,12.8,12.8,0,0,0,0-2.23l-.06-.57a.6.6,0,0,1,0-.2,9.28,9.28,0,0,1,.26,3,7.26,7.26,0,0,1-1,3.47A5.23,5.23,0,0,1,90,299.93h0a6.08,6.08,0,0,1-4.4-2.68,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.33,6.33,0,0,1,2.92-2,10.7,10.7,0,0,1,3.67-.46,7.36,7.36,0,0,1,3.71,1.09,7,7,0,0,1,2.56,3.1,13.7,13.7,0,0,1,1,4c.32,2.85-.59,5.71-1.59,8.43-1.94,5.52-4,11.32-6.1,17.31-1.71,4.76-3.39,9.4-5,13.88a51.09,51.09,0,0,0-2.15,6.63,23.57,23.57,0,0,0-.62,6.58,10.83,10.83,0,0,0,1.81,5.87,5,5,0,0,0,2.36,1.63,8,8,0,0,0,2.83.31,8.48,8.48,0,0,0,5.1-1.6,6,6,0,0,0,2.2-4.26v0a8.84,8.84,0,0,0-.66-4.3,5,5,0,0,0-1.17-1.6,4.72,4.72,0,0,0-1.65-.88,6.06,6.06,0,0,0-3.35,0,4.07,4.07,0,0,0-2.24,1.65,6,6,0,0,0-.86,2.11,9.94,9.94,0,0,0-.21,1.68c0,.46,0,.81,0,1S88.64,348.75,88.64,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,417.9a1,1,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,8.83,8.83,0,0,1,.17-1.7,5.82,5.82,0,0,1,.84-2.19,4.17,4.17,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.39,5.39,0,0,1,1.26,1.7,9,9,0,0,1,.73,4.48v0a6.3,6.3,0,0,1-2.31,4.57,8.88,8.88,0,0,1-5.33,1.71,8.3,8.3,0,0,1-3-.31,5.51,5.51,0,0,1-2.57-1.77A11.27,11.27,0,0,1,84,416a24.44,24.44,0,0,1,.61-6.72,50.54,50.54,0,0,1,2.16-6.69l5-13.89c2.12-6,4.17-11.78,6.12-17.3,1-2.73,1.87-5.49,1.58-8.21a13.51,13.51,0,0,0-.94-3.89,6.6,6.6,0,0,0-2.37-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.52.42,5.82,5.82,0,0,0-2.73,1.85,6.56,6.56,0,0,0-1.27,2.9,8.21,8.21,0,0,0,.76,5.7,5.83,5.83,0,0,0,4.15,2.59h0a5,5,0,0,0,4.16-2,7.22,7.22,0,0,0,1-3.36,12.85,12.85,0,0,0,0-2.23l-.06-.57c0-.12,0-.19,0-.19a9.24,9.24,0,0,1,.26,3,7.29,7.29,0,0,1-1,3.48A5.25,5.25,0,0,1,90,369.09h0a6.09,6.09,0,0,1-4.4-2.69,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.32,6.32,0,0,1,2.92-2,10.47,10.47,0,0,1,3.67-.46A7.35,7.35,0,0,1,96.39,356a7,7,0,0,1,2.56,3.1,13.76,13.76,0,0,1,1,4c.32,2.84-.59,5.7-1.59,8.43-1.94,5.52-4,11.32-6.1,17.3-1.71,4.76-3.39,9.4-5,13.88a52.1,52.1,0,0,0-2.15,6.63,23.64,23.64,0,0,0-.62,6.59,10.8,10.8,0,0,0,1.81,5.86,5.1,5.1,0,0,0,2.36,1.64,8,8,0,0,0,2.83.3,8.48,8.48,0,0,0,5.1-1.59,6,6,0,0,0,2.2-4.26v0a8.84,8.84,0,0,0-.66-4.3A5.18,5.18,0,0,0,97,412a4.69,4.69,0,0,0-1.65-.87,6,6,0,0,0-3.35,0,4.05,4.05,0,0,0-2.24,1.64,6,6,0,0,0-.86,2.12,10,10,0,0,0-.21,1.67c0,.46,0,.81,0,1.05S88.64,417.9,88.64,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6,6,0,0,0-.83-2.13A4,4,0,0,0,76,341.9a6.16,6.16,0,0,0-3.36,0,4.68,4.68,0,0,0-1.66.85,5,5,0,0,0-1.19,1.58,8.7,8.7,0,0,0-.73,4.29v0a5.93,5.93,0,0,0,2.13,4.3,8.5,8.5,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,5,5,0,0,0,2.39-1.6,10.71,10.71,0,0,0,1.89-5.83,23.59,23.59,0,0,0-.53-6.6,49.82,49.82,0,0,0-2.06-6.66c-1.55-4.51-3.15-9.18-4.8-14-2-6-4-11.85-5.85-17.4-1-2.74-1.83-5.61-1.47-8.45a13.62,13.62,0,0,1,1-4,7,7,0,0,1,2.6-3.07,7.4,7.4,0,0,1,3.73-1,10.64,10.64,0,0,1,3.66.52,6.34,6.34,0,0,1,2.89,2.05,6.9,6.9,0,0,1,1.28,3.09,8.46,8.46,0,0,1-.92,5.94A6.08,6.08,0,0,1,78.47,300h0a5.24,5.24,0,0,1-4.29-2.18,7.15,7.15,0,0,1-1-3.49,9.59,9.59,0,0,1,.29-3s0,.06,0,.19l-.08.57a13.41,13.41,0,0,0,0,2.23,7.11,7.11,0,0,0,1,3.38,5,5,0,0,0,4.12,2h0a5.79,5.79,0,0,0,4.19-2.52,8.18,8.18,0,0,0,.83-5.69,6.73,6.73,0,0,0-1.23-2.92,5.86,5.86,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,6.92,6.92,0,0,0-3.5,1A6.52,6.52,0,0,0,70.1,290a13.34,13.34,0,0,0-1,3.87c-.33,2.71.5,5.49,1.47,8.24l5.87,17.38c1.64,4.79,3.24,9.46,4.79,14a52.38,52.38,0,0,1,2.06,6.72,24.1,24.1,0,0,1,.52,6.74,11.24,11.24,0,0,1-2,6.08,5.38,5.38,0,0,1-2.61,1.73,8,8,0,0,1-3,.26,8.86,8.86,0,0,1-5.3-1.8,6.33,6.33,0,0,1-2.25-4.61v0a9,9,0,0,1,.8-4.47,5.24,5.24,0,0,1,1.29-1.68,5,5,0,0,1,1.77-.88,6.21,6.21,0,0,1,3.51.07,4.24,4.24,0,0,1,2.3,1.82,6,6,0,0,1,.81,2.2,9.53,9.53,0,0,1,.15,1.7c0,.47,0,.82-.06,1.05A1.71,1.71,0,0,1,79.17,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,418.15s0-.12,0-.36,0-.58,0-1a9.11,9.11,0,0,0-.21-1.68,6,6,0,0,0-.84-2.12,4.1,4.1,0,0,0-2.23-1.66,6,6,0,0,0-3.35,0,4.51,4.51,0,0,0-1.65.86,5,5,0,0,0-1.18,1.59,8.73,8.73,0,0,0-.69,4.3v0a6,6,0,0,0,2.18,4.28A8.45,8.45,0,0,0,76,424a8,8,0,0,0,2.84-.28,5.08,5.08,0,0,0,2.37-1.63A10.76,10.76,0,0,0,83,416.22a23.62,23.62,0,0,0-.58-6.59A51.42,51.42,0,0,0,80.33,403c-1.59-4.49-3.24-9.15-4.92-13.92-2.08-6-4.09-11.8-6-17.34-1-2.73-1.87-5.59-1.54-8.44a13.81,13.81,0,0,1,1-4,7,7,0,0,1,2.57-3.08,7.29,7.29,0,0,1,3.72-1.06,10.71,10.71,0,0,1,3.67.48,6.4,6.4,0,0,1,2.91,2,7,7,0,0,1,1.3,3.09,8.5,8.5,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.23,5.23,0,0,1-4.31-2.14,7.17,7.17,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3s0,.07,0,.19l-.06.57a12.65,12.65,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.82,5.82,0,0,0,4.16-2.55,8.21,8.21,0,0,0,.79-5.7,6.73,6.73,0,0,0-1.25-2.91A5.93,5.93,0,0,0,78.7,356a10.2,10.2,0,0,0-3.51-.44,6.88,6.88,0,0,0-3.49,1,6.44,6.44,0,0,0-2.39,2.9,13.07,13.07,0,0,0-1,3.88c-.31,2.71.55,5.48,1.53,8.22l6,17.33c1.68,4.77,3.32,9.43,4.91,13.92a52.6,52.6,0,0,1,2.12,6.71,24.47,24.47,0,0,1,.57,6.73,11.21,11.21,0,0,1-2,6.1,5.52,5.52,0,0,1-2.59,1.76,8.47,8.47,0,0,1-3,.29,8.88,8.88,0,0,1-5.32-1.75,6.32,6.32,0,0,1-2.29-4.59v0a9.09,9.09,0,0,1,.75-4.48,5.51,5.51,0,0,1,1.28-1.68,4.9,4.9,0,0,1,1.77-.91,6.23,6.23,0,0,1,3.51,0A4.22,4.22,0,0,1,78,412.85,5.85,5.85,0,0,1,78.8,415a8.89,8.89,0,0,1,.16,1.71,7.14,7.14,0,0,1,0,1.05A1.12,1.12,0,0,1,78.85,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.78,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S99.93,426.09,99.78,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.09,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S68.24,426.09,68.09,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,348.75a1.12,1.12,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,8.93,8.93,0,0,1,.17-1.71,5.89,5.89,0,0,1,.84-2.19,4.24,4.24,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.89,4.89,0,0,1,1.76.92,5.34,5.34,0,0,1,1.26,1.69,9,9,0,0,1,.73,4.48v0a6.29,6.29,0,0,1-2.31,4.57,8.82,8.82,0,0,1-5.33,1.72,8.54,8.54,0,0,1-3-.32,5.37,5.37,0,0,1-2.57-1.77,11.24,11.24,0,0,1-1.94-6.11,24.15,24.15,0,0,1,.62-6.73,52.5,52.5,0,0,1,2.15-6.69l5-13.89c2.12-6,4.17-11.77,6.12-17.29,1-2.73,1.88-5.5,1.58-8.22a13.13,13.13,0,0,0-.94-3.88,6.49,6.49,0,0,0-2.37-2.91,6.92,6.92,0,0,0-3.49-1,10.45,10.45,0,0,0-3.51.42,6,6,0,0,0-2.74,1.85,6.63,6.63,0,0,0-1.26,2.91,8.15,8.15,0,0,0,.75,5.7,5.82,5.82,0,0,0,4.15,2.58h0a5,5,0,0,0,4.16-1.95,7.25,7.25,0,0,0,1-3.36,12.8,12.8,0,0,0,0-2.23c0-.24,0-.42-.06-.57a1.35,1.35,0,0,1,0-.2,9.28,9.28,0,0,1,.26,3,7.26,7.26,0,0,1-1,3.47,5.21,5.21,0,0,1-4.33,2.11h0a6.08,6.08,0,0,1-4.41-2.68,8.5,8.5,0,0,1-.85-5.95,7.07,7.07,0,0,1,1.32-3.08,6.33,6.33,0,0,1,2.92-2,10.7,10.7,0,0,1,3.67-.46,7.43,7.43,0,0,1,3.72,1.09,7,7,0,0,1,2.55,3.1,13.7,13.7,0,0,1,1,4c.32,2.85-.59,5.71-1.58,8.43-1.95,5.52-4,11.32-6.11,17.31-1.71,4.76-3.38,9.4-5,13.88a51.09,51.09,0,0,0-2.15,6.63,23.57,23.57,0,0,0-.62,6.58,10.83,10.83,0,0,0,1.81,5.87,5,5,0,0,0,2.36,1.63,8,8,0,0,0,2.83.31,8.48,8.48,0,0,0,5.1-1.6,5.91,5.91,0,0,0,2.2-4.26v0a8.72,8.72,0,0,0-.66-4.3,5,5,0,0,0-1.17-1.6,4.76,4.76,0,0,0-1.64-.88,6.1,6.1,0,0,0-3.36,0,4,4,0,0,0-2.23,1.65,5.85,5.85,0,0,0-.86,2.11,10.08,10.08,0,0,0-.22,1.68c0,.46,0,.81,0,1A2.43,2.43,0,0,1,183.75,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,417.9a1,1,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,8.83,8.83,0,0,1,.17-1.7,5.82,5.82,0,0,1,.84-2.19,4.21,4.21,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.39,5.39,0,0,1,1.26,1.7,9,9,0,0,1,.73,4.48v0a6.3,6.3,0,0,1-2.31,4.57,8.88,8.88,0,0,1-5.33,1.71,8.3,8.3,0,0,1-3-.31,5.51,5.51,0,0,1-2.57-1.77,11.27,11.27,0,0,1-1.94-6.12,24.08,24.08,0,0,1,.62-6.72,52,52,0,0,1,2.15-6.69l5-13.89c2.12-6,4.17-11.78,6.12-17.3,1-2.73,1.88-5.49,1.58-8.21a13.19,13.19,0,0,0-.94-3.89,6.6,6.6,0,0,0-2.37-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.51.42,5.8,5.8,0,0,0-2.74,1.85,6.54,6.54,0,0,0-1.26,2.9,8.15,8.15,0,0,0,.75,5.7,5.83,5.83,0,0,0,4.15,2.59h0a5,5,0,0,0,4.16-2,7.22,7.22,0,0,0,1-3.36,12.85,12.85,0,0,0,0-2.23q0-.35-.06-.57a1.29,1.29,0,0,1,0-.19,9.24,9.24,0,0,1,.26,3,7.29,7.29,0,0,1-1,3.48,5.24,5.24,0,0,1-4.33,2.11h0a6.09,6.09,0,0,1-4.41-2.69,8.5,8.5,0,0,1-.85-5.95,7.12,7.12,0,0,1,1.32-3.08,6.32,6.32,0,0,1,2.92-2,10.47,10.47,0,0,1,3.67-.46,7.41,7.41,0,0,1,3.72,1.08,7,7,0,0,1,2.55,3.1,13.76,13.76,0,0,1,1,4c.32,2.84-.59,5.7-1.58,8.43l-6.11,17.3c-1.71,4.76-3.38,9.4-5,13.88a52.1,52.1,0,0,0-2.15,6.63,23.64,23.64,0,0,0-.62,6.59,10.8,10.8,0,0,0,1.81,5.86,5.1,5.1,0,0,0,2.36,1.64,8,8,0,0,0,2.83.3,8.48,8.48,0,0,0,5.1-1.59,6,6,0,0,0,2.2-4.26v0a8.72,8.72,0,0,0-.66-4.3,5.18,5.18,0,0,0-1.17-1.61,4.74,4.74,0,0,0-1.64-.87,6,6,0,0,0-3.36,0,4,4,0,0,0-2.23,1.64,5.82,5.82,0,0,0-.86,2.12,10.11,10.11,0,0,0-.22,1.67c0,.46,0,.81,0,1.05A2.31,2.31,0,0,1,183.75,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a10.92,10.92,0,0,0-.2-1.68,6,6,0,0,0-.83-2.13,4,4,0,0,0-2.2-1.69,6.16,6.16,0,0,0-3.36,0,4.64,4.64,0,0,0-1.65.85,5.13,5.13,0,0,0-1.2,1.58,8.58,8.58,0,0,0-.72,4.29v0a5.94,5.94,0,0,0,2.14,4.3,8.45,8.45,0,0,0,5.07,1.68,8,8,0,0,0,2.83-.25,5,5,0,0,0,2.39-1.6,10.71,10.71,0,0,0,1.89-5.83,23.59,23.59,0,0,0-.53-6.6,51.25,51.25,0,0,0-2.05-6.66c-1.55-4.51-3.16-9.18-4.81-14-2-6-4-11.85-5.85-17.4-.95-2.74-1.82-5.61-1.47-8.45a13.62,13.62,0,0,1,1-4,7,7,0,0,1,2.6-3.07,7.4,7.4,0,0,1,3.73-1,10.64,10.64,0,0,1,3.66.52,6.29,6.29,0,0,1,2.89,2.05A6.9,6.9,0,0,1,179,291.4a8.46,8.46,0,0,1-.92,5.94,6.08,6.08,0,0,1-4.45,2.62h0a5.24,5.24,0,0,1-4.29-2.18,7.15,7.15,0,0,1-1-3.49,9.35,9.35,0,0,1,.3-3s0,.06,0,.19-.05.34-.08.57a13.41,13.41,0,0,0-.05,2.23,7.11,7.11,0,0,0,1,3.38,5,5,0,0,0,4.13,2h0a5.79,5.79,0,0,0,4.19-2.52,8.18,8.18,0,0,0,.83-5.69,6.61,6.61,0,0,0-1.23-2.92,5.86,5.86,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,6.92,6.92,0,0,0-3.5,1,6.44,6.44,0,0,0-2.41,2.88,13.35,13.35,0,0,0-1,3.87c-.33,2.71.51,5.49,1.47,8.24l5.87,17.38c1.64,4.79,3.24,9.46,4.79,14a52.38,52.38,0,0,1,2.06,6.72,24.1,24.1,0,0,1,.52,6.74,11.24,11.24,0,0,1-2,6.08,5.38,5.38,0,0,1-2.61,1.73,8,8,0,0,1-3,.26,8.89,8.89,0,0,1-5.3-1.8,6.37,6.37,0,0,1-2.25-4.61v0a8.94,8.94,0,0,1,.79-4.47,5.38,5.38,0,0,1,1.29-1.68,4.94,4.94,0,0,1,1.78-.88,6.18,6.18,0,0,1,3.5.07,4.24,4.24,0,0,1,2.3,1.82,6,6,0,0,1,.81,2.2,9.53,9.53,0,0,1,.15,1.7,8.21,8.21,0,0,1-.06,1.05A1.71,1.71,0,0,1,174.28,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,418.15a1.63,1.63,0,0,1,0-.36c0-.23,0-.58,0-1a9.92,9.92,0,0,0-.2-1.68,6,6,0,0,0-.85-2.12,4.07,4.07,0,0,0-2.23-1.66,6,6,0,0,0-3.35,0,4.51,4.51,0,0,0-1.65.86,5.12,5.12,0,0,0-1.18,1.59,8.84,8.84,0,0,0-.69,4.3v0a6,6,0,0,0,2.18,4.28,8.45,8.45,0,0,0,5.09,1.63,7.94,7.94,0,0,0,2.83-.28,5.08,5.08,0,0,0,2.37-1.63,10.76,10.76,0,0,0,1.84-5.85,23.62,23.62,0,0,0-.58-6.59,51.42,51.42,0,0,0-2.11-6.64c-1.59-4.49-3.24-9.15-4.92-13.92-2.08-6-4.09-11.8-6-17.34-1-2.73-1.87-5.59-1.54-8.44a13.81,13.81,0,0,1,1-4,7,7,0,0,1,2.57-3.08,7.33,7.33,0,0,1,3.73-1.06,10.69,10.69,0,0,1,3.66.48,6.4,6.4,0,0,1,2.91,2,7,7,0,0,1,1.3,3.09,8.5,8.5,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.25,5.25,0,0,1-4.32-2.14,7.28,7.28,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3,.69.69,0,0,1,0,.19c0,.15,0,.34-.07.57a12.65,12.65,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.82,5.82,0,0,0,4.16-2.55,8.21,8.21,0,0,0,.79-5.7,6.61,6.61,0,0,0-1.25-2.91,5.9,5.9,0,0,0-2.72-1.87,10.26,10.26,0,0,0-3.52-.44,6.88,6.88,0,0,0-3.49,1,6.44,6.44,0,0,0-2.39,2.9,13.39,13.39,0,0,0-1,3.88c-.31,2.71.55,5.48,1.54,8.22l6,17.33c1.68,4.77,3.33,9.43,4.91,13.92a52.6,52.6,0,0,1,2.12,6.71,24.47,24.47,0,0,1,.57,6.73,11.21,11.21,0,0,1-2,6.1,5.49,5.49,0,0,1-2.58,1.76,8.53,8.53,0,0,1-3,.29,8.93,8.93,0,0,1-5.32-1.75,6.32,6.32,0,0,1-2.29-4.59v0a9.1,9.1,0,0,1,.76-4.48,5.33,5.33,0,0,1,1.27-1.68,4.9,4.9,0,0,1,1.77-.91,6.23,6.23,0,0,1,3.51,0,4.24,4.24,0,0,1,2.32,1.79,6,6,0,0,1,.82,2.19,8.15,8.15,0,0,1,.16,1.71,9.37,9.37,0,0,1,0,1.05A1.68,1.68,0,0,1,174,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,426.09c-.15,0-.27-32.39-.27-72.34s.12-72.35.27-72.35.26,32.39.26,72.35S195,426.09,194.9,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S163.35,426.09,163.2,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,348.75a1.41,1.41,0,0,1-.05-.35,7.14,7.14,0,0,1,0-1,9.82,9.82,0,0,1,.17-1.71,6.1,6.1,0,0,1,.85-2.19,4.2,4.2,0,0,1,2.33-1.77,6.21,6.21,0,0,1,3.5,0,4.81,4.81,0,0,1,1.76.92,5.23,5.23,0,0,1,1.27,1.69,9.11,9.11,0,0,1,.73,4.48v0a6.26,6.26,0,0,1-2.32,4.57,8.78,8.78,0,0,1-5.33,1.72,8.5,8.5,0,0,1-3-.32,5.44,5.44,0,0,1-2.58-1.77,11.15,11.15,0,0,1-1.93-6.11,24.13,24.13,0,0,1,.61-6.73,51,51,0,0,1,2.16-6.69l5-13.89c2.11-6,4.16-11.77,6.12-17.29,1-2.73,1.87-5.5,1.58-8.22a13.78,13.78,0,0,0-.94-3.88,6.49,6.49,0,0,0-2.37-2.91,7,7,0,0,0-3.49-1,10.51,10.51,0,0,0-3.52.42,6.05,6.05,0,0,0-2.74,1.85,6.74,6.74,0,0,0-1.26,2.91,8.21,8.21,0,0,0,.76,5.7,5.8,5.8,0,0,0,4.15,2.58h0a5,5,0,0,0,4.15-1.95,7,7,0,0,0,1-3.36,13,13,0,0,0,0-2.23c0-.24-.05-.42-.07-.57a.76.76,0,0,1,0-.2,9.52,9.52,0,0,1,.25,3,7,7,0,0,1-1,3.47,5.19,5.19,0,0,1-4.32,2.11h0a6.08,6.08,0,0,1-4.4-2.68,8.45,8.45,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.28,6.28,0,0,1,2.92-2,10.7,10.7,0,0,1,3.67-.46,7.39,7.39,0,0,1,3.71,1.09,7,7,0,0,1,2.56,3.1,14,14,0,0,1,1,4c.31,2.85-.59,5.71-1.59,8.43-1.95,5.52-4,11.32-6.1,17.31-1.71,4.76-3.39,9.4-5,13.88a49.61,49.61,0,0,0-2.15,6.63,23.57,23.57,0,0,0-.62,6.58,10.75,10.75,0,0,0,1.81,5.87,5,5,0,0,0,2.36,1.63,8,8,0,0,0,2.83.31,8.43,8.43,0,0,0,5.09-1.6,5.93,5.93,0,0,0,2.21-4.26v0a8.84,8.84,0,0,0-.66-4.3,4.9,4.9,0,0,0-1.18-1.6,4.59,4.59,0,0,0-1.64-.88,6.06,6.06,0,0,0-3.35,0,4,4,0,0,0-2.24,1.65,6,6,0,0,0-.86,2.11,9,9,0,0,0-.21,1.68,9.29,9.29,0,0,0,0,1A1.63,1.63,0,0,1,152,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,417.9a1.19,1.19,0,0,1-.05-.35,7.06,7.06,0,0,1,0-1.05,9.71,9.71,0,0,1,.17-1.7,6,6,0,0,1,.85-2.19,4.17,4.17,0,0,1,2.33-1.78,6.3,6.3,0,0,1,3.5,0,5,5,0,0,1,1.76.92,5.27,5.27,0,0,1,1.27,1.7,9.09,9.09,0,0,1,.73,4.48v0a6.28,6.28,0,0,1-2.32,4.57,8.84,8.84,0,0,1-5.33,1.71,8.27,8.27,0,0,1-3-.31,5.59,5.59,0,0,1-2.58-1.77,11.18,11.18,0,0,1-1.93-6.12,24.06,24.06,0,0,1,.61-6.72,50.54,50.54,0,0,1,2.16-6.69l5-13.89c2.11-6,4.16-11.78,6.12-17.3,1-2.73,1.87-5.49,1.58-8.21a13.85,13.85,0,0,0-.94-3.89,6.6,6.6,0,0,0-2.37-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.52.42,5.9,5.9,0,0,0-2.74,1.85,6.66,6.66,0,0,0-1.26,2.9,8.21,8.21,0,0,0,.76,5.7,5.82,5.82,0,0,0,4.15,2.59h0a5,5,0,0,0,4.15-2,7,7,0,0,0,1-3.36,13.06,13.06,0,0,0,0-2.23c0-.23-.05-.42-.07-.57a.69.69,0,0,1,0-.19,9.48,9.48,0,0,1,.25,3,7.07,7.07,0,0,1-1,3.48,5.22,5.22,0,0,1-4.32,2.11h0a6.09,6.09,0,0,1-4.4-2.69,8.45,8.45,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.26,6.26,0,0,1,2.92-2,10.47,10.47,0,0,1,3.67-.46,7.38,7.38,0,0,1,3.71,1.08,7,7,0,0,1,2.56,3.1,14.09,14.09,0,0,1,1,4c.31,2.84-.59,5.7-1.59,8.43-1.95,5.52-4,11.32-6.1,17.3-1.71,4.76-3.39,9.4-5,13.88a50.56,50.56,0,0,0-2.15,6.63,23.64,23.64,0,0,0-.62,6.59,10.72,10.72,0,0,0,1.81,5.86,5,5,0,0,0,2.36,1.64,8,8,0,0,0,2.83.3,8.43,8.43,0,0,0,5.09-1.59,6,6,0,0,0,2.21-4.26v0a8.84,8.84,0,0,0-.66-4.3,5,5,0,0,0-1.18-1.61,4.57,4.57,0,0,0-1.64-.87,6,6,0,0,0-3.35,0,4,4,0,0,0-2.24,1.64,6,6,0,0,0-.86,2.12,9,9,0,0,0-.21,1.67,9.46,9.46,0,0,0,0,1.05A1.55,1.55,0,0,1,152,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,348.8s0-.13,0-.36,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6,6,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.12,6.12,0,0,0-3.35,0,4.68,4.68,0,0,0-1.66.85,5,5,0,0,0-1.19,1.58,8.7,8.7,0,0,0-.73,4.29v0a6,6,0,0,0,2.14,4.3,8.47,8.47,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,4.93,4.93,0,0,0,2.38-1.6,10.71,10.71,0,0,0,1.9-5.83,23.59,23.59,0,0,0-.53-6.6,51.32,51.32,0,0,0-2.06-6.66c-1.55-4.51-3.15-9.18-4.8-14-2-6-4-11.85-5.85-17.4-1-2.74-1.83-5.61-1.47-8.45a13.93,13.93,0,0,1,1-4,7,7,0,0,1,2.61-3.07,7.35,7.35,0,0,1,3.73-1,10.68,10.68,0,0,1,3.66.52,6.34,6.34,0,0,1,2.89,2.05,7.13,7.13,0,0,1,1.28,3.09,8.46,8.46,0,0,1-.93,5.94,6,6,0,0,1-4.44,2.62h0a5.24,5.24,0,0,1-4.29-2.18,7.15,7.15,0,0,1-1-3.49,9.22,9.22,0,0,1,.29-3s0,.06,0,.19,0,.34-.07.57a13.18,13.18,0,0,0-.06,2.23,7.25,7.25,0,0,0,1,3.38,5,5,0,0,0,4.12,2h0a5.75,5.75,0,0,0,4.18-2.52,8.18,8.18,0,0,0,.84-5.69,6.73,6.73,0,0,0-1.23-2.92,5.86,5.86,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,6.92,6.92,0,0,0-3.5,1,6.52,6.52,0,0,0-2.42,2.88,13.34,13.34,0,0,0-1,3.87c-.33,2.71.5,5.49,1.47,8.24,1.87,5.54,3.84,11.37,5.86,17.38,1.65,4.79,3.25,9.46,4.8,14a52.38,52.38,0,0,1,2.06,6.72,24.48,24.48,0,0,1,.52,6.74,11.24,11.24,0,0,1-2,6.08,5.42,5.42,0,0,1-2.61,1.73,8,8,0,0,1-3,.26,8.86,8.86,0,0,1-5.3-1.8,6.33,6.33,0,0,1-2.25-4.61v0a9,9,0,0,1,.79-4.47,5.41,5.41,0,0,1,1.3-1.68,5,5,0,0,1,1.77-.88,6.21,6.21,0,0,1,3.51.07,4.24,4.24,0,0,1,2.3,1.82,6,6,0,0,1,.81,2.2,10.63,10.63,0,0,1,.09,2.75A1.31,1.31,0,0,1,142.53,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,418.15a2.43,2.43,0,0,1,0-.36c0-.23,0-.58,0-1a10.06,10.06,0,0,0-.21-1.68,5.85,5.85,0,0,0-.85-2.12,4,4,0,0,0-2.22-1.66,6,6,0,0,0-3.35,0,4.43,4.43,0,0,0-1.65.86,5,5,0,0,0-1.18,1.59,8.73,8.73,0,0,0-.69,4.3v0a6,6,0,0,0,2.18,4.28,8.42,8.42,0,0,0,5.08,1.63,8,8,0,0,0,2.84-.28,5,5,0,0,0,2.36-1.63,10.69,10.69,0,0,0,1.85-5.85,24,24,0,0,0-.58-6.59A51.42,51.42,0,0,0,143.7,403l-4.93-13.92-6-17.34c-1-2.73-1.87-5.59-1.53-8.44a14.12,14.12,0,0,1,1-4,7,7,0,0,1,2.58-3.08,7.29,7.29,0,0,1,3.72-1.06,10.71,10.71,0,0,1,3.67.48,6.32,6.32,0,0,1,2.9,2,7.07,7.07,0,0,1,1.31,3.09,8.5,8.5,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.23,5.23,0,0,1-4.31-2.14,7.17,7.17,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3s0,.07,0,.19,0,.34-.07.57a14,14,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.84,5.84,0,0,0,4.16-2.55,8.21,8.21,0,0,0,.79-5.7,6.73,6.73,0,0,0-1.25-2.91,5.93,5.93,0,0,0-2.73-1.87,10.2,10.2,0,0,0-3.51-.44,7,7,0,0,0-3.5,1,6.57,6.57,0,0,0-2.39,2.9,13.38,13.38,0,0,0-.95,3.88c-.31,2.71.54,5.48,1.53,8.22l6,17.33c1.68,4.77,3.32,9.43,4.91,13.92a51,51,0,0,1,2.11,6.71,24.1,24.1,0,0,1,.58,6.73,11.21,11.21,0,0,1-2,6.1,5.52,5.52,0,0,1-2.59,1.76,8.51,8.51,0,0,1-3,.29,8.87,8.87,0,0,1-5.31-1.75,6.32,6.32,0,0,1-2.29-4.59v0a9.09,9.09,0,0,1,.75-4.48,5.36,5.36,0,0,1,1.28-1.68,4.82,4.82,0,0,1,1.77-.91,6.19,6.19,0,0,1,3.5,0,4.2,4.2,0,0,1,2.32,1.79,5.85,5.85,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71,7.14,7.14,0,0,1-.05,1.05A1.12,1.12,0,0,1,142.22,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S163.3,426.09,163.15,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.46,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S131.6,426.09,131.46,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,348.75a1.12,1.12,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,9.69,9.69,0,0,1,.16-1.71,6.1,6.1,0,0,1,.85-2.19,4.2,4.2,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.89,4.89,0,0,1,1.76.92,5.34,5.34,0,0,1,1.26,1.69,9,9,0,0,1,.73,4.48v0a6.26,6.26,0,0,1-2.32,4.57A8.77,8.77,0,0,1,250,355a8.54,8.54,0,0,1-3-.32,5.37,5.37,0,0,1-2.57-1.77,11.24,11.24,0,0,1-1.94-6.11,24.13,24.13,0,0,1,.61-6.73,51,51,0,0,1,2.16-6.69l5-13.89c2.11-6,4.16-11.77,6.12-17.29,1-2.73,1.87-5.5,1.58-8.22a13.45,13.45,0,0,0-.94-3.88,6.49,6.49,0,0,0-2.37-2.91,6.92,6.92,0,0,0-3.49-1,10.54,10.54,0,0,0-3.52.42,6,6,0,0,0-2.73,1.85,6.64,6.64,0,0,0-1.27,2.91,8.21,8.21,0,0,0,.76,5.7,5.8,5.8,0,0,0,4.15,2.58h0a5,5,0,0,0,4.16-1.95,7.25,7.25,0,0,0,1.05-3.36,13.89,13.89,0,0,0,0-2.23l-.06-.57a.6.6,0,0,1,0-.2,9.52,9.52,0,0,1,.25,3,7.12,7.12,0,0,1-1,3.47,5.23,5.23,0,0,1-4.33,2.11h0a6.08,6.08,0,0,1-4.4-2.68,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.33,6.33,0,0,1,2.92-2,10.7,10.7,0,0,1,3.67-.46,7.36,7.36,0,0,1,3.71,1.09,7,7,0,0,1,2.56,3.1,13.7,13.7,0,0,1,1,4c.32,2.85-.59,5.71-1.59,8.43-1.94,5.52-4,11.32-6.1,17.31-1.71,4.76-3.39,9.4-5,13.88a51.09,51.09,0,0,0-2.15,6.63,23.57,23.57,0,0,0-.62,6.58,10.83,10.83,0,0,0,1.81,5.87,5,5,0,0,0,2.36,1.63,8,8,0,0,0,2.83.31,8.48,8.48,0,0,0,5.1-1.6,6,6,0,0,0,2.2-4.26v0a8.84,8.84,0,0,0-.66-4.3,5,5,0,0,0-1.17-1.6,4.72,4.72,0,0,0-1.65-.88,6.06,6.06,0,0,0-3.35,0,4.07,4.07,0,0,0-2.24,1.65,6,6,0,0,0-.86,2.11,9.94,9.94,0,0,0-.21,1.68c0,.46,0,.81,0,1S247.12,348.75,247.12,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,417.9a1,1,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,9.58,9.58,0,0,1,.16-1.7,6,6,0,0,1,.85-2.19,4.17,4.17,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.39,5.39,0,0,1,1.26,1.7,9,9,0,0,1,.73,4.48v0a6.28,6.28,0,0,1-2.32,4.57,8.83,8.83,0,0,1-5.32,1.71,8.3,8.3,0,0,1-3-.31,5.51,5.51,0,0,1-2.57-1.77,11.27,11.27,0,0,1-1.94-6.12,24.06,24.06,0,0,1,.61-6.72,50.54,50.54,0,0,1,2.16-6.69l5-13.89c2.11-6,4.16-11.78,6.12-17.3,1-2.73,1.87-5.49,1.58-8.21a13.51,13.51,0,0,0-.94-3.89,6.6,6.6,0,0,0-2.37-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.52.42,5.82,5.82,0,0,0-2.73,1.85,6.56,6.56,0,0,0-1.27,2.9,8.21,8.21,0,0,0,.76,5.7,5.82,5.82,0,0,0,4.15,2.59h0a5,5,0,0,0,4.16-2,7.22,7.22,0,0,0,1.05-3.36,14,14,0,0,0,0-2.23l-.06-.57c0-.12,0-.19,0-.19a9.48,9.48,0,0,1,.25,3,7.16,7.16,0,0,1-1,3.48,5.25,5.25,0,0,1-4.33,2.11h0a6.09,6.09,0,0,1-4.4-2.69,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.32,6.32,0,0,1,2.92-2,10.47,10.47,0,0,1,3.67-.46,7.35,7.35,0,0,1,3.71,1.08,7,7,0,0,1,2.56,3.1,13.76,13.76,0,0,1,1,4c.32,2.84-.59,5.7-1.59,8.43-1.94,5.52-4,11.32-6.1,17.3-1.71,4.76-3.39,9.4-5,13.88a52.1,52.1,0,0,0-2.15,6.63A23.64,23.64,0,0,0,243,416a10.8,10.8,0,0,0,1.81,5.86,5.1,5.1,0,0,0,2.36,1.64,8,8,0,0,0,2.83.3,8.48,8.48,0,0,0,5.1-1.59,6,6,0,0,0,2.2-4.26v0a8.84,8.84,0,0,0-.66-4.3,5.18,5.18,0,0,0-1.17-1.61,4.69,4.69,0,0,0-1.65-.87,6,6,0,0,0-3.35,0,4.05,4.05,0,0,0-2.24,1.64,6,6,0,0,0-.86,2.12,10,10,0,0,0-.21,1.67c0,.46,0,.81,0,1.05S247.12,417.9,247.12,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.65,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6,6,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.12,6.12,0,0,0-3.35,0,4.68,4.68,0,0,0-1.66.85,5,5,0,0,0-1.19,1.58,8.7,8.7,0,0,0-.73,4.29v0a6,6,0,0,0,2.14,4.3,8.5,8.5,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,5,5,0,0,0,2.39-1.6,10.79,10.79,0,0,0,1.89-5.83,23.59,23.59,0,0,0-.53-6.6,51.32,51.32,0,0,0-2.06-6.66c-1.55-4.51-3.15-9.18-4.8-14-2-6-4-11.85-5.85-17.4-1-2.74-1.83-5.61-1.47-8.45a13.62,13.62,0,0,1,1-4,7,7,0,0,1,2.6-3.07,7.38,7.38,0,0,1,3.73-1,10.64,10.64,0,0,1,3.66.52,6.34,6.34,0,0,1,2.89,2.05,7,7,0,0,1,1.28,3.09,8.46,8.46,0,0,1-.92,5.94A6.08,6.08,0,0,1,237,300h0a5.24,5.24,0,0,1-4.29-2.18,7.15,7.15,0,0,1-1-3.49,9.22,9.22,0,0,1,.29-3s0,.06,0,.19l-.07.57a12.39,12.39,0,0,0-.05,2.23,7.11,7.11,0,0,0,1,3.38,5,5,0,0,0,4.12,2h0a5.79,5.79,0,0,0,4.19-2.52,8.18,8.18,0,0,0,.83-5.69,6.73,6.73,0,0,0-1.23-2.92,5.86,5.86,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,6.92,6.92,0,0,0-3.5,1,6.52,6.52,0,0,0-2.42,2.88,13.34,13.34,0,0,0-1,3.87c-.33,2.71.5,5.49,1.47,8.24,1.87,5.54,3.84,11.37,5.86,17.38,1.65,4.79,3.25,9.46,4.8,14a52.38,52.38,0,0,1,2.06,6.72,24.48,24.48,0,0,1,.52,6.74,11.24,11.24,0,0,1-2,6.08,5.38,5.38,0,0,1-2.61,1.73,8,8,0,0,1-3,.26,8.86,8.86,0,0,1-5.3-1.8,6.33,6.33,0,0,1-2.25-4.61v0a9.16,9.16,0,0,1,.79-4.47,5.41,5.41,0,0,1,1.3-1.68,5,5,0,0,1,1.77-.88,6.21,6.21,0,0,1,3.51.07,4.24,4.24,0,0,1,2.3,1.82,6,6,0,0,1,.81,2.2,9.53,9.53,0,0,1,.15,1.7c0,.47,0,.82-.06,1.05A3.39,3.39,0,0,1,237.65,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33,418.15s0-.12,0-.36,0-.58,0-1a10.06,10.06,0,0,0-.21-1.68,6,6,0,0,0-.84-2.12,4.1,4.1,0,0,0-2.23-1.66,6,6,0,0,0-3.35,0,4.51,4.51,0,0,0-1.65.86,5,5,0,0,0-1.18,1.59,8.73,8.73,0,0,0-.69,4.3v0a6,6,0,0,0,2.18,4.28,8.45,8.45,0,0,0,5.08,1.63,8,8,0,0,0,2.84-.28,5.08,5.08,0,0,0,2.37-1.63,10.76,10.76,0,0,0,1.84-5.85,23.62,23.62,0,0,0-.58-6.59,51.42,51.42,0,0,0-2.11-6.64c-1.59-4.49-3.24-9.15-4.92-13.92-2.08-6-4.09-11.8-6-17.34-1-2.73-1.88-5.59-1.54-8.44a13.81,13.81,0,0,1,1-4,7,7,0,0,1,2.57-3.08,7.29,7.29,0,0,1,3.72-1.06,10.71,10.71,0,0,1,3.67.48,6.4,6.4,0,0,1,2.91,2,7,7,0,0,1,1.3,3.09,8.5,8.5,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.23,5.23,0,0,1-4.31-2.14,7.17,7.17,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3s0,.07,0,.19,0,.34-.06.57a12.65,12.65,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.82,5.82,0,0,0,4.16-2.55,8.21,8.21,0,0,0,.79-5.7,6.73,6.73,0,0,0-1.25-2.91,5.93,5.93,0,0,0-2.73-1.87,10.2,10.2,0,0,0-3.51-.44,6.88,6.88,0,0,0-3.49,1,6.52,6.52,0,0,0-2.4,2.9,13.38,13.38,0,0,0-.95,3.88c-.31,2.71.55,5.48,1.53,8.22l6,17.33c1.68,4.77,3.32,9.43,4.91,13.92a52.6,52.6,0,0,1,2.12,6.71,24.47,24.47,0,0,1,.57,6.73,11.21,11.21,0,0,1-2,6.1,5.52,5.52,0,0,1-2.59,1.76,8.51,8.51,0,0,1-3,.29,8.87,8.87,0,0,1-5.31-1.75,6.32,6.32,0,0,1-2.29-4.59v0a9.09,9.09,0,0,1,.75-4.48,5.51,5.51,0,0,1,1.28-1.68,4.9,4.9,0,0,1,1.77-.91,6.23,6.23,0,0,1,3.51,0,4.22,4.22,0,0,1,2.31,1.79,5.85,5.85,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71,7.14,7.14,0,0,1-.05,1.05A1.12,1.12,0,0,1,237.33,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S258.41,426.09,258.26,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S226.72,426.09,226.57,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.37,348.75a1.68,1.68,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,9.82,9.82,0,0,1,.17-1.71,6.25,6.25,0,0,1,.84-2.19,4.27,4.27,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.81,4.81,0,0,1,1.76.92,5.23,5.23,0,0,1,1.27,1.69,9.11,9.11,0,0,1,.73,4.48v0a6.3,6.3,0,0,1-2.32,4.57,8.8,8.8,0,0,1-5.33,1.72,8.46,8.46,0,0,1-3-.32,5.4,5.4,0,0,1-2.58-1.77,11.15,11.15,0,0,1-1.93-6.11,24.13,24.13,0,0,1,.61-6.73,51,51,0,0,1,2.16-6.69l5-13.89,6.11-17.29c1-2.73,1.88-5.5,1.58-8.22a13.44,13.44,0,0,0-.93-3.88,6.51,6.51,0,0,0-2.38-2.91,6.91,6.91,0,0,0-3.48-1,10.51,10.51,0,0,0-3.52.42,6.05,6.05,0,0,0-2.74,1.85,6.74,6.74,0,0,0-1.26,2.91,8.1,8.1,0,0,0,.76,5.7,5.8,5.8,0,0,0,4.14,2.58h0a5,5,0,0,0,4.15-1.95,7,7,0,0,0,1.05-3.36,13,13,0,0,0,0-2.23l-.07-.57a.76.76,0,0,1,0-.2,9.52,9.52,0,0,1,.25,3,7.15,7.15,0,0,1-1,3.47,5.2,5.2,0,0,1-4.33,2.11h0a6.12,6.12,0,0,1-4.41-2.68,8.5,8.5,0,0,1-.84-5.95,7,7,0,0,1,1.32-3.08,6.28,6.28,0,0,1,2.92-2,10.68,10.68,0,0,1,3.66-.46,7.4,7.4,0,0,1,3.72,1.09,7,7,0,0,1,2.56,3.1,13.69,13.69,0,0,1,1,4c.32,2.85-.59,5.71-1.58,8.43-2,5.52-4,11.32-6.1,17.31-1.72,4.76-3.39,9.4-5,13.88a51.17,51.17,0,0,0-2.16,6.63,23.94,23.94,0,0,0-.61,6.58,10.75,10.75,0,0,0,1.81,5.87,5,5,0,0,0,2.35,1.63,8,8,0,0,0,2.84.31,8.45,8.45,0,0,0,5.09-1.6,5.88,5.88,0,0,0,2.2-4.26v0a8.72,8.72,0,0,0-.67-4.3,4.74,4.74,0,0,0-1.17-1.6,4.59,4.59,0,0,0-1.64-.88,6.06,6.06,0,0,0-3.35,0,4,4,0,0,0-2.24,1.65,6,6,0,0,0-.86,2.11,10.08,10.08,0,0,0-.22,1.68c0,.46,0,.81,0,1A3.24,3.24,0,0,1,215.37,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.37,417.9a1.35,1.35,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,9.71,9.71,0,0,1,.17-1.7,6.18,6.18,0,0,1,.84-2.19,4.24,4.24,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.27,5.27,0,0,1,1.27,1.7,9.09,9.09,0,0,1,.73,4.48v0a6.32,6.32,0,0,1-2.32,4.57,8.86,8.86,0,0,1-5.33,1.71,8.22,8.22,0,0,1-3-.31,5.54,5.54,0,0,1-2.58-1.77,11.18,11.18,0,0,1-1.93-6.12,24.06,24.06,0,0,1,.61-6.72,50.54,50.54,0,0,1,2.16-6.69l5-13.89,6.11-17.3c1-2.73,1.88-5.49,1.58-8.21a13.5,13.5,0,0,0-.93-3.89,6.62,6.62,0,0,0-2.38-2.91,7,7,0,0,0-3.48-1,10,10,0,0,0-3.52.42,5.9,5.9,0,0,0-2.74,1.85,6.66,6.66,0,0,0-1.26,2.9,8.1,8.1,0,0,0,.76,5.7,5.82,5.82,0,0,0,4.14,2.59h0a5,5,0,0,0,4.15-2,7,7,0,0,0,1.05-3.36,13.06,13.06,0,0,0,0-2.23l-.07-.57a.69.69,0,0,1,0-.19,9.48,9.48,0,0,1,.25,3,7.18,7.18,0,0,1-1,3.48,5.23,5.23,0,0,1-4.33,2.11h0a6.13,6.13,0,0,1-4.41-2.69,8.5,8.5,0,0,1-.84-5.95,7,7,0,0,1,1.32-3.08,6.26,6.26,0,0,1,2.92-2,10.44,10.44,0,0,1,3.66-.46,7.38,7.38,0,0,1,3.72,1.08,7,7,0,0,1,2.56,3.1,13.75,13.75,0,0,1,1,4c.32,2.84-.59,5.7-1.58,8.43-2,5.52-4,11.32-6.1,17.3-1.72,4.76-3.39,9.4-5,13.88a52.18,52.18,0,0,0-2.16,6.63,24,24,0,0,0-.61,6.59,10.72,10.72,0,0,0,1.81,5.86,5.07,5.07,0,0,0,2.35,1.64,8,8,0,0,0,2.84.3,8.45,8.45,0,0,0,5.09-1.59,5.91,5.91,0,0,0,2.2-4.26v0a8.72,8.72,0,0,0-.67-4.3,4.88,4.88,0,0,0-1.17-1.61,4.57,4.57,0,0,0-1.64-.87,6,6,0,0,0-3.35,0,4,4,0,0,0-2.24,1.64,6,6,0,0,0-.86,2.12,10.11,10.11,0,0,0-.22,1.67c0,.46,0,.81,0,1.05A3.09,3.09,0,0,1,215.37,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6,6,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.12,6.12,0,0,0-3.35,0,4.68,4.68,0,0,0-1.66.85,5.13,5.13,0,0,0-1.2,1.58,8.81,8.81,0,0,0-.72,4.29v0a6,6,0,0,0,2.14,4.3,8.47,8.47,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,5,5,0,0,0,2.38-1.6,10.71,10.71,0,0,0,1.9-5.83,24,24,0,0,0-.53-6.6,52.92,52.92,0,0,0-2.06-6.66c-1.55-4.51-3.16-9.18-4.8-14-2-6-4-11.85-5.85-17.4-1-2.74-1.83-5.61-1.48-8.45a13.94,13.94,0,0,1,1-4,7.08,7.08,0,0,1,2.6-3.07,7.41,7.41,0,0,1,3.74-1,10.71,10.71,0,0,1,3.66.52,6.34,6.34,0,0,1,2.89,2.05,7.13,7.13,0,0,1,1.28,3.09,8.51,8.51,0,0,1-.93,5.94A6,6,0,0,1,205.2,300h0a5.27,5.27,0,0,1-4.3-2.18,7.26,7.26,0,0,1-1-3.49,9.35,9.35,0,0,1,.3-3s0,.06,0,.19l-.07.57a13.18,13.18,0,0,0-.06,2.23,7.14,7.14,0,0,0,1,3.38,5,5,0,0,0,4.12,2h0a5.77,5.77,0,0,0,4.18-2.52,8.13,8.13,0,0,0,.83-5.69,6.59,6.59,0,0,0-1.22-2.92,5.91,5.91,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,7,7,0,0,0-3.51,1,6.5,6.5,0,0,0-2.41,2.88,13.68,13.68,0,0,0-1,3.87c-.33,2.71.51,5.49,1.47,8.24,1.88,5.54,3.84,11.37,5.87,17.38,1.64,4.79,3.25,9.46,4.79,14a49.38,49.38,0,0,1,2.06,6.72,24.1,24.1,0,0,1,.52,6.74,11.08,11.08,0,0,1-2,6.08,5.35,5.35,0,0,1-2.6,1.73,8.07,8.07,0,0,1-3,.26,8.84,8.84,0,0,1-5.3-1.8,6.33,6.33,0,0,1-2.25-4.61v0a9,9,0,0,1,.79-4.47,5.38,5.38,0,0,1,1.29-1.68,5.11,5.11,0,0,1,1.78-.88,6.21,6.21,0,0,1,3.51.07,4.28,4.28,0,0,1,2.3,1.82,6.19,6.19,0,0,1,.81,2.2,9.41,9.41,0,0,1,.14,1.7,8.65,8.65,0,0,1-.05,1.05A1.31,1.31,0,0,1,205.9,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.59,418.15a2.43,2.43,0,0,1,0-.36c0-.23,0-.58,0-1a10.06,10.06,0,0,0-.21-1.68,6,6,0,0,0-.85-2.12,4,4,0,0,0-2.22-1.66,6,6,0,0,0-3.36,0,4.47,4.47,0,0,0-1.64.86,5.14,5.14,0,0,0-1.19,1.59,8.72,8.72,0,0,0-.68,4.3v0a6,6,0,0,0,2.17,4.28,8.45,8.45,0,0,0,5.09,1.63,7.94,7.94,0,0,0,2.83-.28,5,5,0,0,0,2.37-1.63,10.69,10.69,0,0,0,1.85-5.85,24,24,0,0,0-.58-6.59,53.1,53.1,0,0,0-2.12-6.64c-1.59-4.49-3.23-9.15-4.92-13.92l-6-17.34c-1-2.73-1.87-5.59-1.54-8.44a14.13,14.13,0,0,1,1-4,7,7,0,0,1,2.58-3.08,7.29,7.29,0,0,1,3.72-1.06,10.71,10.71,0,0,1,3.67.48,6.32,6.32,0,0,1,2.9,2,7.19,7.19,0,0,1,1.31,3.09,8.55,8.55,0,0,1-.88,5.95,6.13,6.13,0,0,1-4.43,2.66h0a5.27,5.27,0,0,1-4.32-2.14,7.14,7.14,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3,1.29,1.29,0,0,1,0,.19c0,.15,0,.34-.07.57a15,15,0,0,0,0,2.23,7.15,7.15,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.84,5.84,0,0,0,4.17-2.55,8.16,8.16,0,0,0,.78-5.7,6.71,6.71,0,0,0-1.24-2.91,5.93,5.93,0,0,0-2.73-1.87,10.26,10.26,0,0,0-3.52-.44,6.94,6.94,0,0,0-3.49,1,6.57,6.57,0,0,0-2.39,2.9,13.71,13.71,0,0,0-1,3.88c-.31,2.71.55,5.48,1.54,8.22,1.92,5.53,3.94,11.34,6,17.33,1.69,4.77,3.33,9.43,4.92,13.92a52.53,52.53,0,0,1,2.11,6.71,24.1,24.1,0,0,1,.58,6.73,11.21,11.21,0,0,1-2,6.1,5.52,5.52,0,0,1-2.59,1.76,8.51,8.51,0,0,1-3,.29,8.93,8.93,0,0,1-5.32-1.75,6.35,6.35,0,0,1-2.28-4.59v0a9,9,0,0,1,.75-4.48,5.21,5.21,0,0,1,1.28-1.68,4.78,4.78,0,0,1,1.76-.91,6.23,6.23,0,0,1,3.51,0,4.24,4.24,0,0,1,2.32,1.79,6,6,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71,8.9,8.9,0,0,1,0,1.05A1.68,1.68,0,0,1,205.59,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.52,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S226.66,426.09,226.52,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.83,426.09c-.15,0-.26-32.39-.26-72.34s.11-72.35.26-72.35.26,32.39.26,72.35S195,426.09,194.83,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48,348.75a1.41,1.41,0,0,1-.05-.35,7.14,7.14,0,0,1-.05-1,9.82,9.82,0,0,1,.17-1.71,6.1,6.1,0,0,1,.85-2.19,4.2,4.2,0,0,1,2.33-1.77,6.21,6.21,0,0,1,3.5,0,4.81,4.81,0,0,1,1.76.92,5.23,5.23,0,0,1,1.27,1.69,9.11,9.11,0,0,1,.73,4.48v0a6.26,6.26,0,0,1-2.32,4.57,8.8,8.8,0,0,1-5.33,1.72,8.48,8.48,0,0,1-3-.32,5.44,5.44,0,0,1-2.58-1.77,11.15,11.15,0,0,1-1.93-6.11,24.13,24.13,0,0,1,.61-6.73,51,51,0,0,1,2.16-6.69l5-13.89,6.11-17.29c1-2.73,1.88-5.5,1.58-8.22a13.44,13.44,0,0,0-.93-3.88,6.51,6.51,0,0,0-2.38-2.91,6.88,6.88,0,0,0-3.48-1,10.51,10.51,0,0,0-3.52.42,6.05,6.05,0,0,0-2.74,1.85,6.74,6.74,0,0,0-1.26,2.91,8.1,8.1,0,0,0,.76,5.7,5.8,5.8,0,0,0,4.14,2.58h0A5,5,0,0,0,316,297.7a7,7,0,0,0,1.05-3.36,13,13,0,0,0,0-2.23c0-.24-.05-.42-.07-.57a.76.76,0,0,1,0-.2,9.52,9.52,0,0,1,.25,3,7,7,0,0,1-1,3.47,5.19,5.19,0,0,1-4.32,2.11h0a6.08,6.08,0,0,1-4.4-2.68,8.45,8.45,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.28,6.28,0,0,1,2.92-2,10.7,10.7,0,0,1,3.67-.46,7.39,7.39,0,0,1,3.71,1.09,7,7,0,0,1,2.56,3.1,14,14,0,0,1,1,4c.31,2.85-.6,5.71-1.59,8.43-1.95,5.52-4,11.32-6.1,17.31-1.72,4.76-3.39,9.4-5,13.88a49.61,49.61,0,0,0-2.15,6.63,23.57,23.57,0,0,0-.62,6.58,10.75,10.75,0,0,0,1.81,5.87,5,5,0,0,0,2.36,1.63,8,8,0,0,0,2.83.31,8.43,8.43,0,0,0,5.09-1.6,5.93,5.93,0,0,0,2.21-4.26v0a8.84,8.84,0,0,0-.66-4.3,4.9,4.9,0,0,0-1.18-1.6,4.59,4.59,0,0,0-1.64-.88,6.06,6.06,0,0,0-3.35,0,4,4,0,0,0-2.24,1.65,6,6,0,0,0-.86,2.11,9,9,0,0,0-.21,1.68,9.29,9.29,0,0,0,0,1A1.63,1.63,0,0,1,310.48,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48,417.9a1.19,1.19,0,0,1-.05-.35,7.06,7.06,0,0,1-.05-1.05,9.71,9.71,0,0,1,.17-1.7,6,6,0,0,1,.85-2.19,4.17,4.17,0,0,1,2.33-1.78,6.3,6.3,0,0,1,3.5,0,5,5,0,0,1,1.76.92,5.27,5.27,0,0,1,1.27,1.7,9.09,9.09,0,0,1,.73,4.48v0a6.28,6.28,0,0,1-2.32,4.57,8.86,8.86,0,0,1-5.33,1.71,8.24,8.24,0,0,1-3-.31,5.59,5.59,0,0,1-2.58-1.77,11.18,11.18,0,0,1-1.93-6.12,24.06,24.06,0,0,1,.61-6.72,50.54,50.54,0,0,1,2.16-6.69l5-13.89,6.11-17.3c1-2.73,1.88-5.49,1.58-8.21a13.5,13.5,0,0,0-.93-3.89,6.62,6.62,0,0,0-2.38-2.91,7,7,0,0,0-3.48-1,10,10,0,0,0-3.52.42,5.9,5.9,0,0,0-2.74,1.85,6.66,6.66,0,0,0-1.26,2.9,8.1,8.1,0,0,0,.76,5.7,5.82,5.82,0,0,0,4.14,2.59h0a5,5,0,0,0,4.15-2,7,7,0,0,0,1.05-3.36,13.06,13.06,0,0,0,0-2.23c0-.23-.05-.42-.07-.57a.69.69,0,0,1,0-.19,9.48,9.48,0,0,1,.25,3,7.07,7.07,0,0,1-1,3.48,5.22,5.22,0,0,1-4.32,2.11h0a6.09,6.09,0,0,1-4.4-2.69,8.45,8.45,0,0,1-.85-5.95,7,7,0,0,1,1.32-3.08,6.26,6.26,0,0,1,2.92-2,10.47,10.47,0,0,1,3.67-.46,7.38,7.38,0,0,1,3.71,1.08,7,7,0,0,1,2.56,3.1,14.09,14.09,0,0,1,1,4c.31,2.84-.6,5.7-1.59,8.43-1.95,5.52-4,11.32-6.1,17.3-1.72,4.76-3.39,9.4-5,13.88a50.56,50.56,0,0,0-2.15,6.63,23.64,23.64,0,0,0-.62,6.59,10.72,10.72,0,0,0,1.81,5.86,5,5,0,0,0,2.36,1.64,8,8,0,0,0,2.83.3,8.43,8.43,0,0,0,5.09-1.59,6,6,0,0,0,2.21-4.26v0a8.84,8.84,0,0,0-.66-4.3,5,5,0,0,0-1.18-1.61,4.57,4.57,0,0,0-1.64-.87,6,6,0,0,0-3.35,0,4,4,0,0,0-2.24,1.64,6,6,0,0,0-.86,2.12,9,9,0,0,0-.21,1.67,9.46,9.46,0,0,0,0,1.05A1.55,1.55,0,0,1,310.48,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,348.8s0-.13,0-.36,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6,6,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.12,6.12,0,0,0-3.35,0,4.68,4.68,0,0,0-1.66.85,5.13,5.13,0,0,0-1.2,1.58,8.81,8.81,0,0,0-.72,4.29v0a6,6,0,0,0,2.14,4.3,8.47,8.47,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,4.93,4.93,0,0,0,2.38-1.6,10.71,10.71,0,0,0,1.9-5.83,24,24,0,0,0-.53-6.6,51.32,51.32,0,0,0-2.06-6.66c-1.55-4.51-3.15-9.18-4.8-14-2-6-4-11.85-5.85-17.4-1-2.74-1.83-5.61-1.47-8.45a13.93,13.93,0,0,1,1-4,7.08,7.08,0,0,1,2.6-3.07,7.41,7.41,0,0,1,3.74-1,10.68,10.68,0,0,1,3.66.52,6.34,6.34,0,0,1,2.89,2.05,7.13,7.13,0,0,1,1.28,3.09,8.51,8.51,0,0,1-.93,5.94,6,6,0,0,1-4.44,2.62h0a5.27,5.27,0,0,1-4.3-2.18,7.26,7.26,0,0,1-1-3.49,9.35,9.35,0,0,1,.3-3s0,.06,0,.19,0,.34-.07.57a13.18,13.18,0,0,0-.06,2.23,7.14,7.14,0,0,0,1,3.38,5,5,0,0,0,4.12,2h0a5.75,5.75,0,0,0,4.18-2.52,8.13,8.13,0,0,0,.83-5.69,6.59,6.59,0,0,0-1.22-2.92,5.86,5.86,0,0,0-2.71-1.89,10,10,0,0,0-3.51-.48,6.92,6.92,0,0,0-3.5,1A6.52,6.52,0,0,0,292,290a13.68,13.68,0,0,0-1,3.87c-.33,2.71.51,5.49,1.48,8.24,1.87,5.54,3.83,11.37,5.86,17.38,1.65,4.79,3.25,9.46,4.8,14a52.38,52.38,0,0,1,2.06,6.72,24.47,24.47,0,0,1,.51,6.74,11.08,11.08,0,0,1-2,6.08,5.35,5.35,0,0,1-2.6,1.73,8.05,8.05,0,0,1-3,.26,8.86,8.86,0,0,1-5.3-1.8,6.33,6.33,0,0,1-2.25-4.61v0a9,9,0,0,1,.79-4.47,5.41,5.41,0,0,1,1.3-1.68,5,5,0,0,1,1.77-.88,6.21,6.21,0,0,1,3.51.07,4.24,4.24,0,0,1,2.3,1.82,6.19,6.19,0,0,1,.81,2.2,9.41,9.41,0,0,1,.14,1.7,8.65,8.65,0,0,1-.05,1.05A1.31,1.31,0,0,1,301,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.7,418.15a2.43,2.43,0,0,1,0-.36c0-.23,0-.58,0-1a10.06,10.06,0,0,0-.21-1.68,6,6,0,0,0-.85-2.12,4,4,0,0,0-2.22-1.66,6,6,0,0,0-3.35,0,4.43,4.43,0,0,0-1.65.86,5,5,0,0,0-1.18,1.59,8.61,8.61,0,0,0-.69,4.3v0a6,6,0,0,0,2.18,4.28,8.4,8.4,0,0,0,5.08,1.63,8,8,0,0,0,2.84-.28,5,5,0,0,0,2.36-1.63,10.69,10.69,0,0,0,1.85-5.85,24,24,0,0,0-.58-6.59,51.5,51.5,0,0,0-2.12-6.64c-1.58-4.49-3.23-9.15-4.92-13.92l-6-17.34c-1-2.73-1.87-5.59-1.53-8.44a14.12,14.12,0,0,1,1-4,7,7,0,0,1,2.58-3.08,7.29,7.29,0,0,1,3.72-1.06,10.71,10.71,0,0,1,3.67.48,6.32,6.32,0,0,1,2.9,2,7.07,7.07,0,0,1,1.31,3.09,8.5,8.5,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.23,5.23,0,0,1-4.31-2.14,7.17,7.17,0,0,1-1-3.49,9.38,9.38,0,0,1,.27-3s0,.07,0,.19,0,.34-.07.57a14,14,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.14,2h0a5.84,5.84,0,0,0,4.17-2.55,8.16,8.16,0,0,0,.78-5.7,6.59,6.59,0,0,0-1.24-2.91,5.93,5.93,0,0,0-2.73-1.87,10.2,10.2,0,0,0-3.51-.44,7,7,0,0,0-3.5,1,6.57,6.57,0,0,0-2.39,2.9,13.38,13.38,0,0,0-.95,3.88c-.31,2.71.54,5.48,1.53,8.22l6,17.33c1.68,4.77,3.32,9.43,4.91,13.92a51,51,0,0,1,2.11,6.71,24.1,24.1,0,0,1,.58,6.73,11.21,11.21,0,0,1-2,6.1,5.52,5.52,0,0,1-2.59,1.76,8.51,8.51,0,0,1-3,.29,8.87,8.87,0,0,1-5.31-1.75,6.32,6.32,0,0,1-2.29-4.59v0a9,9,0,0,1,.75-4.48,5.36,5.36,0,0,1,1.28-1.68A4.82,4.82,0,0,1,294,411a6.19,6.19,0,0,1,3.5,0,4.2,4.2,0,0,1,2.32,1.79,6,6,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71,8.9,8.9,0,0,1-.05,1.05A1.12,1.12,0,0,1,300.7,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S321.77,426.09,321.63,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.94,426.09c-.14,0-.26-32.39-.26-72.34s.12-72.35.26-72.35.26,32.39.26,72.35S290.08,426.09,289.94,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,348.75a1.68,1.68,0,0,1-.06-.35,9.37,9.37,0,0,1,0-1,8.93,8.93,0,0,1,.17-1.71,6.06,6.06,0,0,1,.84-2.19,4.27,4.27,0,0,1,2.33-1.77,6.24,6.24,0,0,1,3.51,0,4.81,4.81,0,0,1,1.76.92,5.37,5.37,0,0,1,1.27,1.69,9.11,9.11,0,0,1,.72,4.48v0a6.29,6.29,0,0,1-2.31,4.57A8.82,8.82,0,0,1,281.6,355a8.54,8.54,0,0,1-3-.32,5.42,5.42,0,0,1-2.57-1.77,11.15,11.15,0,0,1-1.93-6.11,24.13,24.13,0,0,1,.61-6.73,52.5,52.5,0,0,1,2.15-6.69c1.61-4.48,3.28-9.13,5-13.89L288,302.23c1-2.73,1.88-5.5,1.58-8.22a13.44,13.44,0,0,0-.93-3.88,6.57,6.57,0,0,0-2.38-2.91,6.92,6.92,0,0,0-3.49-1,10.45,10.45,0,0,0-3.51.42,6,6,0,0,0-2.74,1.85,6.74,6.74,0,0,0-1.26,2.91,8.15,8.15,0,0,0,.75,5.7,5.84,5.84,0,0,0,4.15,2.58h0a5,5,0,0,0,4.15-1.95,7,7,0,0,0,1-3.36,14.15,14.15,0,0,0,0-2.23c0-.24-.05-.42-.07-.57s0-.19,0-.2a9.28,9.28,0,0,1,.26,3,7.26,7.26,0,0,1-1,3.47,5.21,5.21,0,0,1-4.33,2.11h0a6.12,6.12,0,0,1-4.41-2.68,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.33-3.08,6.25,6.25,0,0,1,2.91-2,10.7,10.7,0,0,1,3.67-.46,7.4,7.4,0,0,1,3.72,1.09,7.08,7.08,0,0,1,2.56,3.1,14,14,0,0,1,1,4c.32,2.85-.59,5.71-1.58,8.43-1.95,5.52-4,11.32-6.1,17.31l-5,13.88a52.67,52.67,0,0,0-2.15,6.63,24,24,0,0,0-.62,6.58,10.76,10.76,0,0,0,1.82,5.87,4.93,4.93,0,0,0,2.35,1.63,8,8,0,0,0,2.83.31,8.48,8.48,0,0,0,5.1-1.6,5.91,5.91,0,0,0,2.2-4.26v0a8.61,8.61,0,0,0-.66-4.3,5,5,0,0,0-1.17-1.6,4.68,4.68,0,0,0-1.64-.88,6.1,6.1,0,0,0-3.36,0,4,4,0,0,0-2.23,1.65,6,6,0,0,0-.86,2.11,10.08,10.08,0,0,0-.22,1.68c0,.46,0,.81,0,1A2.43,2.43,0,0,1,278.74,348.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,417.9a1.35,1.35,0,0,1-.06-.35,9.26,9.26,0,0,1,0-1.05,8.83,8.83,0,0,1,.17-1.7,6,6,0,0,1,.84-2.19,4.24,4.24,0,0,1,2.33-1.78,6.33,6.33,0,0,1,3.51,0,5,5,0,0,1,1.76.92,5.41,5.41,0,0,1,1.27,1.7,9.09,9.09,0,0,1,.72,4.48v0a6.3,6.3,0,0,1-2.31,4.57,8.88,8.88,0,0,1-5.33,1.71,8.3,8.3,0,0,1-3-.31A5.56,5.56,0,0,1,276,422.1a11.18,11.18,0,0,1-1.93-6.12,24.06,24.06,0,0,1,.61-6.72,52,52,0,0,1,2.15-6.69q2.42-6.74,5-13.89l6.11-17.3c1-2.73,1.88-5.49,1.58-8.21a13.5,13.5,0,0,0-.93-3.89,6.69,6.69,0,0,0-2.38-2.91,7,7,0,0,0-3.49-1,10,10,0,0,0-3.51.42,5.8,5.8,0,0,0-2.74,1.85,6.66,6.66,0,0,0-1.26,2.9,8.15,8.15,0,0,0,.75,5.7,5.85,5.85,0,0,0,4.15,2.59h0a5,5,0,0,0,4.15-2,7,7,0,0,0,1-3.36,14.2,14.2,0,0,0,0-2.23c0-.23-.05-.42-.07-.57s0-.19,0-.19a9.24,9.24,0,0,1,.26,3,7.29,7.29,0,0,1-1,3.48,5.24,5.24,0,0,1-4.33,2.11h0a6.13,6.13,0,0,1-4.41-2.69,8.5,8.5,0,0,1-.85-5.95,7,7,0,0,1,1.33-3.08,6.24,6.24,0,0,1,2.91-2,10.47,10.47,0,0,1,3.67-.46A7.38,7.38,0,0,1,286.5,356a7.08,7.08,0,0,1,2.56,3.1,14.07,14.07,0,0,1,1,4c.32,2.84-.59,5.7-1.58,8.43-1.95,5.52-4,11.32-6.1,17.3l-5,13.88a53.74,53.74,0,0,0-2.15,6.63,24,24,0,0,0-.62,6.59,10.72,10.72,0,0,0,1.82,5.86,5,5,0,0,0,2.35,1.64,8,8,0,0,0,2.83.3,8.48,8.48,0,0,0,5.1-1.59,6,6,0,0,0,2.2-4.26v0a8.61,8.61,0,0,0-.66-4.3,5.18,5.18,0,0,0-1.17-1.61,4.65,4.65,0,0,0-1.64-.87,6,6,0,0,0-3.36,0,4,4,0,0,0-2.23,1.64,6,6,0,0,0-.86,2.12,10.11,10.11,0,0,0-.22,1.67c0,.46,0,.81,0,1.05A2.31,2.31,0,0,1,278.74,417.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27,348.8a2.46,2.46,0,0,1,0-.36c0-.24,0-.59,0-1a9.67,9.67,0,0,0-.19-1.68,6.21,6.21,0,0,0-.83-2.13,4.06,4.06,0,0,0-2.21-1.69,6.16,6.16,0,0,0-3.36,0,4.72,4.72,0,0,0-1.65.85,5.13,5.13,0,0,0-1.2,1.58,8.81,8.81,0,0,0-.72,4.29v0a6,6,0,0,0,2.14,4.3,8.47,8.47,0,0,0,5.07,1.68,8,8,0,0,0,2.84-.25,5,5,0,0,0,2.38-1.6,10.71,10.71,0,0,0,1.89-5.83,24,24,0,0,0-.52-6.6,52.92,52.92,0,0,0-2.06-6.66c-1.55-4.51-3.16-9.18-4.8-14l-5.86-17.4c-.95-2.74-1.82-5.61-1.47-8.45a13.94,13.94,0,0,1,1-4,7,7,0,0,1,2.6-3.07,7.4,7.4,0,0,1,3.73-1,10.64,10.64,0,0,1,3.66.52,6.29,6.29,0,0,1,2.89,2.05,6.9,6.9,0,0,1,1.28,3.09,8.46,8.46,0,0,1-.92,5.94,6.07,6.07,0,0,1-4.45,2.62h0a5.27,5.27,0,0,1-4.3-2.18,7.26,7.26,0,0,1-1-3.49,9.35,9.35,0,0,1,.3-3s0,.06,0,.19,0,.34-.07.57a13.18,13.18,0,0,0-.06,2.23,7.11,7.11,0,0,0,1,3.38,5,5,0,0,0,4.13,2h0a5.79,5.79,0,0,0,4.19-2.52,8.18,8.18,0,0,0,.83-5.69,6.59,6.59,0,0,0-1.22-2.92,6,6,0,0,0-2.71-1.89,10,10,0,0,0-3.52-.48,6.94,6.94,0,0,0-3.5,1,6.44,6.44,0,0,0-2.41,2.88,13.35,13.35,0,0,0-1,3.87c-.33,2.71.51,5.49,1.47,8.24l5.87,17.38c1.64,4.79,3.24,9.46,4.79,14a52.38,52.38,0,0,1,2.06,6.72,24.1,24.1,0,0,1,.52,6.74,11.08,11.08,0,0,1-2,6.08,5.35,5.35,0,0,1-2.6,1.73,8.11,8.11,0,0,1-3,.26,8.89,8.89,0,0,1-5.3-1.8,6.36,6.36,0,0,1-2.24-4.61v0a8.94,8.94,0,0,1,.79-4.47,5.38,5.38,0,0,1,1.29-1.68,4.94,4.94,0,0,1,1.78-.88,6.22,6.22,0,0,1,3.51.07,4.26,4.26,0,0,1,2.29,1.82,5.83,5.83,0,0,1,.81,2.2,8.68,8.68,0,0,1,.15,1.7,8.21,8.21,0,0,1-.06,1.05A1.71,1.71,0,0,1,269.27,348.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,418.15a2.43,2.43,0,0,1,0-.36c0-.23,0-.58,0-1a9.92,9.92,0,0,0-.2-1.68,6,6,0,0,0-.85-2.12,4,4,0,0,0-2.22-1.66,6,6,0,0,0-3.36,0,4.51,4.51,0,0,0-1.65.86,5.12,5.12,0,0,0-1.18,1.59,8.72,8.72,0,0,0-.68,4.3v0a6,6,0,0,0,2.17,4.28,8.45,8.45,0,0,0,5.09,1.63,7.94,7.94,0,0,0,2.83-.28,5,5,0,0,0,2.37-1.63,10.77,10.77,0,0,0,1.85-5.85,23.63,23.63,0,0,0-.59-6.59,51.42,51.42,0,0,0-2.11-6.64c-1.59-4.49-3.23-9.15-4.92-13.92l-6-17.34c-1-2.73-1.87-5.59-1.54-8.44a13.81,13.81,0,0,1,1-4,6.94,6.94,0,0,1,2.58-3.08,7.26,7.26,0,0,1,3.72-1.06,10.62,10.62,0,0,1,3.66.48,6.35,6.35,0,0,1,2.91,2,7,7,0,0,1,1.3,3.09,8.44,8.44,0,0,1-.88,5.95,6.11,6.11,0,0,1-4.42,2.66h0a5.27,5.27,0,0,1-4.32-2.14,7.28,7.28,0,0,1-1-3.49,9.52,9.52,0,0,1,.28-3s0,.07,0,.19,0,.34-.07.57a12.65,12.65,0,0,0,0,2.23,7.12,7.12,0,0,0,1,3.37,5,5,0,0,0,4.15,2h0a5.8,5.8,0,0,0,4.16-2.55,8.16,8.16,0,0,0,.79-5.7,6.61,6.61,0,0,0-1.25-2.91,5.9,5.9,0,0,0-2.72-1.87,10.26,10.26,0,0,0-3.52-.44,6.88,6.88,0,0,0-3.49,1,6.57,6.57,0,0,0-2.39,2.9,13.39,13.39,0,0,0-1,3.88c-.31,2.71.55,5.48,1.54,8.22l6,17.33c1.69,4.77,3.33,9.43,4.91,13.92a52.6,52.6,0,0,1,2.12,6.71,24.09,24.09,0,0,1,.57,6.73,11.12,11.12,0,0,1-2,6.1,5.45,5.45,0,0,1-2.58,1.76,8.51,8.51,0,0,1-3,.29,8.93,8.93,0,0,1-5.32-1.75,6.36,6.36,0,0,1-2.29-4.59v0a9.1,9.1,0,0,1,.76-4.48,5.21,5.21,0,0,1,1.28-1.68,4.78,4.78,0,0,1,1.76-.91,6.23,6.23,0,0,1,3.51,0,4.24,4.24,0,0,1,2.32,1.79,6.22,6.22,0,0,1,.83,2.19,9.77,9.77,0,0,1,.16,1.71c0,.46,0,.81-.05,1.05A1.68,1.68,0,0,1,269,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.89,426.09c-.15,0-.26-32.39-.26-72.34s.11-72.35.26-72.35.26,32.39.26,72.35S290,426.09,289.89,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.2,426.09c-.15,0-.26-32.39-.26-72.34s.11-72.35.26-72.35.26,32.39.26,72.35S258.34,426.09,258.2,426.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,459.33H50a30.48,30.48,0,0,0,0-27.17H344.16A31.83,31.83,0,0,0,344.16,459.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.86,
    y: 429.36,
    width: 305.54,
    height: 8.89,
    rx: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,227s3.86,6.18,5.15,8.76S262,269.2,281.08,277.89c0,0-7.74-25.09-11.87-30S254.26,227.55,246,227Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,207.26s-2.52,21.12-1.11,33.9,8.63,34.27,11.84,36.61h2s1.6-20,1.23-26.5-1-14.3-2.09-19.48S272.77,209.24,269.93,207.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,205c-.26-.91-12.88,33.55-13.77,41.54s-3.27,31-3.27,31,6.38-1.87,11.27-11.2S302.58,216.94,299,205Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,227.44c-.42-.27-16.26,14.65-18.48,22s-11.71,28-11.71,28,12.55-.07,20-16.72A149.65,149.65,0,0,0,313.36,227.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,260.84c.14.42,6.35,1.93,10.58,7.52s21.4,9.53,21.4,9.53S271,265.51,266.31,263.37,249.1,260.84,249.1,260.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.05,264.88s-10,1.19-13.59,2.09A40.14,40.14,0,0,0,282,277.75s13.73-.26,19.92-4.31S314.05,264.88,314.05,264.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.07,276.94a35.11,35.11,0,0,1,12.31-8.35,32,32,0,0,1,6.66-1.8c2.7-.43,5.47-.43,8.11-1.16a.09.09,0,0,0,0-.18c-2.77.6-5.59.69-8.38,1.16a32.61,32.61,0,0,0-7.1,2.06A31.91,31.91,0,0,0,283,276.84c-.06.07,0,.17.1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.14,270.31a20,20,0,0,0,3.26,6c.08.1.23,0,.15-.15a20.56,20.56,0,0,1-3.3-5.84c0-.07-.14,0-.11,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.43,267.67a13.81,13.81,0,0,0,3.54,5.8c.06,0,.18,0,.12-.1a29,29,0,0,1-3.55-5.75c0-.06-.14,0-.11.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,267.56a14.07,14.07,0,0,0,2.77,5.36s.1,0,.07-.06a23,23,0,0,1-2.8-5.31s0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.35,266.37a11.37,11.37,0,0,0,1.71,3c.05.06.15,0,.11-.09-.59-1-1.18-1.94-1.7-3,0-.06-.15,0-.12.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,265.75a7,7,0,0,0,1,2.05c.06.06.15,0,.12-.09a22.65,22.65,0,0,1-1.09-2,0,0,0,1,0-.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.47,265.79c.2.38.4.76.62,1.13a.06.06,0,1,0,.1-.06c-.19-.39-.41-.76-.62-1.13,0-.07-.13,0-.1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77,277.37c3.29-1.64,5.61-4.79,7.31-7.95,1.6-3,3.09-6,4.44-9.13a54.57,54.57,0,0,0,4.38-19.09c0-.14-.21-.14-.22,0a59.38,59.38,0,0,1-4.36,19c-1.17,2.69-2.47,5.34-3.8,8a27.88,27.88,0,0,1-3.21,5.17,26.18,26.18,0,0,1-4.56,4s0,.05,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,277.72c1.62-3.21,1.56-7.2,1.8-10.71.31-4.37.4-8.75.3-13.12a.07.07,0,0,0-.14,0c0,4-.06,7.95-.29,11.93-.12,1.88-.26,3.77-.43,5.65a16.78,16.78,0,0,1-1.36,6.18c0,.08.08.15.12.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.11,262.3a83.27,83.27,0,0,0,8,8.28c2.77,2.54,5.5,5.25,8.81,7.12a.07.07,0,1,0,.08-.12,62.46,62.46,0,0,1-9.2-7.49,94.2,94.2,0,0,1-7.63-7.85s-.09,0-.05.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.31,250.42c2.64,1.44,5.19,3,7.83,4.46.07,0,.13-.07.06-.11a75.48,75.48,0,0,0-7.84-4.43c-.05,0-.1,0-.05.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92,240c2.66,1.43,5.34,2.83,8.05,4.16,0,0,.1-.06,0-.09-2.65-1.43-5.35-2.79-8.06-4.12,0,0-.07,0,0,.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,238.46c.3-.12,1.87.64,2.24.75l1.55.52a12.46,12.46,0,0,1,3.44,1.86c.05,0,.13-.05.07-.1a10.16,10.16,0,0,0-3.47-1.91c-.78-.28-1.58-.52-2.38-.76-.4-.13-1.06-.51-1.5-.39a0,0,0,0,0,0,0l0,0s0,0,.05,0h0s0-.07,0-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05,230a14.39,14.39,0,0,0,3.76.58,51.38,51.38,0,0,1,5.07.94.09.09,0,0,0,.05-.17c-2.93-.78-5.91-.82-8.86-1.43a0,0,0,0,0,0,.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.06,226.91c2.61.17,5.67-.25,8.17.61.09,0,.12-.11,0-.14a11.51,11.51,0,0,0-3.74-.47c-1.49,0-3-.12-4.47-.12-.07,0-.07.11,0,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "298.26 246.66 306.86 251.65 308.4 247.15 299.26 241.53 298.04 246.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,260.31c-.2-.21,7.15,3.61,7.15,3.61l1.25-2.45-7.26-3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.61 232.66 311.71 235.36 312.15 233.44 308.99 231.39 307.61 232.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,269.59l3.25,6.29s2.92-.93,3.73-1.32L296.32,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "301.25 266.89 304.16 271.93 305.17 271.24 302.54 266.74 301.46 266.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.39 263.92 291.78 265.79 293.58 261.78 283.8 258.76 283.39 263.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,249.94l12.25,1.71,1.3-7.55-12.37-1.58S285.1,247.84,284.87,249.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,223.59l8.23.79s.3-4,.05-4.19-6.87-.75-6.87-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,217.51c2.14,0,4.22-.16,6.22.75.11.05.2-.11.1-.16a12.46,12.46,0,0,0-6.32-.67c-.05,0-.05.08,0,.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.64,213.16a16.81,16.81,0,0,1,4.41.72,9.69,9.69,0,0,0-.34-1.6l-1.88-.39a1.7,1.7,0,0,0-1.5.17c-.28.27-.35.7-.61,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,233a65.59,65.59,0,0,1,10.07,1.4c.17,0,.24-.23.08-.26-3.39-.49-6.72-1.13-10.15-1.31a.09.09,0,0,0,0,.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.44,234.35c3.61.38,7.21.82,10.82,1.25.1,0,.1-.15,0-.16-3.6-.45-7.21-.81-10.82-1.15a0,0,0,0,0,0,.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,254.5c3.83.45,7.67.95,11.51,1.34.06,0,.06-.08,0-.09-3.84-.4-7.66-1-11.51-1.36-.07,0-.07.1,0,.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54,237.73l13.94-2.81a57.81,57.81,0,0,0-2.32-8.07l-11.75,3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,217.79c0,.13,6.48-1.65,6.48-1.65l-1.15-2.26-5.18,2-.15,1.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,253.89l11.59-4a28.2,28.2,0,0,1,0,7.58l-8.74,3.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,247.53c2.19-.7,4.32-1.6,6.47-2.41a40.86,40.86,0,0,0,5.66-2.29c.07,0,0-.14-.07-.11-3.9,1.88-8.12,3-12.09,4.74,0,0,0,.08,0,.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.54,243.68c4.43-.92,8.82-2.06,13.2-3.14a.16.16,0,0,0-.08-.3c-4.39,1.07-8.81,2.08-13.15,3.32a.06.06,0,1,0,0,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.88,251.2c4.17-1.84,8.39-3.59,12.48-5.62.07,0,0-.14,0-.12-4.19,1.78-8.3,3.79-12.47,5.64-.05,0,0,.13,0,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,226.2c3.14-.8,6.26-1.7,9.38-2.57a.12.12,0,0,0-.06-.24c-3.12.88-6.26,1.72-9.36,2.66a.08.08,0,1,0,0,.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.78,223.5a59.54,59.54,0,0,0,8.55-2.65c.06,0,0-.13,0-.1-2.82,1-5.66,1.86-8.54,2.69,0,0,0,.07,0,.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,213.47a12,12,0,0,0,3.86-1.73.09.09,0,0,0-.09-.15,38.27,38.27,0,0,1-3.8,1.74.07.07,0,0,0,0,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,265.51c2.31-.74,4.6-1.59,6.86-2.48.07,0,0-.16,0-.13-2.27.87-4.56,1.69-6.84,2.53-.05,0,0,.09,0,.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.07,269a46.37,46.37,0,0,0,6.17-2.51c.16-.07,0-.31-.14-.24-2,.95-4,1.76-6.08,2.59a.08.08,0,0,0,.05.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.95 235.36 255.1 231.86 253.42 230.48 250.11 233.84 250.95 235.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.16 243.35 255.77 247.09 264.32 241.79 260.89 237.73 254.16 243.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.39 247.09 259.6 254.82 263.07 260.67 272.23 254.44 269.89 248.82 268.39 247.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,253.09a41.33,41.33,0,0,0,8.38-7.55s0-.11-.06-.07c-1.35,1.32-2.66,2.68-4.05,3.95s-2.92,2.35-4.28,3.64a0,0,0,0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.48,250.11a49.49,49.49,0,0,0,8.56-6s0-.07-.05-.05a69.35,69.35,0,0,1-8.54,6s0,.07,0,.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,240.18c1.91-1.13,4.18-2.38,5.63-4.11.09-.1-.06-.26-.16-.15-1.56,1.71-3.7,2.76-5.54,4.14a.07.07,0,0,0,.07.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,237.89c1.53-1.41,3.15-2.66,4.78-3.94,0,0,0-.1-.05-.07a34.18,34.18,0,0,0-4.77,4s0,.06,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14,231.63c.37-.39.72-.79,1.12-1.15s.92-.72,1.4-1.08c0,0,0-.11,0-.08a7.71,7.71,0,0,0-2.52,2.27s0,.07,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94,264.06c2.59-2,5.18-3.88,7.92-5.62.11-.07,0-.25-.1-.18a72.56,72.56,0,0,0-7.9,5.69c-.05.05,0,.15.08.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44,267.08a35.5,35.5,0,0,0,6.13-5,0,0,0,0,0,0,0c-2,1.77-4,3.36-6.15,5-.05,0,0,.12.05.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,239.34c3.79.62,7.42,2.4,11.33,2.25a.08.08,0,0,0,0-.16c-3.94,0-7.47-1.72-11.32-2.2a.06.06,0,0,0,0,.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.16 261.18 253.4 262.96 255.81 264.55 257.25 261.39 254.16 261.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,262.4l-3,6.56a7.52,7.52,0,0,0,3,2.36l3.09-6.44-2.18-2.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.27,262c-.56,1.39-1.14,2.76-1.82,4.09,0,.06.05.11.08,0a33.69,33.69,0,0,0,1.87-4.1c0-.08-.1-.12-.13,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,272.93a31.71,31.71,0,0,0,2-5.19c0-.08-.1-.11-.13,0-.62,1.74-1.35,3.45-1.94,5.2,0,0,0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,273.53a11.17,11.17,0,0,0,1.88-3.66.05.05,0,1,0-.1,0,17.4,17.4,0,0,1-1.87,3.64s.05.1.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,270.93a16.13,16.13,0,0,0,3.85-2.91.14.14,0,0,0-.2-.2c-1.25,1-2.46,2-3.77,2.91a.12.12,0,0,0,.12.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.95,
    y: 272.65,
    width: 68.18,
    height: 5.84,
    rx: 2.82,
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,275.57l4.18,18.91a4.42,4.42,0,0,0,4.31,3.46h45.65a4.41,4.41,0,0,0,4.3-3.44l4.28-18.93Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "311.74 278.48 250.33 278.48 311.13 281.17 311.74 278.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.68,283.2c0,.15-13.28.26-29.66.26s-29.65-.11-29.65-.26,13.27-.26,29.65-.26S310.68,283.06,310.68,283.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,298.57a56.13,56.13,0,0,1-.26-7.58,56.34,56.34,0,0,1,.26-7.59A56.34,56.34,0,0,1,268,291,56.13,56.13,0,0,1,267.72,298.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.83,298.43a54.43,54.43,0,0,1-.26-7.59,54.23,54.23,0,0,1,.26-7.58,56.13,56.13,0,0,1,.26,7.58A56.34,56.34,0,0,1,293.83,298.43Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.7bafc279424e4a9ddc9bfb76f653422e.svg";
export { ForwardRef as ReactComponent };